export default [["en-us", {
  "annotations": {
    "filterResponse": {
      "orders": {
        "order1": "1st order {responseType}",
        "order10": "10th order {responseType}",
        "order2": "2nd order {responseType}",
        "order3": "3rd order {responseType}",
        "order4": "4th order {responseType}",
        "order5": "5th order {responseType}",
        "order6": "6th order {responseType}",
        "order7": "7th order {responseType}",
        "order8": "8th order {responseType}",
        "order9": "9th order {responseType}",
        "orderN": "{order}th order {responseType}"
      },
      "responseType": {
        "Bessel": "Bessel",
        "Butterworth": "Butterworth",
        "Butterworth Bessel": "Butterworth Bessel",
        "Chebyshev": "Chebyshev"
      },
      "responseValue": "{value} dB",
      "stages": "{count, plural, =1 {1 stage} other {# stages}}"
    },
    "magnitude": {
      "db-down": "{n} dB down",
      "gain": "Gain = {n} dB",
      "passband-region": "Passband region",
      "passband-ripple": "Passband ripple = {n} dB",
      "stopband-region": "Stopband region"
    }
  },
  "dialogs": {
    "algorithm-confirmation": {
      "decreasing-r2-advantages": "Decreasing R2 has the following advantages",
      "decreasing-r2-advantages-item-1": "Lower resistor noise from R2.",
      "decreasing-r2-advantages-item-2": "Lower current noise effect through R2.",
      "decreasing-r2-advantages-item-3": "Less chance of amplifier input capacitance affecting performance.",
      "expand": "expand",
      "hide": "hide",
      "increasing-r1-advantages": "Increasing R1 has the following advantages",
      "increasing-r1-advantages-item-1": "Smaller chance of source impedance affecting filter response.",
      "increasing-r1-advantages-item-2": "Higher input filter input impedance at high frequencies.",
      "increasing-r1-advantages-item-3": "Less loading on the amplifier output at high frequencies.",
      "introduction": "In November 2023 we updated Filter Wizard to calculate Sallen Key Lowpass components differently. All other stage types are unaffected. The change affects Sallen Key Lowpass stages with high R2/R1 ratios. High ratios negatively affect filter performance. We are reducing this ratio. This change will have little effect on the filter stage key specs: fp, Q, and gain. For some optimizations, you may see the stage order change, as our algorithm takes advantage of the better stage performance.",
      "new-algorithm-button": "Use new algorithm",
      "old-algorithm-button": "Use old algorithm",
      "post-script-new-design": "You may see a change in R1, R2, C1, and C2. All other components will be unaffected. All new designs will use the new method.",
      "post-script-save-design": "For this saved design, you can choose to continue to use the old algorithm or the new one. If you update to the new algorithm these components may be different than when you last saved.",
      "potential-drawbacks": "Potential drawbacks of this change",
      "potential-drawbacks-item-1": "C1/C2 was often a nice ratio of 10 with the old algorithm.",
      "potential-drawbacks-item-2": "Slight increase in noise gain.  We believe the reduction in R2 noise outweighs this disadvantage.",
      "potential-drawbacks-item-3": "For single supply configurations when gain > 1, decreased R2 requires the mid-supply driver to have lower output impedance.  We believe our AD8031 capacitor driving solution is well-equipped for this.",
      "pros-and-cons": "Pros and cons of reducing the R2/R1 ratio - click to",
      "title": "Change in Sallen Key Lowpass component calculations since you saved"
    },
    "common": {
      "cancel": "Cancel",
      "close": "Close",
      "ok": "OK",
      "open": "Open",
      "save": "Save",
      "select": "Select"
    },
    "connect-to": {
      "message-error": "Connection to {tool} failed",
      "title-error": "Connection Error"
    },
    "evaluation-boards": {
      "eval-board-column": "Eval Boards Needed",
      "eval-board-flagged": "Unable to Order Eval Board",
      "eval-board-flagged-after-incompatibles": "To order an evaluation board, please go back to the component selection tab and select parts that are compatible.",
      "eval-board-flagged-before-incompatibles": "In the component selection tab, you selected the following non-recommended op amps that are not compatible with the filter wizard evaluation board system: ",
      "eval-board-flagged-multi-feedback": "In the component selection tab, you selected a Multiple Feedback stage implementation for one or more of your circuit Stages.  Evaluation daughter boards are not yet available for Multiple Feedback circuit stages.",
      "eval-board-instruction": "In the page the Order button opens, click \"Buy Now\" to open the page where you can place items in the cart",
      "eval-board-multiple": "*Each daughterboard box we ship contains 4 individual stages, so it is not necessary to order them separately.",
      "eval-board-not-available-board": "Not available",
      "eval-board-parts-column": "Solder These Parts (Order Parts Separately)",
      "eval_board-flagged-inductor": "In the component selection tab, you selected an Inductor stage implementation for one or more of your circuit Stages.  Evaluation daughter boards are not yet available for inductor circuit stages.",
      "evalboard-confirmation": {
        "cancel-button-text": "Cancel",
        "message": "We apologize. The filter wizard evaluation board system does not have daughter boards for stages using inductors.",
        "proceed-button-text": "Look at eval boards anyway",
        "title": "Frequencies too high for eval board system"
      },
      "stage-column": "Stage",
      "stage-info": {
        "channel-dual": "-- Dual Op Amp",
        "channel-none": "",
        "channel-single": "-- Single Op Amp",
        "implementation-buffered-rc": "Buffered RC",
        "implementation-deliyannis-friend": "Multiple Feedback (Deliyannis Friend)",
        "implementation-first-order": "First Order",
        "implementation-gain": "Gain",
        "implementation-inductor": "Inductor",
        "implementation-multiple-feedback": "Multiple Feedback",
        "implementation-none": "",
        "implementation-sallen-key": "Sallen Key",
        "stage-text": "{stageType} {stageImplementation} Stage {stageChannel}",
        "stage-type-band-pass": "Band Pass",
        "stage-type-band-stop": "Band Stop",
        "stage-type-gain": "Gain",
        "stage-type-high-pass": "High Pass",
        "stage-type-low-pass": "Low Pass",
        "stage-type-none": "",
        "stage-type-notch": "Notch"
      },
      "stage-info-column": "Stage Information",
      "table-title": "Evaluation Boards Needed",
      "title": "Order Eval Board"
    },
    "feedback": {
      "email": "EMail: ",
      "feedback": "Your Feedback",
      "feedback-dialog-ng-message": "Failed to send user feedback. This may be due to a poor connection to the server. Please try again.",
      "feedback-dialog-ok-message": "Your feedback has been sent.",
      "give-feedback": "Tell us",
      "invitation": "Please let us know your opinion of this tool, good and bad.",
      "name": "Name: ",
      "optional": "(Optional)",
      "title": "Give us your feedback!"
    },
    "load": {
      "choose-button": "Choose File",
      "invalid-file": "Invalid design file. Please verify the contents of the design file you are trying to load.",
      "invalid-parts": "Unable to load design. The following {numParts, plural, =1 {part in this design file is} other {parts in this design file are}} no longer supported by this application: {parts}",
      "message": "Load a design from a file on your computer.",
      "no-opamps": "OpAmp data is unavailable. Unable to load design. Try to refresh your browser. If the problem persists, please use Filter Wizard's feedback button in the upper right to report the issue.",
      "title": "Load Design"
    },
    "opamp": {
      "table": {
        "architecture": "Architecture",
        "canOrderEvalBoard": "Eval Board?",
        "comment": "Comment",
        "comments": "Comments",
        "commentsDisplay": {
          "showAll": "Show All",
          "showNotAllowed": "Not Allowed",
          "showNotAllowedMatch": "not allowed",
          "showNotRecommended": "Not Recommended",
          "showNotRecommendedMatch": "not recommended",
          "showRecommended": "Recommended",
          "showRecommendedMatch": "recommended"
        },
        "feedbackMethod": "Feedback Method",
        "gbw": "GBW (Hz)",
        "iBias": "max iBias (A)",
        "iNoise": "iNoise",
        "inHeadroomMinus": "In Headroom- (V)",
        "inHeadroomPlus": "In Headroom+ (V)",
        "index": "Index",
        "isLTSpiceDisplay": {
          "showAll": "Show All",
          "showNo": "No",
          "showYes": "Yes"
        },
        "isLTSpiceOpAmp": "LTspice?",
        "maxSupplyVoltage": "vSupply Max (V)",
        "minStableGain": "Min Stable Gain",
        "minSupplyVoltage": "vSupply Min (V)",
        "numberChannels": "# Channels",
        "outHeadroomMinus": "Out Headroom- (V)",
        "outHeadroomPlus": "Out Headroom+ (V)",
        "packageCode": "Package Code",
        "partNumber": "Part Name",
        "price": "Price (US $)",
        "rOut": "rOut",
        "rawGBW": "Raw GBW",
        "selectable": "Selectable?",
        "slewRate": "Slew Rate",
        "specialOpAmp": "Special Op-Amp?",
        "status": "Status Code",
        "statusDisplay": {
          "showAll": "Show All",
          "showNotRecommended": "Not Recommended for New Designs",
          "showProduction": "Production",
          "showRecommended": "Recommended for New Designs"
        },
        "statusText": "Status",
        "supplyCurrent": "iSupply (A)",
        "tempRange": "Temperature Range",
        "tempRangeDisplay": {
          "showAll": "Show All",
          "showBlanks": "(Blank)"
        },
        "vNoise": "vNoise (nV/√Hz)",
        "vintage": "Vintage",
        "vos": "max Vos (V)"
      }
    },
    "samples": {
      "add-button": "Add Selected Samples to Cart",
      "add-to-cart-column": "Add Sample to Cart",
      "model-column": "Device Model/Package",
      "part-column": "Device Name",
      "quantities-warning": "Analog Devices offers a limited amount of free samples to qualified customers. Due to the large demand for our product samples we ask that you limit your sample request to 2 pieces per part with a maximum of 4 parts per request within a 14 day time period. Should your design needs require additional product quantities, you can purchase them on the web through Buy Online, or you can contact one of our authorized distributors.",
      "title": "Order Samples",
      "unavailable-message": "Not available for sample"
    },
    "save": {
      "save-desc-error": "Please provide a Description",
      "save-desc-field": "Description",
      "save-name-error": "Please provide a Design Name",
      "save-name-field": "Design Name",
      "title": "Save Design"
    },
    "send-filter": {
      "message": "You may now close this browser tab.",
      "message-error": "Sending design to {tool} was unsuccessful",
      "title-cancel": "{tool} has broken the connection",
      "title-error": "Send Design Error",
      "title-ok": "Filter Transfer to {tool} Complete"
    },
    "share": {
      "share-button": "Email",
      "share-design-information": "<p>To share a copy of your design, enter your name into the <b>Sender name</b> field. Then enter the email address of the recipients in the <b>Share design with</b> field.</p><p>The recipients will receive an email from Analog Devices with an attachment containing a ZIP archive of the shared design. All you have to do is extract the design from the ZIP file and upload it using the Load Design functionality of the application</p><p>This process creates a copy of the design for each recipient. If recipients choose to make edits on their copies, it will have no effect on your design you saved to your own computer.</p>",
      "share-dialog-ng-message": "Unable to share design. This is likely due to a server connection error. Please try again.",
      "share-dialog-ok-message": "Design has been shared",
      "share-duplicate-email": "Duplicate emails found",
      "share-email-empty-error": "Please enter an email address",
      "share-email-field": "Share design with",
      "share-email-format-error": "At least one of the email addresses you entered is invalid. Please correct and try again",
      "share-email-placeholder": "Email Address",
      "share-name-error": "Please provide a Design Name",
      "share-name-field": "Design Name",
      "share-sender-error": "Please provide a Sender Name",
      "share-sender-field": "Sender Name",
      "title": "Email My Design"
    },
    "system": {
      "application-busy": "Working...",
      "connecting-to": "Connecting to {tool}...",
      "download-create-bom": "Creating BOM File...",
      "download-create-data": "Creating Data Files...",
      "download-create-design": "Creating Design File...",
      "download-create-eval-board": "Creating Eval Board File...",
      "download-create-graph": "Creating Graph Data...",
      "download-create-pdf": "Creating PDF File...",
      "download-create-spice": "Creating SPICE Files...",
      "download-downloading": "Downloading...",
      "download-requesting": "Requesting...",
      "error-opamp-data": "OpAmp data is unavailable. Filter Wizard is unable to proceed. Save your design and try to refresh your browser. If the problem persists, please use Filter Wizard's feedback button in the upper right to report the issue.",
      "error-pst-data": "Data map is temporarily unavailable, and hence the OpAmp table cannot be displayed. Save your design and try to refresh your browser. If the problem persists, please use Filter Wizard's feedback button in the upper right to report the issue.",
      "loading-opamp-data": "Loading OpAmp data...",
      "sending-filter": "Sending filter to {tool}...",
      "title": "Application Message"
    },
    "video": {
      "active_filter": {
        "title": "Filtering 101: Active Filter Stage Order",
        "url": "{basedir}/en/resources/media-center/videos/3637489700001.html"
      },
      "active_passive": {
        "title": "Filtering 101: Active vs. Passive",
        "url": "{basedir}/en/resources/media-center/videos/3637523715001.html"
      },
      "analog_digital": {
        "title": "Filtering 101: Analog vs. Digital",
        "url": "{basedir}/en/resources/media-center/videos/3637489722001.html"
      },
      "chebyshev_butterworth_bessel": {
        "title": "Filtering 101: Chebyshev vs. Butterworth vs. Bessel",
        "url": "{basedir}/en/resources/media-center/videos/3637489717001.html"
      },
      "gain_attenuation": {
        "title": "Sallen Key 101: Gain and Attenuation",
        "url": "{basedir}/en/resources/media-center/videos/3637489691001.html"
      },
      "heading": "Click on links below to see explanatory video",
      "opamp_output_impedance": {
        "title": "Sallen Key 101: Effect of Op Amp Output Impedance",
        "url": "{basedir}/en/resources/media-center/videos/3637495042001.html"
      },
      "picking_components": {
        "title": "Sallen Key 101: Picking Components",
        "url": "{basedir}/en/resources/media-center/videos/3637437921001.html"
      },
      "quality_factor": {
        "title": "Filtering 101: Q - The Quality Factor of a Filter",
        "url": "{basedir}/en/resources/media-center/videos/3637489712001.html"
      },
      "sallenkey_feedback": {
        "title": "Filtering 101: Sallen Key vs. Multiple Feedback",
        "url": "{basedir}/en/resources/media-center/videos/3637489704001.html"
      },
      "subtitle": "Tutorial videos on Filter Design",
      "title": "Videos"
    }
  },
  "download": {
    "error-message": "<p>Unable to get design files. This error may occur for the following reasons:</p><p>1) Broken connection to the server.</p><p>2) Services are down.</p>",
    "error-title": "Download",
    "file-content": {
      "no-schematic": "Now that LTspice is part of Analog Devices, we are converting our SPICE netlists into LTspice models.  The op amps in your design do not currently have LTspice models available.  If you would like ADI to prioritize LTspice model generation for a particular part, please let your sales representative know or send feedback through this tool.\r\n\r\nSPICE simulation supported by parts in your design:\r\n",
      "no-schematic-no-netlist": "ADI is currently in the process of transitioning our op amps from SPICE netlists to LTspice models.  Your design contains a mixture of parts, where some have text based netlists and some have LTspice files.  Because of this, the tool is not able to generate any SPICE output.  We apologize for the inconvenience and are working on getting this fixed.  If you would like ADI to prioritize LTspice model generation for a particular part, please let your sales representative know or send feedback through this tool.\r\n\r\nSPICE simulation supported by parts in your design:\r\n",
      "part-no-spice-info": "The following op amps in your design do not have LTspice models or text netlist models. If you would like ADI to prioritize LTspice model generation for a particular part, please let your sales representative know or send feedback through this tool."
    },
    "pdf-content": {
      "image-headers": {
        "circuit": "Circuit",
        "group-delay": "Group Delay",
        "input-impedance-mag": "Input Impedance Magnitude",
        "input-impedance-phase": "Input Impedance Phase",
        "magnitude-db": "Magnitude(dB)",
        "magnitude-vv": "Magnitude(Volts per Volt)",
        "noise": "Noise",
        "phase-degrees": "Phase(degrees)",
        "phase-delay": "Phase Delay",
        "phase-radians": "Phase(radians)",
        "stages": "Stages",
        "step-response": "Step Response"
      },
      "pdf-data-ie-image-missing": "We are very sorry, but we are unable to generate images if you are using Internet Explorer 8 or below to browse this tool. Please use Firefox, Chrome, or Internet Explorer 9 or above if you would like to see the image on this page.",
      "pdf-desc": "{desc}\n\nCreated by {user} on {date}",
      "pdf-desc-no-design-name": "Created by {user} on {date}",
      "pdf-desc-no-name-desc": "Created on {date}",
      "pdf-desc-no-user-name": "{desc}\n\nCreated on {date}",
      "pdf-heading": "Filter Wizard Design Report",
      "pdf-orders": {
        "order1": "1st order",
        "order10": "10th order",
        "order11": "11th order",
        "order12": "12th order",
        "order2": "2nd order",
        "order3": "3rd order",
        "order4": "4th order",
        "order5": "5th order",
        "order6": "6th order",
        "order7": "7th order",
        "order8": "8th order",
        "order9": "9th order"
      },
      "pdf-subheading": "Filter Requirements for {filterType}, {nthOrder} {filterResponse}",
      "pdf-tool-name": "Filter Wizard"
    }
  },
  "ember-aditools-page": {
    "card": {
      "checkbox-tooltip": "Toggle",
      "help-tooltip": "Click for help",
      "part-number-tooltip": "Click to select part"
    },
    "common": {
      "cancel": "Cancel",
      "close": "Close",
      "load": "Load",
      "ok": "OK",
      "open": "Open",
      "save": "Save",
      "select": "Select"
    },
    "dialogs": {
      "feedback": {
        "email": "EMail: ",
        "feedback": "Your Feedback",
        "give-feedback": "Tell us",
        "invitation": "Please let us know your opinion of this tool, good and bad.",
        "name": "Name: ",
        "optional": "(Optional)",
        "title": "Give us your feedback!"
      },
      "load": {
        "choose-button": "Choose File",
        "message": "Load a design from a file on your computer.",
        "no-file-selected": "No file selected.",
        "title": "Load Design"
      },
      "samples": {
        "add-button": "Add Selected Samples to Cart",
        "add-link": "Add to Order",
        "add-to-cart-column": "Add Sample to Cart",
        "model-column": "Device Model/Package",
        "part-column": "Device Name",
        "quantities-warning": "Analog Devices offers a limited amount of free samples to qualified customers. Due to the large demand for our product samples we ask that you limit your sample request to 2 pieces per part with a maximum of 4 parts per request within a 14 day time period. Should your design needs require additional product quantities, you can purchase them on the web through Buy Online, or you can contact one of our authorized distributors.",
        "title": "Order Samples",
        "unavailable-message": "Not available for sample"
      },
      "save": {
        "save-desc-error": "Please provide a Description",
        "save-desc-field": "Description",
        "save-name-error": "Please provide a Design Name",
        "save-name-field": "Design Name",
        "title": "Save Design"
      },
      "share": {
        "share-button": "Email",
        "share-design-information": "<p>To share a copy of your design, enter your name into the <b>Sender name</b> field. Then enter the email address of the recipients in the <b>Share design with</b> field.</p><p>The recipients will receive an email from Analog Devices with an attachment containing a ZIP archive of the shared design. All you have to do is extract the design from the ZIP file and upload it using the Load Design functionality of the application</p><p>This process creates a copy of the design for each recipient. If recipients choose to make edits on their copies, it will have no effect on your design you saved to your own computer.</p>",
        "share-dialog-ng-message": "Unable to share design. This is likely due to a server connection error. Please try again.",
        "share-dialog-ok-message": "Design has been shared",
        "share-duplicate-email": "Duplicate emails found",
        "share-email-empty-error": "Please enter an email address",
        "share-email-field": "Share design with",
        "share-email-format-error": "At least one of the email addresses you entered is invalid. Please correct and try again",
        "share-email-placeholder": "Email Address",
        "share-name-error": "Please provide a Design Name",
        "share-name-field": "Design Name",
        "share-sender-error": "Please provide a Sender Name",
        "share-sender-field": "Sender Name",
        "title": "Share My Design"
      },
      "system": {
        "application-busy": "Working...",
        "title": "Application Message"
      }
    },
    "footer": {
      "accessibility": "Accessibility",
      "cookie-settings": "Cookie Settings",
      "copyright-text": "1995 - 2025 Analog Devices, Inc. All Rights Reserved",
      "icp-id": "",
      "legal": "Legal and Risk",
      "privacy-policy": "Privacy Policy",
      "privacy-settings": "Privacy Settings",
      "sitemap": "Sitemap"
    },
    "header": {
      "applications": "Applications",
      "company": "Company",
      "design-center": "Design Center",
      "education": "Education",
      "parametric-search": "Parametric Search",
      "products": "Products",
      "spoken": {
        "homepage": "ADI Home Page",
        "sitelinks": "ADI Site Links"
      },
      "support": "Support"
    },
    "menubar": {
      "chinese": "简体中文",
      "english": "English",
      "help": "Help",
      "japanese": "日本語",
      "load": "Load Design",
      "save": "Save"
    },
    "studio": {
      "adcdriver": "ADC Driver",
      "dacebc": "DAC",
      "diamond": "In Amp",
      "filterwizard": "Analog Filter",
      "noise": "Noise",
      "photodiode": "Photodiode",
      "precisionstudio": "ADI<span class=''service-mark''>℠</span> Precision Studio",
      "signalchaindesigner": "Signal Chain",
      "simdds": "DDS",
      "spoken": {
        "studiolinks": "ADI Precision Studio Links"
      },
      "virteval": "Virtual Eval"
    },
    "toolbar": {
      "actions": "Actions"
    }
  },
  "figures": {
    "billOfMaterials": {
      "bom-designator": "Reference Designator",
      "bom-material": "Material",
      "bom-package": "Package",
      "bom-quantity": "Quantity",
      "bom-text": "Click on Get Files->All Files to download a zip file that includes a Bill of Materials in tab delimited format.",
      "bom-text-italic": "Components in italics can be omitted if you are creating your own PCB rather than using ADI's evaluation board.",
      "bom-tolerance": "Tolerance",
      "bom-value": "Value",
      "extra-components": {
        "header": "header",
        "jumper": "jumper",
        "sma-jack": "SMA Jack, board edge female",
        "sma-male": "male-male SMA",
        "socket": "socket",
        "test-pin": "Test pin"
      },
      "materials": {
        "tantalum": "tantalum"
      },
      "title": "Bill of Materials",
      "x-axis": "",
      "y-axis": ""
    },
    "circuit": {
      "filter-type": {
        "band-pass": "Band-Pass",
        "high-pass": "High-Pass",
        "low-pass": "Low-Pass"
      },
      "implementation": {
        "first-order": "Buffered RC",
        "gain": "Gain",
        "inductor": "Inductor",
        "multiple-feedback": "Multiple Feedback",
        "sallen-key": "Sallen Key"
      },
      "order": {
        "eighth_order": "8th order",
        "fifth_order": "5th order",
        "first_order": "1st order",
        "fourth_order": "4th order",
        "nineth_order": "9th order",
        "second_order": "2nd order",
        "seventh_order": "7th order",
        "sixth_order": "6th order",
        "tenth_order": "10th order",
        "third_order": "3rd order"
      },
      "stage": "Stage {letter}",
      "title": "Circuit",
      "x-axis": "",
      "y-axis": ""
    },
    "errors": {
      "adcBandwidthIsLessThanMinimum": "The ADC bandwidth value (currently {value}Hz) must be at least {minimum}Hz",
      "centerFrequencyNotInRange": "The center frequency must be between {minimum}Hz and {maximum}Hz",
      "centerFrequencyTooHigh": "Ratio of center frequency to passband frequency is too high. Please decrease center frequency or increase passband frequency.",
      "centerFrequencyTooLow": "Ratio of center frequency to passband frequency is too low. Please increase center frequency or decrease passband frequency.",
      "emptyField": "The {fieldId} field cannot be empty.",
      "frequencyTooHigh": "Unable to find realistic component values. Your Q values may be too high. Use the stages view in the specifications screen to monitor your Q values. Things to try: (1) Use a Butterworth or Bessel rather than a Chebyshev filter response. (2) Use a slower transition from passband to stopband.",
      "frequencyTooLow": "Frequency too low. Unable to find component values.",
      "gainNotInRange": "The gain must be between {minimum} {unit} and {maximum} {unit}",
      "highOrderFiltersUnsupported": "No filter solution found with order ≤ 10. Decrease passband frequency or stopband attenuation, increase stopband frequency or passband attenuation, or adjust filter response.",
      "invalidField": "The value \"{value}\" in field {fieldId} cannot be parsed.",
      "noOpAmpFoundForRequirements": "No Op Amp found that meets requirements.",
      "noOpAmpFoundForRequirementsWithVoltage": "No Op Amp found that meets requirements. Setting +Vs to 5V and -Vs to 0V or -5V may yield better results.",
      "passbandAttenuationHighBandGreaterThan": "As the passband frequency approaches the maximum limit of {frequency}Hz, the passband attenuation becomes more restricted. At the stated passband frequency, the attenuation must be greater than {minimum} dB.",
      "passbandAttenuationLowGreaterThan": "As the passband frequency approaches the minimum limit of {frequency}Hz, the passband attenuation becomes more restricted. At the stated passband frequency, the attenuation must be greater than {minimum} dB.",
      "passbandAttenuationNotInRange": "The passband attenuation must be between {minimum} dB and {maximum} dB",
      "passbandFrequencyNotInRange": "The passband frequency must be between {minimum}Hz and {maximum}Hz",
      "passbandIsGreaterThanStopband": "The passband frequency (currently {passbandFrequency}Hz) must be less than the stopband frequency {stopbandFrequency}Hz",
      "referenceVoltageSpanGreaterThanMax": " Supply Voltage Span is too large for the AD8031 in the reference stage. Options: (1) Decrease supply voltage, (2) Switch to dual supply",
      "referenceVoltageSpanLessThanMinimum": "Supply Voltage Span is too small for the AD8031 in the reference stage. Options: (1) Increase supply voltage, (2) Switch to dual supply",
      "selectedOpAmpIsIdeal": "Stage {stage}: Please select an op-amp for this stage.",
      "selectedOpAmpIsIncompatible": "Stage {stage}: {opAmp} unable to meet the filter requirements. Please choose a different op-amp, or adjust your component sizes.",
      "selectedOpAmpIsIncompatibleWithVoltage": "Stage {stage}: {opAmp} unable to meet the filter requirements. Please choose a different op-amp, adjust your component sizes, or change your voltage supplies.",
      "stageQTooLarge": "The filter you specified has a stage with a Q of {qValue}. The filter wizard only supports stages with Qs less than 50. Options: (1) Decrease center frequency, (2) Increase stopband and passband frequency.",
      "stopbandAttenuationNotInRange": "The stopband attenuation must be between {minimum} dB and {maximum} dB",
      "stopbandFrequencyNotInRange": "The stopband frequency must be between {minimum}Hz and {maximum}Hz",
      "stopbandIsGreaterThanPassband": "The stopband frequency (currently {stopbandFrequency}Hz) must be less than the passband frequency {passbandFrequency}Hz",
      "stopbandIsGreaterThanPassbandAttenuation": "The stopband attenuation (currently {stopbandAttenuation} dB) must be deeper than the passband attenuation {passbandAttenuation} dB",
      "voltageSpanGreaterThanMax": " Voltage Span is too large. Difference between supplies should be no more than 36V",
      "voltageSpanLessThanMinimum": "Supply Voltage Span is too small. Difference between supplies should be at least 1.8V",
      "vsMinusShouldBeNegative": "-Vs voltage is too large. It should be 0V or less.",
      "vsMinusZeroVsPlusGreaterThanMax": "+Vs voltage must be less than 12.6V when -Vs = 0. The filter wizard always uses the AD8031 in its single supply reference circuit. This part has a max voltage supply of 12.6V.",
      "vsPlusShouldBePositive": "+Vs voltage is too small. It should be 0V or more."
    },
    "groupDelay": {
      "title": "Group Delay",
      "x-axis": "Frequency (Hz)",
      "x-hover": "Frequency:",
      "y-axis": "Group Delay (s)",
      "y-hover": "Group Delay:"
    },
    "inputImpedanceMagnitude": {
      "title": "Input Impedance (Ω)",
      "x-axis": "Frequency (Hz)",
      "x-hover": "Frequency:",
      "y-axis": "Input Impedance (Ω)",
      "y-hover": "Impedance:"
    },
    "inputImpedancePhase": {
      "title": "Input Impedance (°)",
      "x-axis": "Frequency (Hz)",
      "x-hover": "Frequency:",
      "y-axis": "Input Impedance (°)",
      "y-hover": "Impedance:"
    },
    "magnitudeDb": {
      "title": "Magnitude (dB)",
      "x-axis": "Frequency (Hz)",
      "x-hover": "Frequency:",
      "y-axis": "Magnitude (dB)",
      "y-hover": "Magnitude:"
    },
    "magnitudeVV": {
      "title": "Magnitude (V/V)",
      "x-axis": "Frequency (Hz)",
      "x-hover": "Frequency:",
      "y-axis": "Magnitude (V/V)",
      "y-hover": "Magnitude:"
    },
    "noise": {
      "adc-bandwidth": "ADC Bandwidth",
      "adc-input-range": "ADC input range",
      "adc-range": "ADC range",
      "adc-table-title": "ADC Table",
      "enob-comp-sel": "Equivalent # of Bits",
      "enob-comp-tol": "ENOB (bits)",
      "enob-nominal": "Nominal",
      "enob-worst": "Worst",
      "graph-title": "Spectral Noise Density",
      "noise-referred-filter-output-1": "All noise referred to filter output.",
      "noise-referred-filter-output-2": "1/f noise not modeled.",
      "nominal-label": "nominal",
      "peak-to-peak-title": "Peak to Peak",
      "rms-peak-to-peak": "RMS & Peak to Peak",
      "rms-title": "RMS",
      "title": "Noise",
      "worst-case-label": "worst case",
      "x-axis": "Frequency (Hz)",
      "x-hover": "Frequency:",
      "y-axis": "Spectral Noise Density (V/√Hz)",
      "y-hover": "Noise:"
    },
    "phaseDegrees": {
      "title": "Phase (°)",
      "x-axis": "Frequency (Hz)",
      "x-hover": "Frequency:",
      "y-axis": "Phase (°)",
      "y-hover": "Phase:"
    },
    "phaseDelay": {
      "title": "Phase Delay",
      "x-axis": "Frequency (Hz)",
      "x-hover": "Frequency:",
      "y-axis": "Phase Delay (s)",
      "y-hover": "Phase Delay:"
    },
    "phaseRadians": {
      "title": "Phase (rad)",
      "x-axis": "Frequency (Hz)",
      "x-hover": "Frequency:",
      "y-axis": "Phase (rad)",
      "y-hover": "Phase:"
    },
    "power": {
      "header-text": "Note: This page shows the quiescient power consumption of the filter. The input signal can have a significant impact on power consumption, which is not modeled here.",
      "order-with": {
        "order1": "1st order with",
        "order2": "2nd order with"
      },
      "reference-stage-part-with": "with AD8031",
      "reference-stage-text": "Reference Stage",
      "reference-whats-this": "What's This?",
      "title": "Power",
      "total-power": "Total quiescient power",
      "x-axis": "",
      "y-axis": ""
    },
    "stages": {
      "filter-types": {
        "type-name-band-pass": "Band-Pass",
        "type-name-high-pass": "High-Pass",
        "type-name-low-pass": "Low-Pass"
      },
      "header-text": "Your filter requires {n} op amp stage(s) with the following characteristics",
      "implementations": {
        "buffered-rc": "Buffered RC",
        "gain": "Gain",
        "inductor": "Inductor",
        "multiple-feedback": "Multiple<br/>Feedback",
        "sallen-key": "Sallen Key"
      },
      "orders": {
        "first-order": "1st order",
        "second-order": "2nd order"
      },
      "simulated": "Simulated",
      "simulated-to": " to {value}",
      "target": "Target",
      "title": "Stages",
      "tooltip": {
        "fp": "Pole frequency of the stage. Also known as cutoff frequency, natural frequency, or fundamental frequency.",
        "gain": "Gain (V/V): Gain of the stage",
        "q": "Q indicates how much peaking the stage has. Higher numbers indicate a higher peak near the pole frequency."
      },
      "x-axis": "",
      "y-axis": ""
    },
    "stepResponse": {
      "title": "Step Response",
      "x-axis": "Time (s)",
      "x-hover": "Time:",
      "y-axis": "Amplitude (V/V)",
      "y-hover": "Amplitude:"
    },
    "voltageRange": {
      "amp-input-range": "Input Range",
      "amp-output-range": "Output Range",
      "amplifier": "Amplifier",
      "amplifier_specs": "Amplifier Specs",
      "input-range": "Input Signal",
      "max-signals": "Max Signals",
      "max-signals-nominal": "Nominal",
      "max-signals-worst-case": "Worst Case",
      "maximum-input": "Maximum Input",
      "output-range": "Output Signal",
      "signal-possible": "Possible",
      "slew-rate": "Slew Rate",
      "title": "Voltage Range",
      "warning-input-range-voltage-range": "The Input Range of this stage limits the signal range.",
      "warning-output-range-voltage-range": "The Output Range of this stage limits the signal range.",
      "warning-slew-rate_voltage-range": "The Slew Rate of this stage limits the signal range.",
      "x-axis": "",
      "y-axis": ""
    }
  },
  "footer": {
    "copyright": "© 1995 - 2018 Analog Devices, Inc. All Rights Reserved ",
    "privacy-security": "Privacy & Security",
    "privacy-security-url": "/en/about-adi/landing-pages/001/privacy_security_statement.html",
    "privacy-settings": "Privacy Settings",
    "privacy-settings-url": "/en/landing-pages/001/privacy-settings.html",
    "sitemap": "Sitemap",
    "sitemap-url": "/en/sitemap.html",
    "terms-of-use": "Terms of use",
    "terms-of-use-url": "/en/about-adi/landing-pages/001/terms_of_use.html"
  },
  "fragments": {
    "at": "@",
    "eq": "=",
    "f": "f",
    "in": "IN",
    "left": "◄----",
    "n-a": "N/A",
    "out": "OUT",
    "p": "p",
    "plus": "+",
    "q": "Q",
    "r": "R",
    "ref": "REF",
    "right": "---►",
    "times": "×",
    "to": "to"
  },
  "header": {
    "applications": "Applications",
    "community": "Community",
    "design-center": "Design Center",
    "education": "Education",
    "parametric-search": "Parametric Search",
    "products": "Products",
    "support": "Support",
    "title": "Analog Filter Wizard"
  },
  "help": {
    "common": {
      "noise": {
        "adc-bandwidth": {
          "message": "<p>Enter the bandwidth of your ADC here.  We combine this value with the noise from the spectral density plot to calculate the rms and peak to peak noise.</p><p>We integrate the noise in the spectral density plot over the ADC bandwidth to create both the rms and peak and peak noise. If you look closely at the spectral density plot, the spectral density at the highest frequency is a non-zero number, and in reality continues at frequencies higher than this graph shows. The ADC acts as a filter to remove this residual high frequency noise.  <p>We model the ADC as a first order filter. We create a first order magnitude plot of the ADC roll off, multiply it by the spectral density plot, and then integrate the result. If you have an ADC with a sharper roll-off (for example a sinc^3 sigma delta), this tool may slightly overestimate the filter noise.</p><p>Some ADC's require an RC filter between the amplifier driver and the ADC. If this RC filter has a lower bandwidth than the ADC itself (or you don't know the ADC bandwidth), use the frequency cutoff of this RC filter instead. Frequency cutoff of an RC filter is 1/(2πRC).</p>",
          "title": "ADC Bandwidth",
          "tooltip": "Click for help"
        }
      },
      "power": {
        "message": "<p>The filter tool adds a reference stage whenever &ndash;Vs = 0.   This reference stage creates a mid-supply voltage rail that functions as the reference voltage for the filter circuits.</p><p>The reference stage includes an AD8031 op amp driving a 10 &mu;F capacitance.   Driving a capacitance directly with an op amp is typically a very bad idea.  However the architecture of the AD8031 ensures this configuration is stable, as long as the capacitance being driven is large enough.   The advantage of this circuit is that it provides a low frequency source impedance across the entire frequency spectrum.   Because the filter circuits can source and sink considerable amounts of current into the reference, a low source impedance reference is important for the best filter performance.     To keep this reference circuit stable, please ensure the following:</p><ul><li>Use the AD8031.  The stability of the circuit depends of the properties of this specific op amp.</li><li>The capacitance the AD8031 drives should be at least 10 &mu;F.  Any number of bypass capacitors can be placed in parallel with this capacitance.</li><li>No resistance should be placed between the AD8031 output and the capacitor(s).</li></ul><p>In the tool we show the reference voltage being derived with a voltage divider directly off the positive supply rail.   However this voltage could also be generated from a voltage reference IC such as an ADR4520 or ADR3420.   Footprints for these reference IC's are included on the evaluation board for your convenience.</p><p>Because the AD8031 is a high speed amplifier, it consumes a relatively large amount of power.   In a low power design, this reference circuit can dominate the power budget.  Here a few other techiques that can be used in place of the reference circuit we show in the filter wizard:<ul><li> Level shift the signal before the filter and use low pass filter stages without gain </li><li> Use voltage dividers instead of resistors connected to a reference voltage.  For example, if the designs calls for a 10 k&Omega; resistor connected to a mid-scale voltage reference, use a voltage divider between the two supplies consisting of 2 20 k&Omega; resistors instead.   Of course voltage dividers consume power themselves, so this technique only saves power when the resistors connected to the reference voltage in the original filter design have high values. </li><li> Use a low power voltage follower to generate the reference voltage.   Do not connect capacitors between the reference voltage and ground.   This technique works if the output impedance of the voltage follower is small compared to the rest of the resistors in the filter in the frequency range of interest.   Unfortunately, as a general rule, the lower the power of an op amp, the higher its output resistance at a particular frequency. </li> </ul><p>The tool shows that the reference voltage is derived directly from the positive supply voltage using a voltage divider, but this voltage can also be generated from a voltage reference IC like the ADR4520 or ADR3420. The reference IC footprint is included on the evaluation board for convenience.</p>",
        "title": "Reference Stage",
        "tooltip": "Click for help"
      },
      "voltage-range": {
        "message": "The input voltage range of an active filter, and corresponding output voltage range, are limited by the non-ideal characteristics of the op amps.  The \"Voltage Range\" view shows the calculated maximum input range, and highlights which op amp specification caused that limitation.<ul><li>The \"Maximum Input Signal Possible\" is the largest input voltage allowed - using a larger input signal will result in clipping or distortion. </li><li>The \"Amplifier Specs\" section shows the specifications for the selected op  amp in each stage. </li><li>The \"Max Signals\" section shows the results of calculations to determine the maximum allowable input voltage.  The op amp stage and specification that limits the input signal voltage is indicated with a warning icon.  The other values in the \"Max Signals\" section are calculated to ensure that the limiting parameter is never exceeded - in other words, to ensure no clipping or distortion through the entire filter path. </li><li>In the \"Component Tolerances\" tab, there are values for nominal and worst case.  Nominal assumes the nominal component values shown in the schematic.  Worst case calculates with passive values at the edge of their tolerance ranges, which may result in a larger gain transfer function, requiring further reduction in input signal.  See the \"Magnitude\" plot views in the \"Component Tolerances\" tab for an illustration of the uncertainly in the gain transfer function as a result of component tolerances. </li></ul><p><b>Slew Rate Limited: </b>If the slew rate of one of the op amps is the limiting specification for filter input voltage range,  the input signal voltage is reduced to a level that doesn't slew faster than the op amp is capable of.  See \"Slew Rate and Full-Power Bandwidth\" section of  mini-tutorial <a href=''{siteURL}/MT-045'' target=''_blank''>MT-045: Op Amp Bandwidth and Bandwidth Flatness </a>for more information.</p><p><b>Output Voltage Range Limited: </b>If the output voltage range of one of the op amps is the limiting specification for the filter input voltage range, the input signal voltage is reduced to a level that doesn't overdrive the op amp outputs.</p><p><b>Input Voltage Range Limited: </b>If the input voltage range of one of the op amps is the limiting specification for the filter input voltage range, the input signal voltage is reduced to a level that doesn't overdrive the op amp inputs.</p>",
        "title": "Voltage Range",
        "tooltip": "Click for help"
      }
    },
    "comp-select": {
      "choosing-components": {
        "message": "<p>Now that you have chosen the theoretical performance of the filter in the specifications screen, it is time to pick actual components. As you change components, you can see the changes in the circuit view.   If you change to other views, you can see if the component choices affect the filter performance.</p><p>The software supports two different ways of picking components</p><p><b>Method 1: Have the software pick components for you</b> </p><p>In this mode the software chooses the op amps, resistors and capacitors for you.  We support three optimizations in this mode:</p><ul><li>Voltage Range:   Tool selects an op amp with a wide input and output range.   Resistor and capacitor values tend to be between the \"Noise\" and \"Power\" optimizations.</li><li>Noise:   Tool selects an op amp with a low spectral noise density - taking into account both voltage and current noise.   The tool uses lower value resistors and higher value capacitors to keep noise contribution from resistors low.</li><li>Power:   Tool selects an op amp with low current consumption.  In this mode the tools relaxes the accuracy requirement on the filter to allow use of op amps with lower gain bandwidth products, which typically have lower current consumption.   Tool uses higher value resistors and lower value capacitor values to keep current consumption minimized.</li></ul><p><b>Method 2: Choose the components yourself</b> </p><p>In this mode, the software starts with the last values used in the “Pick for me” mode. You can then adjust the component values in three ways:</p><ul><li>Adjust the resistor-capacitor tradeoff:   For example you can move the slider to get a larger resistor and smaller capacitor.  As you adjust this slider, the RC time constant stays the same, so the frequency cutoff of the filter will still match the cutoff chosen in the specifications screen.</li><li>Adjust the gain resistors:   .   If a stage has them, you can adjust the absolute values of the gain resistors.   The ratio between the resistors stays fixed to maintain the gain chosen in the specifications screen.</li><li>Choose a different op amp:   The program calculates minimum requirements based on your entries in the specifications screen.   You can pick from op amps in our portfolio that meet these minimum requirements.</li></ul><p>You can also adjust the stage order by grabbing one of the stage bars and moving it above/below the other stages.   Stage order typically does not affect the magnitude and phase performance, but can have a significant impact on noise and voltage range.  </p>",
        "title": "Choosing Components",
        "tooltip": "Click for help"
      },
      "compensate-gbw": {
        "message": "<p>If this control is left unchecked, the software program computes the resistor and capacitor values assuming an ideal op amp that is infinitely fast, similar to what you might do using a filter textbook.  Real op amps are not infinitely fast, and this limitation can affect the filter response.   If this control is checked, then the program adjusts the resistor and capacitor values to compensate for the effect of the op amp's limited gain bandwidth, so that the final result is closer to what was intended.</p><p>For example:   lets say a filter stage is supposed to have a frequency cutoff of 100 kHz and a Q of 1.   However because of the op amp's limited gain bandwidth product, the actual result with textbook component values might be 95 KHz and a Q of 1.1.    If the checkbox is checked, the tool will compensate by selecting resistor and capacitor values that are off in the opposite direction, say for a cutoff frequency of 105 kHz and Q of 0.9 if the op amp were ideal.   The errors will cancel out to get a result close to the ideal response.</p><p>In general it is better to choose an op amp with enough gain bandwidth, rather than relying on this compensation method. If you are using the \"Pick for me\" mode and the \"Voltage Range\" or \"Low Noise\" optimization, the tool attempts to choose an op amp with high enough gain bandwidth that it approximates ideal, but not so high that it wastes a lot of power. Therefore the Compensate for GBW checkbox shouldn't make much difference.  However with the \"Power\" optimization, checking this box can improve performance, since this optimization relaxes the op amp GBW requirement to save power.   If you are using “I want to choose” mode, and choose an op amp at or below the recommend GBW, checking this box may also help.  </p><p>Limitations of this technique:</p><ul><li>This technique only compensates for the op amp's gain bandwidth product, not its output resistance.   If you are designing a low pass or bandpass filter and see the response curve go upward at high frequencies, this is a likely a result of the output resistance nonideality.   Output resistance should be addressed by choosing an op amp with a higher gain bandwidth, choosing an op amp with a standard (instead of rail to rail) output stage, or by increasing the circuit's resistor values.</li><li>This technique elimates most, but not all the error from the op amp's gain bandwidth product. </li><li>This technique cannot fix the rolloff of a high pass or bandpass filter at high frequencies.</li><li>The program assumes a fairly simple model for the op amp open loop gain curve.   If the op amp's actual performance varies significantly from the model, this gain bandwidth compensation may not be correct.    Results should be checked in SPICE and in the lab.</li><li>Especially when working with high Q circuits, the compensation may depend on fairly small variations in the R & C components.   Use the \"Component Tolerances\" screen to see how actual component tolerances affect the results.</li></ul>",
        "title": "Compensate For GBW",
        "tooltip": "Click for help"
      },
      "component-sizing": {
        "message": "<p>The filter wizard allows the ratio of resistors to capacitors to be varied.   Larger resistors will create more noise and bias current error, but reduce op amp output resistance errors and lower power consumption.   If possible, keep capacitor values under 0.1&mu;F - this will allow the use of C0G rather than X7R capacitors.   C0G material is preferred because its capacitance is much more stable with the temperature and applied voltage than the X7R type. </p><p>Some filter architectures have both a positive and negative feedback path.   If this is the case, one of the feedback paths will simply be a ratio of resistors.   The second control in this section allows the absolute values in this feedback path to be adjusted (while the ratio remains the same.)</p>",
        "title": "Component Sizing",
        "tooltip": "Click for help"
      },
      "implementation": {
        "message": "<p>The filter wizard current supports the following circuit implementations:   Sallen Key, Multiple Feedback, and First Order.   If an implementation is appropriate for the order and type of the filter stage, it will be listed here.</p><p>For more information on the Sallen Key implementation see the <a href=''{siteURL}/MT-222'' target=''_blank''>MT-222 tutorial.</a> For a comparison of the Sallen Key vs. Multiple Feedback implementation, see the <a href=''{siteURL}/en/resources/media-center/videos/3637489704001.html'' target=''_blank''>Filtering 101: Sallen Key vs. Multiple Feedback </a> video.</p>",
        "title": "Implementation",
        "tooltip": "Click for help"
      },
      "noise": {
        "adc-table": {
          "message": "<p>This table shows you the effective number of bits of an ADC. The equivalent number of bits (ENOB) is calculated as follows:</p><p>Max input signal (rms) = ADC input range (peak to peak) / 2√2</p><p>SNR = 20 * log (Max input signal (rms) / noise (rms))</p><p>ENOB = (SNR – 1.76) / 6.02</p>",
          "title": "ADC Table",
          "tooltip": "Click for help"
        }
      },
      "op-amp-selection": {
        "message": "<p>If you prefer a different op amp than the one the tool selected, here is where you can change it.</p><p>The tool divides ADI's op amp library into three categories:</p><ul><li>Not Allowed:   The tool will not allow you to pick some op amps for a variety of reasons:   op amp is simply not fast enough to implement the filter, op amp won't fit on the the evaluation board, op amp won't work at the supplies you specified, op amp database missing specifications the tool needs, etc.</li><li>Marginal:   Some op amps are fast enough to implement the filter you chose, but with some error.   While not optimal, you still may want to use one of these parts.   For example, because you have it in stock or because you really need to conserve power in your design.   The tool warns you, but allows you to use these parts in your design.   It is often a good idea to use the \"Compensate for GBW\" option with these op amps to reduce the error they create.</li><li>Recommended:   These parts are fast enough to work well in your design. </li></ul>",
        "title": "Op Amp",
        "tooltip": "Click for help"
      },
      "op-amp-selection-help": {
        "message": "<p><b>What these op amp requirements mean:</b></p><ul><li>Total Supply voltage: comes from the “Voltage Supplies” section in the Components.</li><li>Recommended GBW:  An op amp with this gain bandwidth or higher should give good performance for the filter stage.  An op amp must meet this minimum GBW to be a “recommended” part in the op amp list.</li><li>Required GBW:   Op amps with gain bandwidth lower than this threshold are not selectable.  This because the filter performance would be so bad that we are not able to accurately simulate it.  If an op amp has a GBW between recommend and required, the fp and Q will be affected, but performance may still be good enough for some applications.</li></ul><p><b>How the GBW limits are calculated</b></p><p>The standard rule of thumb for filter design is min GBW > gain * Q * fp * 100.  This rule of thumb has the advantage of being straightforward and easy to remember.  However it generally gives a more conservative answer than necessary.  In other words, you can often use a slower op amp than what this equation recommends and get a perfectly good filter result.</p><p>Unfortunately for a more precise answer, the math becomes quite complicated. Because computers can do math well, we use this complicated math in the Filter Wizard to compute the numbers we show.  Unfortunately these equations are messy and don’t enhance understanding.</p><p>If you want to understand how the op amp affects the filter response, Mac Van Valkenburg's excellent \"Design of Analog Filters\" has some good discussions about the effect of the op amp's finite amplifier gain on overall filter response.  His equations, as much as they can be, are written to teach you what is going on. This text heavily influenced the equations we use in the Filter Wizard.</p><p>Where to draw the line is also subjective.  It really depends on how much error you are willing to tolerate.  This is why we give both a recommended GBW (what we think is a good lower limit) and required GBW (the lowest number where we feel comfortable our simulations will be reasonably accurate.)  Most importantly, we simulate the response in real time, so you can immediately see the effect of the op amp on the filter performance.  Our recommended GBW is a rough first pass - ultimately it is up to you whether the filter performance meets your specific needs.  We tried to make our simulations fast and painless, so you can quickly try out various options and evaluate the results on the metrics that are important to you.</p>",
        "title": "Op Amp Requirements",
        "tooltip": "Click for help"
      },
      "voltage-supplies": {
        "message": "<p>Choose voltage supplies for the op amp.   The program will use these voltages to select an appropriate op amp when “pick for me” is chosen or narrow down the op amp choices if “I want to choose” is chosen.</p><p>If you choose a single supply voltage (–Vs = 0), the tool inserts a mid-supply reference voltage generator into the circuit for you.</p>",
        "title": "Voltage Supplies",
        "tooltip": "Click for help"
      }
    },
    "comp-tolerance": {
      "GBW": {
        "message": "<p>The part to part variation in gain bandwidth is typically +/-20% for most op amps.   This control lets you see the effect of this gain bandwidth variation.   Unless the op amp is barely fast enough for the design, the variation in gain bandwidth product normally has little effect on the filter accuracy.</p>",
        "title": "GBW",
        "tooltip": "Click for help"
      },
      "capacitor": {
        "message": "<p><b>Capacitor – Tolerance</b></p><p>This control tells the program what range of capacitor values to use to compute the tolerance envelope shown on the graph.</p><p>For example, let’s say the filter calculations on the previous page compute an ideal capacitor value of 1.12 μF. Let’s also assume you selected E6 as the preferred series, which means this capacitor will be rounded down to 1 uF.  If you select 20% for a tolerance, the program will compute the envelope using 1 μF +/-20%.</p><p>Because 1% capacitor values typically have limited availability, this program limits 1% capacitors to 4.7nF and below.  Higher values will be bumped up to 5% tolerance.</p><table class=''fw-table tolerance-table''><tr><th>Capacitor Tolerance</th><th> Allowed Range</th></tr><tr><td>Ideal</td><td>10pF to 10µF</td></tr><tr><td>1%</td><td>10pF to 4.7nF</td></tr><tr><td>5%</td><td>10pF to 10µF</td></tr><tr><td>10%</td><td>10pF to 10µF</td></tr><tr><td>20%</td><td>10pF to 10µF</td></tr></table><p>Note that capacitors are typically the most inaccurate part of a filter design, so purchasing higher tolerance capacitors is typically a good investment. We recommend 5% or better capacitors, built using C0G (also known as NP0) ceramic material.</p>",
        "title": "Capacitor",
        "tooltip": "Click for help"
      },
      "inductor": {
        "message": "<p><b>Inductor – Tolerance</b></p><p>This control tells the program what range of inductor values to use to compute the tolerance envelope shown on the graph.</p><p>For example, let’s say the filter calculations on the previous page compute an ideal inductor value of 1.12nH. Let’s also assume you selected E6 as the preferred series, which means this inductor will be rounded down to 1uH.  If you select 20% for a tolerance, the program will compute the envelope using 1 μH +/-20%.</p><table class=''fw-table tolerance-table''><tr><th>Inductor Tolerance</th><th> Allowed Range</th></tr><tr><td>Ideal</td><td>10nH to 33µH</td></tr><tr><td>5%</td><td>10nH to 33µH</td></tr><tr><td>10%</td><td>10nH to 33µH</td></tr><tr><td>20%</td><td>10nH to 33µH</td></tr></table><p>When you order the parts for your circuit, we recommend choosing inductors with a resonant frequency at least 10x that of your passband frequency (for low pass filters) or center frequency (for bandpass filters). This constraint may affect the inductor tolerance you are able to order.</p>",
        "title": "Inductor",
        "tooltip": "Click for help"
      },
      "noise": {
        "adc-table": {
          "message": "<p>This table shows you the effective number of bits of an ADC. The equivalent number of bits (ENOB) is calculated as follows:</p><p>Max input signal (rms) = ADC input range (peak to peak) / 2√2</p><p>SNR = 20 * log (Max input signal (rms) / noise (rms))</p><p>ENOB = (SNR – 1.76) / 6.02</p><p>We calculate the effective number of bits for the nominal and worst case combinations of components. The tighter the tolerances, the closer these numbers will be to each other</p>",
          "title": "ADC Table",
          "tooltip": "Click for help"
        }
      },
      "pref-series-capacitor": {
        "message": "<p><b>Capacitor – Preferred Series</b></p><p>The filter wizard program lets you set the preferred series for passive components: the value a component will be rounded to.</p><p>For examples, let’s say the filter calculations on the previous page compute an ideal capacitor value of 1.12 uF.  The following table shows where this value will be rounded, based on the preferred series.</p><table class=''fw-table tolerance-table''><tr><th>Preferred Series</th><th> Rounded value</th></tr><tr><td>Ideal</td><td>1.12 uF</td></tr><tr><td>E24</td><td>1.1 uF</td></tr><tr><td>E12</td><td>1.2 uF</td></tr><tr><td>E6</td><td>1 uF</td></tr></table>",
        "title": "Capacitor",
        "tooltip": "Click for help"
      },
      "pref-series-inductor": {
        "message": "<p><b>Inductor – Preferred Series</b></p><p>The filter wizard program lets you set the preferred series for passive components: the value a component will be rounded to.</p><p>For examples, let’s say the filter calculations on the previous page compute an ideal inductor value of 1.12 uH.  The following table shows where this value will be rounded, based on the preferred series.</p><table class=''fw-table tolerance-table''><tr><th>Preferred Series</th><th> Rounded value</th></tr><tr><td>Ideal</td><td>1.12 uH</td></tr><tr><td>E12</td><td>1.2 uH</td></tr><tr><td>E6</td><td>1 uH</td></tr></table><p>When you order the parts for your circuit, we recommend choosing inductors with a resonant frequency at least 10x that of your passband frequency (for low pass filters) or center frequency (for bandpass filters). This constraint may affect the inductor tolerance you are able to order.</p>",
        "title": "Inductor",
        "tooltip": "Click for help"
      },
      "pref-series-resistor": {
        "message": "<p><b>Resistor – Preferred Series</b></p><p>The filter wizard program lets you set the preferred series for passive components: the value a component will be rounded to.</p><p>For examples, let’s say the filter calculations on the previous page compute an ideal resistor value of 1.12 kΩ.  The following table shows where this value will be rounded, based on the preferred series.</p><table class=''fw-table tolerance-table''><tr><th>Preferred Series</th><th> Rounded value</th></tr><tr><td>Ideal</td><td>1.12 kΩ</td></tr><tr><td>E96</td><td>1.13 kΩ</td></tr><tr><td>E48</td><td>1.1 kΩ</td></tr><tr><td>E24</td><td>1.1 kΩ</td></tr><tr><td>E12</td><td>1.2 kΩ</td></tr><tr><td>E6</td><td>1 kΩ</td></tr></table>",
        "title": "Resistor",
        "tooltip": "Click for help"
      },
      "resistor": {
        "message": "<p><b>Resistor – Tolerance</b></p><p>This control tells the program what range of resistor values to use to compute the tolerance envelope shown on the graph.</p><p>For example, let’s say the filter calculations on the previous page compute an ideal resistor value of 1.12 kΩ. Let’s also assume you selected E96 as the preferred series, which means this resistor will be rounded up to 1.13 kΩ.  If you select 1% for a tolerance, the program will compute the envelope using 1.13 kΩ +/-1%.</p><p>Because 0.1% and 0.5% resistor values typically have limited availability, this program limits these resistors to 10Ω to 1 MΩ.   Values outside this range will be bumped up to a 1% tolerance.</p><table class=''fw-table tolerance-table''><tr><th>Resistor Tolerance</th><th> Allowed Range</th></tr><tr><td>Ideal</td><td>1Ω to 10 MΩ</td></tr><tr><td>0.1%</td><td>10Ω to 1 MΩ</td></tr><tr><td>0.5%</td><td>10Ω to 1 MΩ</td></tr><tr><td>1%</td><td>1Ω to 10 MΩ</td></tr><tr><td>5%</td><td>1Ω to 10 MΩ</td></tr></table><p>We recommend 25 ppm/°C thin film resistors when designing filters. These typically provide a good compromise between accuracy and cost.</p>",
        "title": "Resistor",
        "tooltip": "Click for help"
      },
      "step-response": {
        "why-no-envelope": {
          "message": "<p>This tool does not calculate the tolerance envelope for the step response view.   Calculating an accurate step response envelope requires a large number of iterations, each of which take a long time to calculate.   To preserve the interactive nature of the tool, we decided not to include this feature.   We recommend using Monte Carlo simulations in SPICE if step response variation is critical. </p><p>While we don't calculate the envelope, we do calculate the nominal step response based on the nominal component values in the filter.   As you change the tolerance values, the nominal values change, so you will see some movement in the step response plot.</p>",
          "title": "Why No Envelope?",
          "tooltip": "Click for help"
        }
      }
    },
    "main": {
      "message": "<p class=''sub-help-header''>Tool Overview</p><p>Use the Analog Filter Wizard to design low-pass, high-pass, or band-pass filters with actual op amps in minutes.  As you progress through the design process, you can observe the characteristics of your filter design from ideal specifications to real world circuit behavior.  Quickly evaluate the tradeoffs in op amp specifications - including gain-bandwidth, noise, and supply current – to determine the best filter design for your requirements.  Features include:</p><ul><li>Filter Response slider – select between Fewest Stages (Chebyshev) to Fastest Settling (Bessel), with numerous responses in between (Chebyshev, Butterworth, and Butterworth-Bessel)</li><li>Allow Filter Wizard to select op amps (optimizing for low power, low noise, or voltage range), or use “I want to choose” feature to manually select op-amps</li><li>Sallen Key and Multiple Feedback topology available in “I want to choose” section</li><li>Calculations and plots include the effects of non-ideal op-amp characteristics and passive component tolerances.</li><li>Prototype finished design using the <a href=''{siteURL}/en/design-center/evaluation-hardware-and-software/evaluation-boards-kits/eval-fw.html'' target=''_blank''>Filter Wizard Evaluation System</a></li><li>Save and share design, and download design file package, which includes design report, SPICE simulation files, bill of materials, and evaluation PCB design files.</li></ul><p class=''sub-help-header''>Help on Specific Items</p><p>For help on specific items, please on click on the blue question mark next to the item of interest.</p>",
      "title": "Filter Wizard Help"
    },
    "next-steps": {
      "circuit": {
        "bypass-capacitor-title": "BYPASS CAPACITORS",
        "eval-board-help": {
          "message": "<p>The filter wizard evaluation board system consists of a motherboard and several daughterboards.   Each motherboard has slots for 4 daughterboards.  Use one daughterboard per stage.   If the design calls for more than 4 stages, multiple motherboards can be ganged together.  The motherboard also contains bypass circuitry and the reference stage (if needed).</p><p>The motherboard/daughterboard system gives you the following advantages:</p><ul><li><b>Change stage order quickly.</b> For example to trade-off noise performance vs. input range.</li><li><b>Use multiple different stage types.</b> The filter wizard evaluation board system contains several daughterboard models to support different types of stages.    These daughterboards can be mixed and matched in the same design.   For example: One stage can use a single op amp while another stage uses a dual package op amp.  Or a low-pass and high-pass stage can be combined to create a bandpass filter. </li><li><b>Measure individual stage performance easily.</b> The design makes it very clear where one stage starts and another ends. Single stages can be debugged in isolation.</li></ul><p>You can purchase the bare evaluation boards and sample op amps from Analog Devices.  The rest of the components should be purchased from your distributor.</p><p>The filter wizard refers to components on each board by the last letter in the reference designator.   For example, stage A components will be referred to as R1A, U1A, etc.   Stage B components will be referred to as R1B, U1B, etc.   The motherboard components will be referred to as R1M, U1M, etc.   If your design has multiple daughterboards of the same type, we recommend marking your daughterboards to keep track of which board is stage A, which board is stage B, etc.<p><div class=''opampNotValid-header-txt''>Picture of Motherboard and a Daughterboard</div><div class=''orderEvalBoardExplanationImage'' style=\"background: url(''images/mother-daughter-eval-board.jpg'') no-repeat scroll 0 0 transparent;height: 307px;margin-right: 200px;width: 416px;\"></div>",
          "title": "Explanation of Evaluation Board System",
          "tooltip": "Click for help"
        },
        "opamp-spares-title": "SPARES",
        "whats-this": {
          "message": "<p>The filter tool adds a reference stage whenever &ndash;Vs = 0.   This reference stage creates a mid-supply voltage rail that functions as the reference voltage for the filter circuits.</p><p>The reference stage includes an AD8031 op amp driving a 10 &mu;F capacitance.   Driving a capacitance directly with an op amp is typically a very bad idea.  However the architecture of the AD8031 ensures this configuration is stable, as long as the capacitance being driven is large enough.   The advantage of this circuit is that it provides a low frequency source impedance across the entire frequency spectrum.   Because the filter circuits can source and sink considerable amounts of current into the reference, a low source impedance reference is important for the best filter performance.     To keep this reference circuit stable, please ensure the following:</p><ul><li>Use the AD8031.  The stability of the circuit depends of the properties of this specific op amp.</li><li>The capacitance the AD8031 drives should be at least 10 &mu;F.  Any number of bypass capacitors can be placed in parallel with this capacitance.</li><li>No resistance should be placed between the AD8031 output and the capacitor(s).</li></ul><p>In the tool we show the reference voltage being derived with a voltage divider directly off the positive supply rail.   However this voltage could also be generated from a voltage reference IC such as an ADR4520 or ADR3420.   Footprints for these reference IC's are included on the evaluation board for your convenience.</p><hr><p>Because the AD8031 is a high speed amplifier, it consumes a relatively large amount of power.   In a low power design, this reference circuit can dominate the power budget.  Here a few other techiques that can be used in place of the reference circuit we show in the filter wizard:<ul><li> Level shift the signal before the filter and use low pass filter stages without gain </li><li> Use voltage dividers instead of resistors connected to a reference voltage.  For example, if the designs calls for a 10 k&Omega; resistor connected to a mid-scale voltage reference, use a voltage divider between the two supplies consisting of 2 20 k&Omega; resistors instead.   Of course voltage dividers consume power themselves, so this technique only saves power when the resistors connected to the reference voltage in the original filter design have high values. </li><li> Use a low power voltage follower to generate the reference voltage.   Do not connect capacitors between the reference voltage and ground.   This technique works if the output impedance of the voltage follower is small compared to the rest of the resistors in the filter in the frequency range of interest.   Unfortunately, as a general rule, the lower the power of an op amp, the higher its output resistance at a particular frequency. </li> </ul>",
          "title": "Mid-Supply Voltage Reference",
          "tooltip": "Click for help"
        },
        "whats-this-trigger": "What's This?",
        "why-spares": {
          "message": "<p>When using dual or quad op amps, the filter wizard only uses one of the op amps in the package. The unused op amps are shown in the spares section. The spares are wired so they use minimum power. </p><p>For filters with multiple stages using dual or quad op amps, the filter wizard \"wastes\" op amps; it makes no attempt to use the extra op amp(s) from one stage for another stage. We do this to make the evaluation board system easy to use: by keeping one IC per stage we can use one daughter card per stage, which makes it easy to swap out different daughter cards to see performance differences.</p><p>When you lay out your circuit for production, we recommend making use of each op amp in the package. </p>",
          "title": "Why The Spares?",
          "tooltip": "Click for help"
        }
      }
    },
    "specifications": {
      "filter-response": {
        "message": "<p>Use this slider to choose the filter response.   Choosing a response is a trade-off between the number of components vs. other desirable properties.  This tool supports four response types:</p><p><table class=''fw-table''><tbody><tr><th>Slider Position</th><th>Filter Response</th><th>Comments</th></tr><tr><td>Left<p>(Fewest Stages)</p></td><td>Chebyshev</td><td><p>The Chebyshev response provides the steepest transition between passband and stopband and therefore requires the fewest stages (i.e fewest components.)<p><p>Drawbacks of this filter are: <ul><li>ripple in the passband</li><li>poor step response</li><li>high sensitivity to component variation</li></ul><p> Move the slider further to the left to increase the amount of ripple (and decrease the number of stages needed.)   Move the slider closer to the center to decrease the ripple needed. </p><p>See <a href=''{siteURL}/MT-206'' target=''_blank''>MT-206 tutorial</a> for more information on the Chebyshev response.</p></td></tr><tr><td>Middle</td><td>Butterworth</td><td><p>The Butterworth response is a good compromise between number of components and other characteristics like step response and component tolerance sensitivity. The Butterworth response is often called the \"maximally flat\" response because it offers the steepest transition between passband and stopband while still avoiding peaking.</p><p>See <a href=''{siteURL}/MT-224'' target=''_blank''>MT-224 tutorial</a> for more information on the Butterworth response.</p></td></tr><tr><td>Right Middle</td><td>Butterworth Bessel</td><td><p>The Butterworth-Bessel filter is a transition filter between the Bessel and Butterworth responses.   Its performance is a mixture of these two response types.</p><p>Move the slider towards the middle position to make this filter more \"Butterworth-like\".  Move the slider further to the right to make this filter more \"Bessel-like\".</p></td></tr><tr><td>Furthest Right <p>(Fastest Settling)<p></td><td>Bessel</td><td><p>The Bessel filter offers the shallowest transition between passband and stopband and therefore requires the most  stages (i.e. most components).</p><p>However it otherwise has excellent characteristics</p><ul><li>great step response</li><li>excellent group and phase delay<li>low sensitivity to component variation</li></ul><p>Note that if the stopband and passband frequencies are too close together a Bessel solution may not be possible.</p><p>See <a href=''{siteURL}/MT-204'' target=''_blank''>MT-204 tutorial</a> for more information on the Bessel response.</p></td></tr></tbody></table></p>",
        "title": "Filter Response",
        "tooltip": "Click for help"
      },
      "passband": {
        "message": "<p>This is the range of frequencies you want to let through.   Define this region by entering the circuit gain at the passband frequencies, the frequency cutoff, and the attenuation you prefer at this frequency cutoff.</p><p>Attenuation is relative to the gain entered. For example, if you enter 20 dB for the gain and attenuation of -3 dB, then the tool attempts to set the passband cutoff frequency at 17 dB.</p>",
        "title": "Passband",
        "tooltip": "Click for help"
      },
      "stopband": {
        "message": "<p>This is the range of frequencies you want to reject.</p><p>The attenuation is relative to the circuit gain.   For example if you enter 20 dB for the gain and an attenuation of -35 dB, then the tool attempts to set the stopband frequency at -15 dB.</p>",
        "title": "Stopband",
        "tooltip": "Click for help"
      }
    },
    "to-precision-warning": {
      "message": "We have detected that you are using a browser, probably Edge 15 or 16, that displays certain numbers inaccurately when a precision is specified. (The issue first showed up in Edge 15 and was fixed in Edge 17.) The discrepancy can be as high as 50% in some cases. You will get more reliable results with this application using a different browser.",
      "title": "Browser Number Display Issue"
    }
  },
  "navbar": {
    "chinese": "简体中文",
    "english": "English",
    "feedback": "Feedback",
    "help": "Help",
    "japanese": "日本語",
    "load": "Load",
    "next-tab": "Next Tab",
    "previous-tab": "Previous Tab",
    "save": "Save",
    "videos": "Videos"
  },
  "opAmpSelection": {
    "innerRequirements": {
      "recommended-gbw-title": "Recommended GBW: ",
      "required-gbw-title": "Required GBW: ",
      "requirement-title-one": "Stage ",
      "requirement-title-two": " op amp requirements",
      "total-supply-voltage-title": "Total Supply Voltage: "
    },
    "status": {
      "blank-opamp-name": "op amps name is blank",
      "channel-support": "filter evaluation board only supports singles and duals",
      "components-out-of-range": "R, L, or C in circuit too big or small",
      "current-feedback-unsupported": "Current feedback op amps not supported",
      "disabled": "disabled",
      "gbw-low": "gbw low",
      "gbw-too-low": "GBW too low",
      "ibias_high": "bias current high",
      "last-time-buy": "Last Time Buy",
      "marginal": "marginal",
      "not-allowed": "not allowed",
      "not-available-in-database": "Not Available in database:",
      "not-enough-negative-input-range": "not enough negative input range",
      "not-enough-negative-output-range": "not enough negative output range",
      "not-enough-positive-input-range": "not enough positive input range",
      "not-enough-positive-output-range": "not enough positive output range",
      "not-recommended": "not recommended",
      "not-recommended-new-designs": "not recommended for new designs",
      "obsolete": "Obsolete",
      "output-impedence-high": "output impedance too high",
      "package-incompatible": "package incompatible with evaluation board",
      "prerelease": "pre-release",
      "quad-opamp": "quad op amps not supported by eval board",
      "recommended": "recommended",
      "rout-high": "output resistance high",
      "row-count": "'{count, plural, =0 {Displaying # of {total} op amps. Please check the filters provided.} other {Displaying # of {total} op amps.}}'",
      "slew-rate-low": "slew rate too low",
      "supply-voltage-high": "supply voltage too high",
      "supply-voltage-low": "supply voltage too low",
      "under-min-stable-gain": "Min stable gain = {value}",
      "under-min-stable-gain-no-cap": "Min stable gain = {value} (assumes no comp cap)"
    },
    "title": "Choose Op Amp"
  },
  "page": {
    "description": "Design active filters with real op amps in minutes.",
    "title": "Filter Wizard | Analog Devices"
  },
  "panel": {
    "display-context": {
      "center-frequency": "center",
      "compensate-gbw": "; GBW comp",
      "components": "Optimize: {optimization}; +Vs: {vplus}; -Vs: {vminus}",
      "filter-type": {
        "bandPass": "Band-Pass",
        "highPass": "High-Pass",
        "lowPass": "Low-Pass"
      },
      "frequency": "{value}Hz {signal}",
      "optimizations": {
        "noise": "Noise",
        "power": "Power",
        "specific-components": "Specific Parts",
        "voltage-range": "Voltage Range"
      },
      "passband-frequency": "passband",
      "specifications": "{order} {implementation}",
      "stopband-frequency": "stopband",
      "tolerances": "R: {rtolerance}; C: {ctolerance}",
      "tolerances-inductor": "L: {ltolerance}"
    },
    "view": "View:"
  },
  "parameter-selector": {
    "choose-parameters": "Choose Parameters",
    "ok": "OK"
  },
  "settings": {
    "components": {
      "change-op-amp": "Change Op Amp",
      "choose-op-amp": "Choose",
      "compensate-gbw": "Compensate for GBW",
      "component-sizing": "Component Sizing:",
      "components": "Components",
      "gain-resistors": "Gain Resistors",
      "gain-slider": "Gain Slider",
      "implementation": "Implementation",
      "implementations": {
        "buffered-rc": "Buffered RC",
        "first-order": "First Order",
        "gain": "Gain",
        "inductor": "Inductor",
        "multiple-feedback": "Multiple Feedback",
        "sallen-key": "Sallen Key"
      },
      "negative-supply-voltage": "Negative Supply Voltage",
      "op-amp": "Op Amp:",
      "optimization": "Optimization",
      "optimizations": {
        "low-noise": "Low Noise",
        "low-power": "Low Power",
        "specific-components": "Specific Parts",
        "voltage-range": "Voltage Range"
      },
      "pick-for-me": "Pick for me",
      "positive-supply-voltage": "Positive Supply Voltage",
      "q-resistors": "Q Resistors",
      "rc-sizing": "RC Sizing",
      "stage": "Stage: {letter}",
      "stages": "Stages",
      "user-choice": "I want to choose",
      "volt-unit": "V",
      "voltage-supplies": "Voltage Supplies",
      "vs-minus": "-Vs :",
      "vs-plus": "+Vs :"
    },
    "filter-tab": {
      "bandPass": "Band Pass",
      "highPass": "High Pass",
      "lowPass": "Low Pass",
      "select-filter-type": "Select your filter type"
    },
    "next-steps": {
      "all-files": "All Files",
      "all-files-tooltip": "Download zip file containing SPICE files, BOM, evaluation PCB design files, and pdf versions of views",
      "evaluation-board": "Eval Board",
      "evaluation-board-tooltip": "Order eval board kit to build hardware prototype",
      "feedback": "Give Feedback",
      "get-files": "Get Files",
      "mail-colleague": "Mail to Colleague",
      "mail-colleague-tooltip": "Send a copy of this design to a colleague",
      "order": "Order",
      "samples": "Samples",
      "samples-tooltip": "Order component sample",
      "send-design": "Send filter<br/>to {toolname}",
      "send-design-tooltip": "Sends a filter design to the calling application",
      "share": "Share",
      "spice-only": "SPICE Only",
      "spice-only-tooltip": "Download zip file containing SPICE files"
    },
    "specifications": {
      "center": "Center Frequency",
      "db": "dB",
      "fastest-settling-0": "Fastest",
      "fastest-settling-1": "Settling",
      "fewest-stages-0": "Fewest",
      "fewest-stages-1": "Stages",
      "filter-response": "Filter Response",
      "gain": "Gain",
      "gain-units": {
        "db": "dB",
        "vv": "V/V"
      },
      "hz": "Hz",
      "passband": "Passband",
      "passband-attenuation": "Passband Attenuation",
      "passband-frequency": "Passband Frequency",
      "passband-gain-units": "Passband Gain Units",
      "stopband": "Stopband",
      "stopband-attenuation": "Stopband Attenuation",
      "stopband-frequency": "Stopband Frequency"
    },
    "tolerances": {
      "E12": "E12",
      "E24": "E24",
      "E48": "E48",
      "E6": "E6",
      "E96": "E96",
      "capacitor": "Capacitor",
      "capacitor-series": "Capacitor Preferred Series",
      "capacitor-tolerance": "Capacitor Tolerance",
      "component-tolerances": "Component Tolerances",
      "five": "5%",
      "fiveTenths": "0.5%",
      "gbw-tolerance": "Op Amp GBW Tolerance",
      "ideal": "ideal",
      "inductor": "Inductor",
      "inductor-series": "Inductor Preferred Series",
      "inductor-tolerance": "Inductor Tolerance",
      "one": "1%",
      "oneTenth": "0.1%",
      "op-amp-gbw": "Op Amp GBW",
      "preferred-series": "Preferred Series",
      "resistor": "Resistor",
      "resistor-series": "Resistor Preferred Series",
      "resistor-tolerance": "Resistor Tolerance",
      "ten": "10%",
      "twenty": "20%"
    }
  },
  "units": {
    "ampere": "A",
    "db": "dB",
    "degree": "°",
    "hz": "Hz",
    "ohm": "Ω",
    "radian": "rad",
    "second": "s",
    "snd": "V/√Hz",
    "volt": "V",
    "vperus": "V/us",
    "vpp": "Vpp",
    "vrms": "Vrms",
    "vv": "V/V",
    "watt": "W"
  },
  "wizard": {
    "components": "Components",
    "filter-type": "Filter Type",
    "next-steps": "Next Steps",
    "specifications": "Specifications",
    "tolerances": "Tolerances"
  }
}], ["ja-jp", {
  "annotations": {
    "filterResponse": {
      "orders": {
        "order1": "1次{responseType}",
        "order10": "10次{responseType}",
        "order2": "2次{responseType}",
        "order3": "3次{responseType}",
        "order4": "4次{responseType}",
        "order5": "5次{responseType}",
        "order6": "6次{responseType}",
        "order7": "7次{responseType}",
        "order8": "8次{responseType}",
        "order9": "9次{responseType}",
        "orderN": "{order}次{responseType}"
      },
      "responseType": {
        "Bessel": "ベッセル",
        "Butterworth": "バタワース",
        "Butterworth Bessel": "バタワース・ベッセル",
        "Chebyshev": "チェビシェフ"
      },
      "responseValue": "{value} dB",
      "stages": "{count, plural, =1 {1 段} other {# 段}}"
    },
    "magnitude": {
      "db-down": "{n}dB　減衰",
      "gain": "ゲイン = {n} dB",
      "passband-region": "ベースバンド領域",
      "passband-ripple": "通過帯域のリップル = {n} dB",
      "stopband-region": "ストップバンド領域"
    }
  },
  "dialogs": {
    "algorithm-confirmation": {
      "decreasing-r2-advantages": "R2の低減には以下のメリットがあります。",
      "decreasing-r2-advantages-item-1": "R2で生じる抵抗ノイズの低減",
      "decreasing-r2-advantages-item-2": "R2で生じる電流性ノイズの影響の低減",
      "decreasing-r2-advantages-item-3": "アンプの入力容量が性能に影響する可能性の低減",
      "expand": "展開",
      "hide": "隠す",
      "increasing-r1-advantages": "R1の増大には以下のメリットがあります。",
      "increasing-r1-advantages-item-1": "ソース・インピーダンスがフィルターの応答に影響する可能性の低減",
      "increasing-r1-advantages-item-2": "高周波における入力フィルター側の入力インピーダンスの増大",
      "increasing-r1-advantages-item-3": "高周波におけるアンプ出力での負荷低減",
      "introduction": "2023年11月にフィルター・ウィザードをアップデートし、サレンキー・ローパス使用部品を他と異なる方法で計算するように変更しました。その他のステージの形態には影響がありません。この変更は高いR2/R1比となるサレンキー・ローパス・ステージに影響します。高い比率はフィルターの性能に悪影響を及ぼします。そのためこの比率を低減しました。この変更はフィルター・ステージの主な仕様（fp、Q、および利得）にはほとんど影響しません。このアルゴリズムでは向上したステージ性能を得るため、一部の最適化においてステージの順序が変わっている場合があります。",
      "new-algorithm-button": "新アルゴリズムを使用",
      "old-algorithm-button": "旧アルゴリズムを使用",
      "post-script-new-design": "R1、R2、C1、およびC2が変化する場合があります。その他のすべての部品は影響を受けません。すべての新規設計には新しい方式が使用されます。",
      "post-script-save-design": "この保存済みの設計に対して、引き続き旧アルゴリズムを使用するか、新アルゴリズムを使用するかを選択できます。新アルゴリズムにアップデートすると、これらの部品は最後に保存した時点と異なるものになる場合があります。",
      "potential-drawbacks": "この変更によって以下のデメリットが生じる可能性があります。",
      "potential-drawbacks-item-1": "旧アルゴリズムではC1/C2が10という良好な比率になることが多かった。",
      "potential-drawbacks-item-2": "ノイズ・ゲインのわずかな増大。ただしR2低減のよるノイズ低下がこのデメリットを上回ると考えられます。",
      "potential-drawbacks-item-3": "単電源構成で利得が1より大きい場合、R2の低減に伴い出力インピーダンスのより低い中間電位ドライバが必要。当社のAD8031コンデンサ駆動ソリューションは十分これに対応可能と考えられます。",
      "pros-and-cons": "R2/R1比を低減することによるメリットとデメリット - クリックして",
      "title": "保存後に行われたサレンキー・ローパス使用部品の計算方式の変更"
    },
    "common": {
      "cancel": "キャンセル",
      "close": "閉じる",
      "ok": "OK",
      "open": "開く",
      "save": "保存する",
      "select": "選ぶ"
    },
    "connect-to": {
      "message-error": "Connection to {tool} failed",
      "title-error": "Connection Error"
    },
    "evaluation-boards": {
      "eval-board-column": "必要な評価用ボード",
      "eval-board-flagged": "評価ボードは、ご注文いただけません。",
      "eval-board-flagged-after-incompatibles": "評価ボードを注文するには、部品選択タブから互換性のある製品を選びなおしてください。",
      "eval-board-flagged-before-incompatibles": "部品選択タブで、フィルターウィザード評価ボードシステムでは非推奨のオペアンプを選んでいます: ",
      "eval-board-flagged-multi-feedback": "コンポーネント選択タブで、1つまたは複数の回路段に対して多重帰還段の実装が選択されています。多重帰還回路段に使用できる評価用ドーター・ボードはまだありません。",
      "eval-board-instruction": "「注文」ボタンが開くページで、「ご購入」をクリックしてカートにアイテムを追加できるページを開いてください。",
      "eval-board-multiple": "* 出荷される各ドーターボードのボックスには4つの個別段が含まれており、それぞれを個別に注文する必要はありません。",
      "eval-board-not-available-board": "使用できません",
      "eval-board-parts-column": "これらの部品をハンダ付けする（部品は別々に注文する） ",
      "eval_board-flagged-inductor": "コンポーネント選択タブで、1つまたは複数の回路段に対してインダクタ段の実装が選択されています。インダクタ回路段に使用できる評価用ドーター・ボードはまだありません。",
      "evalboard-confirmation": {
        "cancel-button-text": "キャンセル",
        "message": "申し訳ありません。フィルタ・ウィザードの評価用ボード・システムには、インダクタを用いる段のためのドーターボードがありません。",
        "proceed-button-text": "ともかく評価用ボードを見る",
        "title": "評価用ボード・システムに対し周波数が高すぎます。"
      },
      "stage-column": "段",
      "stage-info": {
        "channel-dual": "-- デュアルオペアンプ",
        "channel-none": "",
        "channel-single": "-- シングル・オペアンプ",
        "implementation-buffered-rc": "RC",
        "implementation-deliyannis-friend": "複数のフィードバック (Deliyannis Friend)",
        "implementation-first-order": "初回注文",
        "implementation-gain": "ゲイン",
        "implementation-inductor": "インダクタ許容誤差",
        "implementation-multiple-feedback": "複数のフィードバック",
        "implementation-none": "",
        "implementation-sallen-key": "サレンキー",
        "stage-text": "{stageType} {stageImplementation} 段 {stageChannel}",
        "stage-type-band-pass": "バンドパス",
        "stage-type-band-stop": "バンドストップ",
        "stage-type-gain": "ゲイン",
        "stage-type-high-pass": "ハイパス",
        "stage-type-low-pass": "ローパス",
        "stage-type-none": "",
        "stage-type-notch": "ノッチ"
      },
      "stage-info-column": "回路段の情報",
      "table-title": "必要な評価ボード",
      "title": "評価ボードを注文する"
    },
    "feedback": {
      "email": "お客様のメールアドレス：",
      "feedback": "ご意見、ご要望：",
      "feedback-dialog-ng-message": "フィードバックの送信に失敗しました。ネットワーク接続に問題がある場合があります。お手数ですが再度お試しください。",
      "feedback-dialog-ok-message": "ご意見、ご要望をご記入頂きありがとうございました。",
      "give-feedback": "意見または感想を送る",
      "invitation": "このツールに関する率直なご意見、ご要望をお聞かせください。 ",
      "name": "お客様のお名前：",
      "optional": "(Optional)",
      "title": "皆様のご意見をお聞かせください！"
    },
    "load": {
      "choose-button": "ファイルを選択",
      "invalid-file": "有効でない設計ファイルです。ファイルをご確認ください。",
      "invalid-parts": "{numParts,plural,other{設計を読み込めません。この設計で使用されている次の部品は、このアプリケーションではサポートされていません： }}{parts}",
      "message": "ローカルPC上の設計ファイルを読み込む",
      "no-opamps": "オペアンプのデータが入手できません。設計を読み込むことができません。ブラウザを更新してみてください。引き続きこの問題が発生する場合は、フィルタ・ウィザードの右上部にある［ご意見・ご要望］ボタンで問題をご報告ください。",
      "title": "設計を読み込む"
    },
    "opamp": {
      "table": {
        "architecture": "Architecture",
        "canOrderEvalBoard": "Eval Board?",
        "comment": "コメント",
        "comments": "コメント",
        "commentsDisplay": {
          "showAll": "すべて表示",
          "showNotAllowed": "許可されていない",
          "showNotAllowedMatch": "使用できません",
          "showNotRecommended": "おススメではない",
          "showNotRecommendedMatch": "非推奨",
          "showRecommended": "お勧め",
          "showRecommendedMatch": "推奨"
        },
        "feedbackMethod": "Feedback Method",
        "gbw": "GBW (Hz)",
        "iBias": "max iBias (A)",
        "iNoise": "iNoise",
        "inHeadroomMinus": "In Headroom- (V)",
        "inHeadroomPlus": "In Headroom+ (V)",
        "index": "Index",
        "isLTSpiceDisplay": {
          "showAll": "すべて表示",
          "showNo": "いいえ",
          "showYes": "はい"
        },
        "isLTSpiceOpAmp": "LTspice?",
        "maxSupplyVoltage": "最大供給 (V)",
        "minStableGain": "Min Stable Gain",
        "minSupplyVoltage": "最少供給 (V)",
        "numberChannels": "＃チャネル",
        "outHeadroomMinus": "Out Headroom- (V)",
        "outHeadroomPlus": "Out Headroom+ (V)",
        "packageCode": "Package Code",
        "partNumber": "部品",
        "price": "価格 (US $)",
        "rOut": "rOut",
        "rawGBW": "Raw GBW",
        "selectable": "Selectable?",
        "slewRate": "Slew Rate",
        "specialOpAmp": "Special Op-Amp?",
        "status": "Status Code",
        "statusDisplay": {
          "showAll": "すべて表示",
          "showNotRecommended": "新規設計には非推奨",
          "showProduction": "生産／供給中",
          "showRecommended": "新規設計にお薦めします。"
        },
        "statusText": "ステータス",
        "supplyCurrent": "iSupply (A)",
        "tempRange": "温度範囲",
        "tempRangeDisplay": {
          "showAll": "すべて表示",
          "showBlanks": "(ブランク)"
        },
        "vNoise": "vNoise (nV/√Hz)",
        "vintage": "Vintage",
        "vos": "max Vos (V)"
      }
    },
    "samples": {
      "add-button": "選択したサンプルをカートに入れる",
      "add-to-cart-column": "サンプルをカートに入れる",
      "model-column": "モデル／パッケージ",
      "part-column": "構成部品",
      "quantities-warning": "アナログ・デバイセズは認証させていただいたお客様に限り、無料サンプルのご注文を受け付けています。 サンプルについては大変多くのご要望をいただいておりますため、おひとり様2週間あたり最大で4製品、各2個ずつまでのご注文とさせていただきます。無料サンプルとしてご注文いただける以上の量が必要な場合は、オンライン購入をしていただくか（在庫がある場合に限ります）、販売代理店にお問い合わせください。",
      "title": "サンプル注文",
      "unavailable-message": "サンプルの提供はありません。"
    },
    "save": {
      "save-desc-error": "概要を入力してください。",
      "save-desc-field": "概要",
      "save-name-error": "デザイン名を入力してください。",
      "save-name-field": "デザイン名",
      "title": "保存"
    },
    "send-filter": {
      "message": "You may now close this browser tab.",
      "message-error": "Sending design to {tool} was unsuccessful",
      "title-cancel": "{tool} has broken the connection",
      "title-error": "Send Design Error",
      "title-ok": "Filter Transfer to {tool} Complete"
    },
    "share": {
      "share-button": "Email",
      "share-design-information": "<p>設計ファイルのコピーを共有するには、<b>“差出人名”</b>にお客様のお名前を、共有したい方のメールアドレスを<b>“設計を共有”</b>項目にご入力ください。送信先が複数の場合には、それぞれのメールアドレスを改行してご入力ください。</p><p>アナログ･デバイセズよりZIPファイルにまとめられた設計ファイルが添付されたメールを、ご入力いただいたメールアドレスにお送りします。添付されたZIPファイルを解凍して、各ツールのアップロード機能を使用して設計ファイルをアップロードするだけで、その設計ファイルを使用することが出来ます。</p><p>上記手順により、共有された設計ファイルのコピーを使用することが出来ます。ただし、共有された設計ファイルのコピーが編集されても、お客様のオリジナルの設計ファイルが編集されることはありません。</p>",
      "share-dialog-ng-message": "回路を共有できません。サーバーの接続不良による可能性があります。再度お試しください。",
      "share-dialog-ok-message": "回路は共有されました",
      "share-duplicate-email": "同じメールアドレスが複数含まれています",
      "share-email-empty-error": "メールアドレスを入力してください。",
      "share-email-field": "設計を共有",
      "share-email-format-error": "お客様が入力したメールアドレスの中で少なくとも１つは無効です。修正して再度お試しください。",
      "share-email-placeholder": "メールアドレス",
      "share-name-error": "デザイン名を入力してください。",
      "share-name-field": "デザイン名",
      "share-sender-error": "差出人名を入力してください。",
      "share-sender-field": "差出人名",
      "title": "自分の設計をメールで送信"
    },
    "system": {
      "application-busy": "処理中・・・",
      "connecting-to": "Connecting to {tool}...",
      "download-create-bom": "BOM ファイルを作成中・・・",
      "download-create-data": "データ・ファイルを作成中・・・",
      "download-create-design": "設計ファイルの作成中・・・",
      "download-create-eval-board": "評価用ボード・ファイルを作成中・・・",
      "download-create-graph": "Graph データを作成中・・・",
      "download-create-pdf": "PDFファイルを作成中・・・",
      "download-create-spice": "SPICEファイルを作成中・・・",
      "download-downloading": "ダウンロード中・・・",
      "download-requesting": "送信中・・・",
      "error-opamp-data": "オペアンプのデータが入手できません。そのため、フィルタ・ウィザードを続行できません。設計を保存しブラウザを更新してみてください。引き続きこの問題が発生する場合は、フィルタ・ウィザードの右上部にある［ご意見・ご要望］ボタンで問題をご報告ください。",
      "error-pst-data": "現在データ・マップが入手できません。そのため、オペアンプ・テーブルを表示できません。設計を保存しブラウザを更新してみてください。引き続きこの問題が発生する場合は、フィルタ・ウィザードの右上部にある［ご意見・ご要望］ボタンで問題をご報告ください。",
      "loading-opamp-data": "オペアンプ・データ読み込み中...",
      "sending-filter": "Sending filter to {tool}...",
      "title": "アプリケーション・メッセージ"
    },
    "video": {
      "active_filter": {
        "title": "Filtering 101: アクティブ・フィルタ段の順序",
        "url": "{basedir}/jp/resources/media-center/videos/4586846379001.html"
      },
      "active_passive": {
        "title": "Filtering 101: アクティブ・フィルタ　vs. パッシブ・フィルタ",
        "url": "{basedir}/jp/resources/media-center/videos/4282614503001.html"
      },
      "analog_digital": {
        "title": "Filtering 101: アナログ vs　デジタル",
        "url": "{basedir}/jp/resources/media-center/videos/4301672668001.html"
      },
      "chebyshev_butterworth_bessel": {
        "title": "Filtering 101: チェビシェフ VS バターワース VS ベッセル",
        "url": "{basedir}/jp/resources/media-center/videos/4301683346001.html"
      },
      "gain_attenuation": {
        "title": "Sallen-Key 101: ゲインと減衰",
        "url": "{basedir}/jp/resources/media-center/videos/4616958051001.html"
      },
      "heading": "説明のビデオを観るには、下のリンクをクリックしてください。",
      "opamp_output_impedance": {
        "title": "Sallen-Key 101: オペアンプの出力インピーダンスの影響",
        "url": "{basedir}/jp/resources/media-center/videos/4586847310001.html"
      },
      "picking_components": {
        "title": "Sallen-Key 101: 部品の選び方",
        "url": "{basedir}/jp/resources/media-center/videos/4616965945001.html"
      },
      "quality_factor": {
        "title": "Filtering 101: Q-フィルタの品質係数",
        "url": "{basedir}/jp/resources/media-center/videos/4586847309001.html"
      },
      "sallenkey_feedback": {
        "title": "Filtering 101: サレンキー回路 vs 多重帰還回路",
        "url": "{basedir}/jp/resources/media-center/videos/4304269767001.html"
      },
      "subtitle": "フィルタ設計に関するチュートリアル・ビデオ",
      "title": "ビデオ"
    }
  },
  "download": {
    "error-message": "<p>設計ファイルを取得できません。 このエラーは、以下の理由で発生している場合があります。</ p> <p> 1）サーバとの接続が切れているため。</ p> <p> 2）サービスが停止されているため。",
    "error-title": "ダウンロード",
    "file-content": {
      "no-schematic": "現在、LTspiceはアナログ・デバイセズのツールとなり、SPICEネットリストをLTspiceモデルに変換しております。残念ながら、お客様の設計で使用しているオペアンプ製品は、現在LTspiceでは使用できません。特定の製品をLTspiceで使用されることをご希望の場合には、営業担当者にご連絡いただくか、このツールのフィードバック機能よりご意見をお送りください。\r\n\r\nSPICEシュミレーション・ツールでのサポート済み製品:\r\n",
      "no-schematic-no-netlist": "アナログ･デバイセズは、現在SPICE ネットリストのオペアンプ製品をLTspiceにてご使用いただけるよう移行を行っております。お客様の設計にはLTspiceで使用できるものと使用できないものがあり、このツールではSPICE用ファイルを作成することが出来ません。ご不便をお掛けしておりますこと、お詫び申し上げます。特定の製品をLTspiceで使用されることをご希望の場合には、営業担当者にご連絡いただくか、このツールのフィードバック機能よりご意見を頂きますようお願い申し上げます。\r\n\r\nSPICEシュミレーション・ツールでのサポート済み製品:\r\n",
      "part-no-spice-info": "設計で使用されている次のオペアンプには、LTspiceモデルまたはテキスト・ネットリスト・モデルがありません。特定部品のLTspiceモデルを優先的に作成することをアナログ・デバイセズに希望される場合は、営業担当者またはこのツールを通じてご連絡ください。"
    },
    "pdf-content": {
      "image-headers": {
        "circuit": "回路",
        "group-delay": "群遅延",
        "input-impedance-mag": "入力インピーダンス",
        "input-impedance-phase": "入力インピーダンス位相",
        "magnitude-db": "振幅（dB)",
        "magnitude-vv": "振幅（V/V)",
        "noise": "ノイズ",
        "phase-degrees": "位相(度)",
        "phase-delay": "位相遅れ",
        "phase-radians": "位相（ラジアン)",
        "stages": "段",
        "step-response": "ステップ応答"
      },
      "pdf-data-ie-image-missing": "大変申し訳ありませんが、このツールをExplorer 8　またはそれ以下のバージョンでお使いの場合、画像を表示することができません。Firefox,Chrome,または　Explorer 9をお使いください。",
      "pdf-desc": "{desc}\n\n作成者 {user} 作成日 {date}",
      "pdf-desc-no-design-name": "作成者 {user} 作成日{date}",
      "pdf-desc-no-name-desc": "作成日{date}",
      "pdf-desc-no-user-name": "{desc}\n\n作成日 {date}",
      "pdf-heading": "フィルタ・ウィザード・デザイン・レポート",
      "pdf-orders": {
        "order1": "1次",
        "order10": "10次",
        "order11": "11次",
        "order12": "12次",
        "order2": "2次",
        "order3": "3次",
        "order4": "4次",
        "order5": "5次",
        "order6": "6次",
        "order7": "7次",
        "order8": "8次",
        "order9": "9次"
      },
      "pdf-subheading": "{filterType}、{nthOrder}{filterResponse}のフィルタの条件",
      "pdf-tool-name": "フィルタ・ウィザード"
    }
  },
  "ember-aditools-page": {
    "card": {
      "checkbox-tooltip": "Toggle",
      "help-tooltip": "Click for help",
      "part-number-tooltip": "Click to select part"
    },
    "common": {
      "cancel": "キャンセル",
      "close": "閉じる",
      "load": "読み込む",
      "ok": "OK",
      "open": "開く",
      "save": "保存する",
      "select": "選ぶ"
    },
    "dialogs": {
      "feedback": {
        "email": "お客様のメールアドレス：",
        "feedback": "ご意見、ご要望：",
        "give-feedback": "意見または感想を送る",
        "invitation": "このツールに関する率直なご意見、ご要望をお聞かせください。 ",
        "name": "お客様のお名前：",
        "optional": "(Optional)",
        "title": "皆様のご意見をお聞かせください！"
      },
      "load": {
        "choose-button": "ファイルを選択",
        "message": "ローカルPC上の設計ファイルを読み込む",
        "no-file-selected": "No file selected.",
        "title": "設計を読み込む"
      },
      "samples": {
        "add-button": "選択したサンプルをカートに入れる",
        "add-link": "Add to Order",
        "add-to-cart-column": "サンプルをカートに入れる",
        "model-column": "モデル／パッケージ",
        "part-column": "構成部品",
        "quantities-warning": "アナログ・デバイセズは認証させていただいたお客様に限り、無料サンプルのご注文を受け付けています。 サンプルについては大変多くのご要望をいただいておりますため、おひとり様2週間あたり最大で4製品、各2個ずつまでのご注文とさせていただきます。無料サンプルとしてご注文いただける以上の量が必要な場合は、オンライン購入をしていただくか（在庫がある場合に限ります）、販売代理店にお問い合わせください。",
        "title": "サンプル注文",
        "unavailable-message": "サンプルの提供はありません。"
      },
      "save": {
        "save-desc-error": "概要を入力してください。",
        "save-desc-field": "概要",
        "save-name-error": "デザイン名を入力してください。",
        "save-name-field": "デザイン名",
        "title": "保存"
      },
      "share": {
        "share-button": "Email",
        "share-design-information": "<p>設計ファイルのコピーを共有するには、<b>“差出人名”</b>にお客様のお名前を、共有したい方のメールアドレスを<b>“設計を共有”</b>項目にご入力ください。送信先が複数の場合には、それぞれのメールアドレスを改行してご入力ください。</p><p>アナログ･デバイセズよりZIPファイルにまとめられた設計ファイルが添付されたメールを、ご入力いただいたメールアドレスにお送りします。添付されたZIPファイルを解凍して、各ツールのアップロード機能を使用して設計ファイルをアップロードするだけで、その設計ファイルを使用することが出来ます。</p><p>上記手順により、共有された設計ファイルのコピーを使用することが出来ます。ただし、共有された設計ファイルのコピーが編集されても、お客様のオリジナルの設計ファイルが編集されることはありません。</p>",
        "share-dialog-ng-message": "回路を共有できません。サーバーの接続不良による可能性があります。再度お試しください。",
        "share-dialog-ok-message": "回路は共有されました",
        "share-duplicate-email": "同じメールアドレスが複数含まれています",
        "share-email-empty-error": "メールアドレスを入力してください。",
        "share-email-field": "設計を共有",
        "share-email-format-error": "お客様が入力したメールアドレスの中で少なくとも１つは無効です。修正して再度お試しください。",
        "share-email-placeholder": "メールアドレス",
        "share-name-error": "デザイン名を入力してください。",
        "share-name-field": "デザイン名",
        "share-sender-error": "差出人名を入力してください。",
        "share-sender-field": "差出人名",
        "title": "自分の設計をメールで送信"
      },
      "system": {
        "application-busy": "処理中・・・",
        "title": "アプリケーション・メッセージ"
      }
    },
    "footer": {
      "accessibility": "アクセシビリティ",
      "cookie-settings": "Cookieの設定",
      "copyright-text": "1995 - 2025 Analog Devices, Inc. 全著作権所有",
      "icp-id": "",
      "legal": "法的事項およびリスク約",
      "privacy-policy": "プライバシーポリシー",
      "privacy-settings": "プライバシー設定",
      "sitemap": "サイトマップ"
    },
    "header": {
      "applications": "アプリケーション",
      "company": "企業情報",
      "design-center": "設計支援",
      "education": "調べる／学ぶ",
      "parametric-search": "パラメータ検索",
      "products": "製品",
      "spoken": {
        "homepage": "ホームページ",
        "sitelinks": "アナログ・デバイセズのサイトへのリンク"
      },
      "support": "サポート"
    },
    "menubar": {
      "chinese": "简体中文",
      "english": "English",
      "help": "ヘルプ",
      "japanese": "日本語",
      "load": "設計を読み込む",
      "save": "保存"
    },
    "studio": {
      "adcdriver": "ADCドライバ",
      "dacebc": "DAC",
      "diamond": "計装アンプ",
      "filterwizard": "アナログ・フィルタ",
      "noise": "ノイズ",
      "photodiode": "フォトダイオード",
      "precisionstudio": "ADI<span class=''service-mark''>℠</span> Precision Studio",
      "signalchaindesigner": "Signal Chain",
      "simdds": "DDS",
      "spoken": {
        "studiolinks": "ADI Precision Studio へのリンク"
      },
      "virteval": "Virtual Eval"
    },
    "toolbar": {
      "actions": "Actions"
    }
  },
  "figures": {
    "billOfMaterials": {
      "bom-designator": "リファレンス・デジグネーター",
      "bom-material": "材料",
      "bom-package": "パッケージ",
      "bom-quantity": "量",
      "bom-text": "「ファイルの取得」をクリックすると、テキストファイル形式のBOMを含むすべてのファイルをzip形式でダウンロードできます。",
      "bom-text-italic": "アナログ・デバイセズ製の評価ボードを使用せずに、お客様自身でPCBを作成する場合、斜体文字で書かれているパッケージは省略可能です。",
      "bom-tolerance": "許容誤差",
      "bom-value": "値",
      "extra-components": {
        "header": "ヘッダ",
        "jumper": "ジャンパ",
        "sma-jack": "SMAジャック、ボード・エッジ、メス",
        "sma-male": "オス-オスSMA",
        "socket": "ソケット",
        "test-pin": "テスト・ピン"
      },
      "materials": {
        "tantalum": "タンタル"
      },
      "title": "部品表",
      "x-axis": "",
      "y-axis": ""
    },
    "circuit": {
      "filter-type": {
        "band-pass": "バンドパス",
        "high-pass": "ハイパス",
        "low-pass": "ローパス"
      },
      "implementation": {
        "first-order": "RC",
        "gain": "ゲイン",
        "inductor": "インダクタ許容誤差",
        "multiple-feedback": "複数のフィードバック",
        "sallen-key": "サレンキー"
      },
      "order": {
        "eighth_order": "8次",
        "fifth_order": "5次",
        "first_order": "1次",
        "fourth_order": "4次",
        "nineth_order": "9次",
        "second_order": "2次",
        "seventh_order": "7次",
        "sixth_order": "6次",
        "tenth_order": "10次",
        "third_order": "3次"
      },
      "stage": "ステージ {letter}",
      "title": "回路",
      "x-axis": "",
      "y-axis": ""
    },
    "errors": {
      "adcBandwidthIsLessThanMinimum": "ADCの帯域幅（現在{value}Hz）は、{minimum}Hz以上であることが必要です。",
      "centerFrequencyNotInRange": "中心周波数は{minimum}Hzから{maximum}Hzの間で設定してください。",
      "centerFrequencyTooHigh": "中心周波数と通過帯域幅の比率が高すぎます。中心周波数を下げるか、通過帯域幅を広くしてください。",
      "centerFrequencyTooLow": "中心周波数と通過帯域幅の比が低すぎます。中心周波数を上げるか、通過帯域幅を狭くしてください。",
      "emptyField": "{fieldId} は必ず入力してください。",
      "frequencyTooHigh": "実際の部品の値を求める事はできません。 お客様のQ値は高すぎるかもしれません。お客様のQ値をモニターするために仕様画面のステージ図をご利用ください。 以下をお試しください： (1) チェビシェフ・フィルタ応答ではなくバターワース応答あるいはベッセル応答を使用する。 (2) 通過帯域から阻止帯域への変化を遅くする。",
      "frequencyTooLow": "周波数が低すぎます。部品の値が見つかりません。",
      "gainNotInRange": "ゲインは{minimum} {unit}から{maximum} {unit}の間で設定してください。",
      "highOrderFiltersUnsupported": "次数10以下のフィルタ・ソリューションが見つかりません。パスバンド周波数またはストップバンド減衰量を下げるか、ストップバンド周波数またはパスバンド減衰量を上げる、フィルタ応答を調整する、のいずれかを行ってください。",
      "invalidField": "{fieldId}フィールドに入力された{value}という値は解析できません。",
      "noOpAmpFoundForRequirements": "該当するオペアンプはございません。",
      "noOpAmpFoundForRequirementsWithVoltage": "該当するオペアンプはございません。+Vs ～5V および -Vs ～ 0V または -5Vに設定すると、よりよい結果が得られます。",
      "passbandAttenuationHighBandGreaterThan": "As the passband frequency approaches the maximum limit of {frequency}Hz, the passband attenuation becomes more restricted. At the stated passband frequency, the attenuation must be greater than {minimum} dB.",
      "passbandAttenuationLowGreaterThan": "As the passband frequency approaches the minimum limit of {frequency}Hz, the passband attenuation becomes more restricted. At the stated passband frequency, the attenuation must be greater than {minimum} dB.",
      "passbandAttenuationNotInRange": "パスバンド（通過）減衰量は{minimum} dBから{maximum} dBの間で設定してください。",
      "passbandFrequencyNotInRange": "パスバンド（通過）周波数は{minimum}Hzから{maximum}Hzの間で設定してください。",
      "passbandIsGreaterThanStopband": "パスバンド（通過）周波数（現在は {passbandFrequency}Hz)は、ストップバンド（阻止）周波数{stopbandFrequency}Hzよりも小さくなければなりません。",
      "referenceVoltageSpanGreaterThanMax": "リファレンス段のAD8031には電源電圧範囲が広すぎます。電源電圧を下げてください。",
      "referenceVoltageSpanLessThanMinimum": "リファレンス段のAD8031には電源電圧範囲が狭すぎます。電源電圧を上げるか、両電源に変更してください。",
      "selectedOpAmpIsIdeal": "ステージ {stage}: このステージのオペアンプを選択してください。",
      "selectedOpAmpIsIncompatible": "ステージ {stage}: {opAmp} はフィルタ要件を満たしていません。 別のオペアンプを選択するか、コンポーネントの定数を調整してください。",
      "selectedOpAmpIsIncompatibleWithVoltage": "ステージ {stage}: {opAmp} はフィルタ要件を満たしていません。 別のオペアンプを選択するか、コンポーネントの定数を調整、または電源電圧を変更してください。",
      "stageQTooLarge": "あなたのフィルタ段のQは{qValue}。フィルタウィザードツールがサポートするQは50以下です。以下の対処法がありますン: (1) センター周波数を下げる、(2) ストップバンドとパスバンドの周波数を上げる。",
      "stopbandAttenuationNotInRange": "ストップバンド（阻止）減衰量は{minimum} dBから{maximum} dBの間で設定してください。",
      "stopbandFrequencyNotInRange": "ストップバンド（阻止）周波数は{minimum}Hzから{maximum}Hzの間で設定してください。",
      "stopbandIsGreaterThanPassband": "ストップバンド（阻止）周波数（現在は {stopbandFrequency}Hz)は、パスバンド（通過）周波数{passbandFrequency}Hzよりも小さくなければなりません。",
      "stopbandIsGreaterThanPassbandAttenuation": "ストップバンド（阻止）減衰量 （現在は {stopbandAttenuation} dB)は、パスバンド（通過）減衰量{passbandAttenuation} dBよりも大きくなければなりません。",
      "voltageSpanGreaterThanMax": "供給電圧範囲が広すぎます。電圧差36V以内に設定してください。",
      "voltageSpanLessThanMinimum": "供給電圧範囲がせますぎます。1.8V以上に設定してください。",
      "vsMinusShouldBeNegative": "-Vs 電圧の値が高すぎます。0V以下の値を設定してください。",
      "vsMinusZeroVsPlusGreaterThanMax": "+Vs 電圧は -Vs = 0の時、12.6V以下に設定してください。この数値は、最大電圧供給値は12.6Vの単電源リファレンスドライバ　AD8031という製品の仕様からきています。",
      "vsPlusShouldBePositive": "+Vs 電圧の値が低すぎます。0V以上の値を設定してください。"
    },
    "groupDelay": {
      "title": "群遅延",
      "x-axis": "周波数（Hz)",
      "x-hover": "周波数:",
      "y-axis": "群遅延 (s)",
      "y-hover": "群遅延:"
    },
    "inputImpedanceMagnitude": {
      "title": "入力インピーダンス(Ω)",
      "x-axis": "周波数（Hz)",
      "x-hover": "周波数:",
      "y-axis": "入力インピーダンス(Ω)",
      "y-hover": "入力インピーダンス:"
    },
    "inputImpedancePhase": {
      "title": "入力インピーダンス(°)",
      "x-axis": "周波数（Hz)",
      "x-hover": "周波数:",
      "y-axis": "入力インピーダンス(°)",
      "y-hover": "入力インピーダンス:"
    },
    "magnitudeDb": {
      "title": "振幅（dB)",
      "x-axis": "周波数（Hz)",
      "x-hover": "周波数:",
      "y-axis": "振幅（dB)",
      "y-hover": "振幅:"
    },
    "magnitudeVV": {
      "title": "振幅（V/V)",
      "x-axis": "周波数（Hz)",
      "x-hover": "周波数:",
      "y-axis": "振幅（V/V)",
      "y-hover": "振幅:"
    },
    "noise": {
      "adc-bandwidth": "ADCバンド幅",
      "adc-input-range": "ADC入力レンジ",
      "adc-range": "ADCの範囲",
      "adc-table-title": "ADCテーブル",
      "enob-comp-sel": "等価ビット数",
      "enob-comp-tol": "等価ビット数",
      "enob-nominal": "公称有効",
      "enob-worst": "ワースト有効",
      "graph-title": "スペクトル・ノイズ密度",
      "noise-referred-filter-output-1": "全フィルタ出力換算ノイズ。",
      "noise-referred-filter-output-2": "1/fノイズはモデル化されていません。",
      "nominal-label": "少量",
      "peak-to-peak-title": "ピーク to ピーク",
      "rms-peak-to-peak": "RMS & ピーク to ピーク",
      "rms-title": "RMS",
      "title": "ノイズ",
      "worst-case-label": "最も悪いケース",
      "x-axis": "周波数（Hz)",
      "x-hover": "周波数:",
      "y-axis": "スペクトル・ノイズ密度 (V/√Hz)",
      "y-hover": "ノイズ:"
    },
    "phaseDegrees": {
      "title": "位相 (°)",
      "x-axis": "周波数（Hz)",
      "x-hover": "周波数:",
      "y-axis": "位相 (°)",
      "y-hover": "位相:"
    },
    "phaseDelay": {
      "title": "位相遅れ",
      "x-axis": "周波数（Hz)",
      "x-hover": "周波数:",
      "y-axis": "位相遅れ (s)",
      "y-hover": "位相遅れ:"
    },
    "phaseRadians": {
      "title": "位相（rad)",
      "x-axis": "周波数（Hz)",
      "x-hover": "周波数:",
      "y-axis": "位相（rad)",
      "y-hover": "位相:"
    },
    "power": {
      "header-text": "ご注意：このページでは、フィルターの静電消費電力を示しています。入力信号は、電力供給に莫大なインパクトをもたらします。",
      "order-with": {
        "order1": "1次と共に",
        "order2": "2次と共に"
      },
      "reference-stage-part-with": "AD8031と共に",
      "reference-stage-text": "リファレンス段",
      "reference-whats-this": "詳細を見る",
      "title": "電源",
      "total-power": "静止電力の合計",
      "x-axis": "",
      "y-axis": ""
    },
    "stages": {
      "filter-types": {
        "type-name-band-pass": "バンドパス",
        "type-name-high-pass": "ハイパス",
        "type-name-low-pass": "ローパス"
      },
      "header-text": "フィルタは要求します{n}以下の性質のオペアンプステージ",
      "implementations": {
        "buffered-rc": "RC",
        "gain": "ゲイン",
        "inductor": "インダクタ許容誤差",
        "multiple-feedback": "複数の<br/>フィードバック",
        "sallen-key": "サレンキー"
      },
      "orders": {
        "first-order": "1次",
        "second-order": "2次"
      },
      "simulated": "シュミレーション",
      "simulated-to": " へ {value}",
      "target": "ターゲット",
      "title": "段",
      "tooltip": {
        "fp": "そのステージの極周波数。カットオフ周波数、自然周波数、あるいは基本周波数としても知られています。",
        "gain": "ゲイン (V/V): ゲインステージ",
        "q": "Qはそのステージでのピーキングのレベルを示します。この値が高いほど極周波数付近でのピークが高い事を表します。"
      },
      "x-axis": "",
      "y-axis": ""
    },
    "stepResponse": {
      "title": "ステップ応答",
      "x-axis": "時間（秒）",
      "x-hover": "時間:",
      "y-axis": "振幅 (V/V)",
      "y-hover": "振幅:"
    },
    "voltageRange": {
      "amp-input-range": "入力範囲",
      "amp-output-range": "出力範囲",
      "amplifier": "アンプ",
      "amplifier_specs": "アンプの仕様",
      "input-range": "入力範囲",
      "max-signals": "最大信号",
      "max-signals-nominal": "少量",
      "max-signals-worst-case": "最も悪いケース",
      "maximum-input": "最大入力",
      "output-range": "出力信号",
      "signal-possible": "可能な信号",
      "slew-rate": "スルー・レート",
      "title": "電圧範囲",
      "warning-input-range-voltage-range": "このステージの入力範囲は信号範囲を制限します。",
      "warning-output-range-voltage-range": "このステージの出力範囲は信号範囲を制限します。",
      "warning-slew-rate_voltage-range": "このステージのスルーレートは信号範囲を制限します。",
      "x-axis": "",
      "y-axis": ""
    }
  },
  "footer": {
    "copyright": "© 1995 - 2018 Analog Devices, Inc. All Rights Reserved ",
    "privacy-security": "個人情報保護方針",
    "privacy-security-url": "/jp/about-adi/landing-pages/001/privacy_security_statement.html",
    "privacy-settings": "Privacy Settings",
    "privacy-settings-url": "/jp/landing-pages/001/privacy-settings.html",
    "sitemap": "サイトマップ",
    "sitemap-url": "/jp/sitemap.html",
    "terms-of-use": "利用規約",
    "terms-of-use-url": "/jp/about-adi/landing-pages/001/terms_of_use.html"
  },
  "fragments": {
    "at": "@",
    "eq": "=",
    "f": "f",
    "in": "IN",
    "left": "◄----",
    "n-a": "N/A",
    "out": "OUT",
    "p": "p",
    "plus": "+",
    "q": "Q",
    "r": "R",
    "ref": "REF",
    "right": "---►",
    "times": "×",
    "to": "to"
  },
  "header": {
    "applications": "アプリケーション",
    "community": "コミニティ",
    "design-center": "設計支援",
    "education": "調べる／学ぶ",
    "parametric-search": "パラメータ検索",
    "products": "製品",
    "support": "サポート",
    "title": "アナログ・フィルター・ウィザード"
  },
  "help": {
    "common": {
      "noise": {
        "adc-bandwidth": {
          "message": "<p>ここでADCの帯域を入力してください。この値とスペクトル密度のグラフから得たノイズを組み合わせて、実効値とピークtoピーク・ノイズを計算します。 </p><p>実効値とピークtoピークのノイズを計算するためにADCの帯域全体に渡ってスペクトル密度のグラフのノイズを積分します。スペクトル密度のグラフを良く見ると、最も高い周波数でのスペクトル密度の数字はゼロではなく、実際にはグラフが示す周波数よりも高い周波数でも続いています。ADCはフィルタとして動作し、この残留高周波ノイズを取り除きます。</p><p>ADCを１次フィルタとしてモデル化します。ADCロールオフが１次のグラフを作成し、それにスペクトル密度のグラフを掛け、次にその結果を積分します。もしお客様のADCがより鋭いロールオフ（たとえばsinc^3Σ-Δ)の場合、このツールは全体のシステム・ノイズを多少過大評価する可能性があります。</p><p>ADCによっては駆動アンプとADCの間にRCフィルタが必要になります。もしこのRCフィルタの帯域がADC自信の帯域よりも低い（あるいはお客様がADCの帯域をご存じない）場合、代わりにこのRCフィルタのカットオフ周波数をご使用ください。   RCフィルタのカットオフ周波数は 1/(2πRC)です。</p>",
          "title": "ADCバンド幅",
          "tooltip": "ヘルプはここをクリック"
        }
      },
      "power": {
        "message": "<p>－­Vs=0の時、フィルタ・ツールはリファレンス段を追加します.このリファレンス段はフィルタ回路の基準電圧として機能する中間電源電圧を作ります.</p><p>リファレンス段はコンデンサ10&mu;Fを駆動するオペアンプAD8031を含みます.一般的にはコンデンサをオペアンプで直接駆動するのは良くありません.しかし駆動するコンデンサが十分大きければAD8031の回路構造はこの回路が安定に動作する事を保証します.この回路の利点は全周波数スペクトルにわたり低周波数ソース・インピーダンスになっている事です。フィルタ回路はリファレンスに対してかなりの量の電流の吐き出し/吸い込みを行う可能性があるので、ベストのフィルタ性能を得るに低ソース・インピーダンスのリファレンスが重要です.このリファレンス回路を使用する時、次の事に留意してください:</p><ul><li>AD8031を使用する。この回路で他のオペンプに置き換えると不安定になります.</li><li> AD8031が駆動するコンデンサは10&mu;F以上にする必要があります。このコンデンサと並列にいくつでもバイパスコンデンサを接続する事ができます.</li><li>AD8031とコンデンサの間に抵抗は接続しないでください.</li></ul><p>ツールはリファレンス電圧を正電源電圧から直接電圧分割器を使って得ている事を示しています.しかしこの電圧を又ADR4520 又は ADR3420のようおな電圧リファレンスICから生成する事もできます.　これらのリファレンスICのフットプリントは便利のよいように評価ボードに含まれています.</p>",
        "title": "リファレンス段",
        "tooltip": "ヘルプはここをクリック"
      },
      "voltage-range": {
        "message": "アクティブ・フィルタの入力電圧範囲と対応する出力電圧範囲はオペアンプの非理想的な特性によって制限されます。”電圧範囲”ビューは計算された最大入力範囲を示し、どのオペアンプの仕様がその制限に影響を及ぼしているかを強調します。<ul><li>”可能な最も大きな入力信号”は許容される最大入力電圧です- それよりも大きな入力信号を印加するとクリッピングまたは歪をもたらします。</li><li>”アンプの仕様”セクションは各段で選択されたオペアンプの仕様を示します。 </li><li>”最大信号”セクションは最大入力許容力電圧を決定する計算の結果を示します。オペアンプ段と入力信号電圧を制限する仕様は警告アイコンで表示されます。”最大信号”セクションの中の他の値は制限パラメータが絶対に超えないように計算されます-言い変えると全体のフィルタ経路を通して確実にクリッピングあるいは歪が生じないようにします。 </li><li>”部品の許容誤差”タブには、公称値とワーストケースの値があります。公称は回路図に示された部品の公称値と想定します。ワーストケースは許容誤差範囲の限界（その部分ではゲイン伝達関数がより大きくなっていて、入力信号をさらに低く抑える必要がでてきます）でのパッシブ値を使って計算します。部品の許容誤差によるゲイン伝達関数の不確実の説明については”部品許容誤差”タブの”振幅”ビューをご覧ください。  </li></ul><p><b>スルーレートの制限： </b>オペアンプの１つのスルーレートがフィルタの入力電圧範囲を制限する仕様の場合、オペアンプの出力はその能力以上には変化しないので、入力信号電圧はそのスルーレートが対応できるレベルまで減少します。詳細についてはミニチュートリアル <a href=''{siteURL}/MT-045'' target=''_blank''>MT-045</a>：オペアンプの帯域幅と帯域幅平坦度の”スルーレートとフルパワー帯域幅”セクションをご覧ください。</p><p><b>出力電圧範囲の制限： </b>オペアンプの１つの出力電圧範囲がフィルタ入力電圧範囲を制限する仕様の場合、入力信号電圧はオペアンプ出力がオーバードライブしないレベルに減少します。</p><p><b>入力電圧範囲の制限：</b>オペアンプの１つの入力電圧範囲がフィルタ入力電圧範囲の制限する仕様の場合、入力信号電圧はオペアンプ入力がオーバードライブしないレベルに減少します。</p>",
        "title": "電圧範囲",
        "tooltip": "ヘルプはここをクリック"
      }
    },
    "comp-select": {
      "choosing-components": {
        "message": "<p>仕様決定の画面でフィルタの理論的な性能を選択し終わると、次は部品選択の画面で実際の部品を選ぶ番です。部品を変更した際は、回路図上でその変更を見る事ができます。他の表示に変更すれば、部品の選択がフィルタ性能にどのように影響するか見る事ができます。</p><p>フィルタ・ウィザードは部品を選択するために異なる2通りの方法に対応しています。</p><p><b>方法１：ソフトウェアに部品を選択させる方法「”推奨値”ラジオボタンを選択」　　このモードではフィルタ・ウィザード・ソフトウェアがオペアンプ、抵抗、コンデンサを選びます。このモードでは３種類の最適化に対応します。</b></p><ul><li>電圧範囲：ツールは広い入/出力範囲のオペアンプを選択します。　抵抗値とコンデンサ値は\"ノイズ\"の適正化と\"電源\"の最適化の間の値になる傾向があります.</li><li>ノイズ：ツールは低スペクトル・ノイズ密度のオペアンプを選択します；電圧ノイズと電流ノイズの両方を計算に入れます。ツールは抵抗からのノイズに対する影響を低く抑えるために、できるだけ低い値の抵抗とできるだけ高い値のコンデンサを使用します.</li><li>電源：　ツールは低消費電流のオペアンプを選択します。ツールは消費電流を最小限にするためにできるだけ高い値の抵抗とできるだけ低い値のコンデンサを選択します.</li><p><b>方法2：お客様ご自身で部品を選択する方法「”自分で選ぶ”ラジオボタンを選択」。</b> </p><p>このモードでは”推奨値”モードで使われた最後の値で始まります。次に3種類の方法で部品の値を調整する事ができます。</p><ul><li>ー 抵抗ーコンデンサ間のトレードオフを調整する：たとえば抵抗値がより大きく、コンデンサ値がより小さくなるようにスライダーを動かす事が出来ます。このスライダーを調整する時、RC時定数は同じ値を保ちます。従ってフィルターのカットオフ周波数は仕様決定画面で選択したカットオフ周波数と同じ値になっています。</li><li>ーゲイン抵抗を調整する：そのステージにゲイン調整用抵抗が接続されていれば、ゲイン抵抗値の絶対値を調整できます。抵抗比は仕様決定画面で選択されたゲインを維持するために一定に保たれます。</li><li>ー異なるオペアンプを選択する：プログラムは仕様決定画面でのお客様の入力を基に最小要求を計算します。オペンプ一覧表の中からこれらの最小要求を満足するオペアンプを選択できます。</li></ul> <p>また、ステージ名のバーをつかんで、他のステージ・バーの上または下にドラッグ＆ドロップする事によりそれらのステージの順序を入れ替える事ができます。ステージの順番を変えても一般的に大きさや位相性能には影響しませんが、ノイズや電圧範囲に大きな影響がある可能性があります。   </p>",
        "title": "設定を最適化する",
        "tooltip": "ヘルプはここをクリック"
      },
      "compensate-gbw": {
        "message": "<p>もしこのコントロールにチェックが付いてない状態の場合、ソフトウエア・プログラムは（フィルタ教本を使って行うであろう方法と同様に）オペアンプを無限に速い理想的なオペアンプと仮定して、抵抗値とコンデンサ値を計算します。実際のオペアンプは無限に速くはないので、この速さの限界がフィルタ応答に影響を及ぼします.もしこのコントロールにチェックが付いていれば、プログラムは抵抗値とコンデンサ値を調整して、最終結果が意図した結果により近くなるようにオペアンプの限界のある利得帯域幅による影響を補正します.</p><p>たとえば：仮にフィルタ段のカットオフ周波数が100KHzで、Qが1と想定されるとします.　しかしオペアンプの利得帯域幅積には限界があるので、教本にある部品での実際の結果はカットオフ周波数が95 KHz で Q が 1.1になるかもしれません.もしチェックボックスにチェックが入っていれば、ツールはオペアンプが理想的とすればカットオフ周波数が105ｋHzでQが0.9のような反対方向にはならないような抵抗値とコンデンサ値を選択して補償します.　　誤差は相殺して理想の応答に近い結果が得られます.</p><p>一般的にオペアンプを選択する場合はこの補正方法に依存するよりも十分なゲイン帯域幅のあるオペアンプを選択する方が優れています。もしお客様が”推奨値”モードの”電圧範囲”での最適化あるいは”低ノイズ”での最適化のどちらかを選択した場合、ツールはゲイン帯域幅として十分に高く理想に近いが、消費電力が過度に大きくならない程度のゲイン帯域幅を持つオペアンプを選択しようとします。従って”GBWの補正”のチェックボックスの有り無しで回路に大きな違いはないはずです。しかし”低電力”の最適化を選択した場合、この”GBWの補正”のボックスにチェックを入れると電力を節約するためにオペアンプのゲイン帯域幅要求を緩和するので性能が改善する可能性があります。もし”自分で選ぶ”モードにおいて、推奨ゲイン帯域幅かそれ以下の帯域幅のオペアンプを選択した場合、このチェックボックスを確認する事は役に立つかもしれません。   </p><p>この技術の限界:</p><ul><li>この技術はオペアンプの利得帯域幅積のみ補償し、その出力抵抗は補償しません。もしローパスフィルタあるいはバンドパスフィルタを設計していて、応答曲線が高い周波数で上昇するのを観察したら、これは出力抵抗の非理想特性の結果と考えられます.出力抵抗はより高い利得帯域幅のオペアンプを選択したり、標準(レールtoレールではなく)出力段のオペアンプを選択したり、あるいは回路の抵抗値を増加して改善する必要があります。.</li><li>この技術によってオペアンプの利得帯域幅積からすべての誤差は削減されません. </li><li>この技術によって高い周波数でのハイパスフィルタのロールオフは改善できません.</li><li>プログラムはオペアンプのオープンループゲイン曲線をかなり簡単なモデルと仮定します.もしオペアンプの実際の性能がモデルから大幅に変化したら、この利得帯域幅の補正は正しくないかもしれません.　結果をスパイスと実験室でチェックする必要があります.</li><li>得に高いQの回路を取り扱う時、補償はRとC部品のかなり小さなばらつきの影響を受ける可能性があります。　実際の部品の許誤差が結果にどのように影響するかについて確認するために\"部品許容誤差\"画面を使用してください.</li></ul>",
        "title": "GBWの補正",
        "tooltip": "ヘルプはここをクリック"
      },
      "component-sizing": {
        "message": "<p>フィルタ・ウイザートによって抵抗 対 コンデンサ比を変更する事ができます.抵抗を大きくするとノイズとバイアス電流誤差が増えますが、オペアンプの出力抵抗による誤差が減少し、電力消費も小さくなります.できればコンデンサ値を0.1&mu;F以下にしてください ；これによりX7RコンデンサではなくC0Gを使用する事ができます.C0Gタイプのコンデンサの方がX7Rタイプより温度と供給電圧に対してはるかに安定しているのでC0Gをお薦めします. </p><p>フィルタの中には正と負のフィードバック経路がある回路構成のフィルタがあります.　このような場合１つの経路は簡単な抵抗比です。このセクションの２番目のコントロールによりこのフィードバック経路の絶対値を調整できます（一方比率は同じ値に維持します）</p>",
        "title": "「部品のサイジング」",
        "tooltip": "ヘルプはここをクリック"
      },
      "implementation": {
        "message": "<p>フィルタ・ウイザードは以下の回路組込みをサポートしています：Sallen Key（サレンキー）、Multiple Feedback（多重帰還形フィルタの変形）、1次順序やフィルタ段タイプの組込みが適切な場合はここに表示されます.</p><p>サレンキー（Sallen Key）実装についての詳細は、<a href=''{siteURL}/MT-222'' target=''_blank''>MT-222 チュートリアル（英語）</a>をご覧ください。 サレンキーと多重機関回路の実装についての比較は、 <a href=''{siteURL}/jp/resources/media-center/videos/4304269767001.html'' target=''_blank''>Filtering 101 : サレンキー回路 vs 多重帰還回路</a> のビデオをご覧ください</p>",
        "title": "組込み",
        "tooltip": "ヘルプはここをクリック"
      },
      "noise": {
        "adc-table": {
          "message": "<p>この表は、ADCの有効ビット数を示しており、有効ビット数（ENOB）は次式から計算できます:</p><p>最大入力信号（rms）= ADCの入力範囲（ピークtoピーク）/ 2√2</p><p>SNR = 20 × log（最大入力信号（rms）/ノイズ（rms））</p><p>ENOB = (SNR – 1.76) / 6.02</p>",
          "title": "ADCテーブル",
          "tooltip": "ヘルプはここをクリック"
        }
      },
      "op-amp-selection": {
        "message": "<p>もしツールが選択したオペアンプと違うオペアンプを選ぶ場合、オペアンプを変更できるかどうかは下記の判定によります.</p> <p>ツールはADIのオペアンプのライブラリを3つの分類に分けます:</p><ul><li>使用不可：ツールは各種の理由によりあるオペアンプは使用不可にしいます：オペアンプが単純にフィルタを実施するには十分速くない、オペアンプが評価ボードに適さない、あなたが指定した電源でオペアンプが動作しない、オペアンプ・データベースにツールが必要とする仕様が欠けている等.</li><li>マージナル：あるオペアンプの速さはユーザが選んだフィルタを実施するのに十分速いが多少の誤差がある。最適ではないが、これらのオペアンプの一つを使用したい。たとえば、在庫している、あるいは真剣に回路の電力を節約しなければならない。ツールは警告を出しますが、これらの部品を設計に使用する事を許可します。　時にはこれらのオペアンプが作る誤差を削減するためにこれらのオペアンプについて\"GBWの補償\"オプションを使用するのは良い考えです.</li><li>推奨品：　これらのオペアンプは十分速いのでユーザの設計の中で正常に動作します. </li></ul>",
        "title": "オペアンプ",
        "tooltip": "ヘルプはここをクリック"
      },
      "op-amp-selection-help": {
        "message": "<p><b>これらのオペアンプの条件:</b></p><ul><li>全体の供給電圧：部品選択の「オペアンプ電圧供給」セクションの値で決まります。</li><li>推奨されるGBW：ゲイン帯域幅がこの値以上のオペアンプは、フィルタ段用に優れた性能を発揮します。オペアンプ・リストの「推奨」部品となるためには、オペアンプはこの最小GBWを満たす必要があります。</li><li>要求されるGBW：ゲイン帯域幅がこの閾値より小さいオペアンプは選択できません。これは、フィルタ性能が低下し、正確なシミュレーションができないためです。オペアンプのGBWが「推奨されるGBW」と「要求されるGBW」の間にある場合は、fpとQが影響を受けますが、アプリケーションによっては十分に良好な性能を保つことができます。</li></ul><p><b>GBW制限値の計算方法</b></p><p>フィルタ設計の標準的な経験則は、最小GBW > ゲイン × Q × fp × 100です。この経験則は、簡単で覚えやすいという利点がありますが、一般に、必要以上に慎重な答えが導き出されます。言い換えると、この式が推奨する値よりも遅いオペアンプを使用しても、全く良好なフィルタ性能を得られる場合が多々あるということです。</p><p>あいにく、より正確な答えを得ようとすると、数式は非常に複雑なものになってしまいます。コンピュータではこの数式をきちんと処理できるため、フィルタ・ウィザードでは、この複雑な数式を使用して計算し、数値を表示しています。残念ながら、これらの数式は複雑で、それを見ても理解が増すことはありません。</p><p>オペアンプがフィルタ応答に与える影響を理解するには、Mac Van Valkenburgの優れた著書『Design of Analog Filters』が参考になります。この著書にはオペアンプの有限のアンプ利得がフィルタ応答全体に及ぼす影響が詳述されており、できる限り多くの式を用いて、内容を理解できるようになっています。フィルタ・ウィザードで使用している式は、この著書の影響を強く受けています。</p><p>どこで線引きをするかも問題です。これはどの程度の誤差を許容するかに大きく依存します。このことが、推奨のGBW（余裕を持った下限値と思われる値）と要求されるGBW（かなり正確なシミュレーションが可能と想定される最小値）の両方を提示する理由です。最も重要な点は、応答が実時間でシミュレーションされるので、オペアンプがフィルタ性能に及ぼす影響を直ちに知ることができることです。推奨のGBWは大まかな初期設定値です。そのフィルタ性能が特定の目的に適うかどうかを判断するのは、最終的にお客様です。アナログ・デバイセズでは、シミュレーションが高速で使いやすいものとなるよう改良を重ねています。そのため、様々なオプションを即座に試していただき、その結果を、お客様にとって重要な尺度で評価いただけます。</p>",
        "title": "オペアンプの条件",
        "tooltip": "ヘルプはここをクリック"
      },
      "voltage-supplies": {
        "message": "<p>オペアンプの電源電圧を選択してください。「推奨値」を選択すると適切な値のオペアンプが選択され、「自分で選ぶ」を選択すると、製品の選択肢を絞ることができます。<p><p>単電源電圧（–Vs=0）を選択すると、ツールは回路に中間電源リファレンス電圧発生器を挿入します.</p>",
        "title": "オペアンプ電圧供給",
        "tooltip": "ヘルプはここをクリック"
      }
    },
    "comp-tolerance": {
      "GBW": {
        "message": "<p>ほとんどのオペアンプの場合、ゲイン帯域幅の部品毎のばらつきは+/-20%typ です.この制御を行う事によりこのゲイン帯域幅のばらつきの影響がわかります.オペアンプの速度が設計回路に対してぎりぎりでなければ、通常ゲイン帯域幅積のばらつきが許容誤差の包絡線全体に影響を及ぼす事はほとんどありません.</p>",
        "title": "オペアンプGBW",
        "tooltip": "ヘルプはここをクリック"
      },
      "capacitor": {
        "message": "<p><b>コンデンサ － 誤差</b></p><p>この設定はコンデンサ容量の誤差範囲を指定します。この設定値は誤差の包絡線の計算に用いられ、グラフ表示されます。</p><p>たとえば、前ページのフィルタ計算の結果、最適なコンデンサの値が1.12μFになったとします。E6系列が選択されている場合、コンデンサの値は端数が切捨てられ1μFになります。誤差20%を選択した場合、プログラムは1μF +/-20%として包絡線を計算します。 </p><p>一般的に1%のコンデンサ値は入手性に制限があるので、このプログラムは1%誤差コンデンサの容量を4.7nF以下に制限しています。4.7nFより高い値の場合は5%の誤差に変更されます。</p><table class=\"fw-table\"><tr><th>コンデンサの誤差</th><th> 使用できるコンデンサ容量の範囲</th></tr><tr><td>理想</td><td>10pF ～ 10µF</td></tr><tr><td>1%</td><td>10pF ～ 4.7nF</td></tr><tr><td>5%</td><td>10pF ～ 10µF</td></tr><tr><td>10%</td><td>10pF ～ 10µF</td></tr><tr><td>20%</td><td>10pF ～ 10µF</td></tr></table><p>一般的にコンデンサはフィルタ回路構成部品の中で最も精度の悪い部品なので、誤差の小さいコンデンサを使用する事をお薦めします。誤差5%またはそれ以下で、温度特性C0G（あるいはNP0）の良好なセラミック・コンデンサをお薦めします。 </p>",
        "title": "コンデンサ",
        "tooltip": "ヘルプはここをクリック"
      },
      "inductor": {
        "message": "<p><b>インダクタ – 誤差</b></p><p>この設定はインダクタの誤差範囲を指定します。この設定値は誤差の包絡線の計算に用いられ、グラフ表示されます。</p><p>たとえば、前ページのフィルタ計算の結果、理想的なインダクタの値が1.12nHになったとします。E6系列が選択されている場合、インダクタの値は端数が切捨てられ1 nHになります。誤差20%を選択した場合、プログラムは1 nH +/-20%として包絡線を計算します。</p><table class=\"fw-table\"><tr><th>インダクタ の誤差</th><th> 使用できるインダクタの範囲</th></tr><tr><td>理想</td><td>10nH ～ 33µH</td></tr><tr><td>5%</td><td>10nH ～ 33µH</td></tr><tr><td>10%</td><td>10nH ～ 33µH</td></tr><tr><td>20%</td><td>10nH ～ 33µH</td></tr></table><p>インダクタの選定の際には、通過帯域周波数（ローパス・フィルタの場合）あるいは中心周波数（バンドパス・フィルタの場合）の10倍以上の共振周波数を持つインダクタを選択する事をお勧めします。この制約はお客様が注文できるインダクタの誤差に影響する可能性があります。</p>",
        "title": "インダクタ",
        "tooltip": "ヘルプはここをクリック"
      },
      "noise": {
        "adc-table": {
          "message": "<p>この表は、ADCの有効ビット数を示しており、有効ビット数（ENOB）は次式から計算できます:</p><p>最大入力信号（rms）= ADCの入力範囲（ピークtoピーク）/ 2√2</p><p>SNR = 20 × log（最大入力信号（rms）/ノイズ（rms））</p><p>ENOB = (SNR – 1.76) / 6.02</p><p>公称値でワーストケースの組み合わせの部品対する有効ビット数を計算します。許容誤差をより厳しくすると、これらの数は互いに近くなります。</p>",
          "title": "ADCテーブル",
          "tooltip": "ヘルプはここをクリック"
        }
      },
      "pref-series-capacitor": {
        "message": "<p><b>コンデンサ - 系列の指定</b></p><p>使用する部品の系列を設定することができます。設定された系列によって値が丸め処理されます。</p><p>たとえば、前ページのフィルタ計算の結果、コンデンサの理想値が1.12μFになった場合、次の表は指定された系列に基づいて1.12μFがどのように丸め処理されるかを示しています。</p><table class=\"fw-table\"><tr><th>設定した系列</th><th> 丸め処理される値</th></tr><tr><td>理想</td><td>1.12 uF</td></tr><tr><td>E24</td><td>1.1 uF</td></tr><tr><td>E12</td><td>1.2 uF</td></tr><tr><td>E6</td><td>1 uF</td></tr></table>",
        "title": "コンデンサ",
        "tooltip": "ヘルプはここをクリック"
      },
      "pref-series-inductor": {
        "message": "<p><b>インダクタ –系列の指定</b></p><p>使用する部品の系列を設定することができます。設定された系列によって値が丸め処理されます。</p><p>たとえば、前ページでのフィルタの計算の結果、理想インダクタが1.12uH になった場合、次の表は指定された系列に基づいて1.12uHがどのように丸め処理されるかを示しています。</p><table class=\"fw-table\"><tr><th>設定した系列</th><th> 丸め処理される値</th></tr><tr><td>理想</td><td>1.12 uH</td></tr><tr><td>E12</td><td>1.2 uH</td></tr><tr><td>E6</td><td>1 uH</td></tr></table><p>インダクタの選定の際には、通過帯域周波数（ローパス・フィルタの場合）あるいは中心周波数（バンドパス・フィルタの場合）の10倍以上の共振周波数を持つインダクタを選択する事をお勧めします。この制約はお客様が注文できるインダクタの誤差に影響する可能性があります。 </p>",
        "title": "インダクタ",
        "tooltip": "ヘルプはここをクリック"
      },
      "pref-series-resistor": {
        "message": "<p><b>抵抗 - 望ましい系列</b></p><p>使用する部品の系列を設定することができます。設定された系列によって値が丸め処理されます。</p><p>たとえば、前ページのフィルタ計算の結果、抵抗の理想値が1.12kΩになった場合、次の表は指定された系列に基づいて1.12kΩがどのように丸め処理されるかを示しています。</p><table class=\"fw-table\"><tr><th>設定した系列</th><th> 丸め処理される値</th></tr><tr><td>理想</td><td>1.12 kΩ</td></tr><tr><td>E96</td><td>1.13 kΩ</td></tr><tr><td>E48</td><td>1.1 kΩ</td></tr><tr><td>E24</td><td>1.1 kΩ</td></tr><tr><td>E12</td><td>1.2 kΩ</td></tr><tr><td>E6</td><td>1 kΩ</td></tr></table>",
        "title": "抵抗",
        "tooltip": "ヘルプはここをクリック"
      },
      "resistor": {
        "message": "<p><b>抵抗 － 誤差</b></p><p>この設定は抵抗値の誤差範囲を指定します。この設定値は誤差の包絡線の計算に用いられ、グラフ表示されます。</p><p>たとえば、前ページのフィルタ計算の結果、最適な抵抗値が1.12kΩになったとします。E6系列が選択されている場合、抵抗値は端数が切り上げられ1.13kΩになります。誤差1%を選択した場合、プログラムは1.13kΩ +/-1%として包絡線を計算します。</p><p>一般的に誤差0.1% と 0.5%の抵抗値は入手性に制限があるので、このプログラムはこれらの誤差を持つ抵抗を10Ω ～ 1 MΩの範囲に制限しています。この範囲を外れる抵抗値を使う場合は1%の誤差に変更されます。</p><table class=\"fw-table\"><tr><th>抵抗の誤差</th><th> 使用できる抵抗値の範囲</th></tr><tr><td>理想</td><td>1Ω ～ 10 MΩ</td></tr><tr><td>0.1%</td><td>10Ω ～ 1 MΩ</td></tr><tr><td>0.5%</td><td>10Ω ～ 1 MΩ</td></tr><tr><td>1%</td><td>1Ω ～ 10 MΩ</td></tr><tr><td>5%</td><td>1Ω ～ 10 MΩ</td></tr></table><p>一般的に精度とコストとのバランスが良いため、フィルタ設計には25 ppm/°C の薄膜抵抗をお薦めします。</p>",
        "title": "抵抗",
        "tooltip": "ヘルプはここをクリック"
      },
      "step-response": {
        "why-no-envelope": {
          "message": "<p>本ツールは、ステップ応答のグラフでは許容差の計算は行いません。正確なステップ応答の計算には、処理時間が必要な大量の繰返し演算が必要です。ツール自体のインタラクティブ性を保つため、許容差の計算は除外しています。ステップ応答の許容差計算にはSPICEシミュレータ上でのモンテカルロ法によるシミュレーションを実施されることをおすすめします。</p><p>包絡線を計算しない時は、フィルタの公称部品の値に基づいて公称ステップ応答を計算します。公差値を変更すると公称値が変わるので、ステップ応答グラフで多少の変動があるのがわかります。 </p>",
          "title": "なぜ包絡線がないのか？",
          "tooltip": "ヘルプはここをクリック"
        }
      }
    },
    "main": {
      "message": "<p class=''sub-help-header''>ツール概要</p><p>アナログ・フィルタ・ウィザードを利用すれば、実際のオペアンプを使い、ローパス、ハイパス、あるいはバンドパス・フィルタを数分間で設計することができます。理想の仕様から実際の回路動作までフィルタ設計の各種特性を確認しながら、設計プロセスを進めることができます。ゲインと帯域幅、ノイズ、電源電流などのオペアンプ仕様のトレードオフを迅速に評価し、必要な条件に対応する最良のフィルタ設計を決定できます。ウィザードは以下のような機能を備えています。</p><ul><li>フィルタ応答スライダ － 最小の段数（チェビシェフ）と最速の設定（ベッセル）の間でスライダを移動させることにより、さまざまな応答（チェビシェフ、バターワース、バターワース・ベッセル）が得られます。</li><li>フィルタ・ウィザードでオペアンプを選ぶ（低消費電力、低ノイズ、または電圧範囲のいずれかに最適化）か、「自分で選ぶ」を選択して手動でオペアンプを選択できます。</li><li>「自分で選ぶ」のセクションでは、サレンキーまたは多重帰還方式を選ぶことができます。</li><li>計算とプロットには、非理想的なオペアンプ特性と受動部品の許容誤差の影響が含まれています。</li><li><a href=''{siteURL}/jp/design-center/evaluation-hardware-and-software/evaluation-boards-kits/eval-fw.html'' target=''_blank''>フィルタ・ウィザード評価システム</a>を使用したプロトタイプの最終設計</li><li>設計を保存して共有し、設計レポート、SPICEシミュレーション・ファイル、部品表、評価用PCB設計ファイルなどを含む設計ファイル・パッケージをダウンロードします。</li></ul><p class =''sub-help-header''>特定の項目に関するヘルプ</p><p>特定の項目に関するヘルプを表示するには、その項目の横にある青いクエスチョン・マーク をクリックしてください。</p>",
      "title": "フィルタ・ウィザードのヘルプ"
    },
    "next-steps": {
      "circuit": {
        "bypass-capacitor-title": "バイパスコンデンサ",
        "eval-board-help": {
          "message": "<p>フィルタ・ウィザードの評価ボード・システムはマザーボードと複数のドーターボードで構成されています。各マザーボードには4つのドーターボード用スロットがあります。１ステージあたり１つのドーターボードを使用します。回路で4ステージ以上必要とする場合は、複数のマザーボードをいっしょに使用する事ができます。マザーボードには（必要に応じて）バイパス回路とリファレンス段も含まれています。</p><p>このマザーボード/ドーターボード構成の評価システムによって、たとえばノイズ性能と入力範囲のトレードオフを行うといったステージの順番を速やかに変えたり、異なるステージ・タイプを複数使用することが可能といった利点があります。 </p><ul><li> フィルター・ウィザードの評価ボード・システムには異なるタイプのステージに対応するために複数のドーターボード・モデルが含まれています。これらのドーターボードを同一回路の中で混在させ、組み合わせて使うことができます。たとえば、１つのステージではシングル・オペアンプを使用し、もう１つのステージではデュアル・オペアンプを使用するといった事ができます。あるいはローパスとハイパス・ステージをそれぞれ組み合わせてバンドパス・フィルタを形成する事ができます。 </li><li><b>各ステージの性能測定は容易です。</b> 回路はどのステージから開始し、どのステージで終わるかが非常にはっきりしています。１つのステージを分離してデバックできます。</li></ul><p>デバイスが実装されていない状態の評価ボードとサンプルのオペアンプはアナログ・デバイセズまたは販売代理店からご購入いただけます。 </p><p>フィルター・ウィザードは各ボードの部品を部品番号の最後の文字で表現します。たとえば、ステージAの部品をR1A、 U1Aなどと呼びます。ステージBの部品をR1B、 U1Bのように呼びます。マザーボードの部品をR1M、 U1Mと呼びます。もしお客様の回路で同じタイプのドーターボードが複数使用される場合は、どのボードがステージAで、どのボードがステージBであるかを記録するためにお客様のドーターボードにマーキングする事をお薦めします。<p><div class=''opampNotValid-header-txt''>マザーボードとドーターボードの図 </div><div class=''orderEvalBoardExplanationImage'' style=\"background: url(''images/mother-daughter-eval-board.jpg'') no-repeat scroll 0 0 transparent;height: 307px;margin-right: 200px;width: 416px;\"></div>",
          "title": "評価ボードシステムについて",
          "tooltip": "ヘルプはここをクリック"
        },
        "opamp-spares-title": "スペア",
        "whats-this": {
          "message": "<p>－­Vs=0の時、フィルタ・ツールはリファレンス段を追加します.このリファレンス段はフィルタ回路の基準電圧として機能する中間電源電圧を作ります.</p><p>リファレンス段はコンデンサ10&mu;Fを駆動するオペアンプAD8031を含みます.一般的にはコンデンサをオペアンプで直接駆動するのは良くありません.しかし駆動するコンデンサが十分大きければAD8031の回路構造はこの回路が安定に動作する事を保証します.この回路の利点は全周波数スペクトルにわたり低周波数ソース・インピーダンスになっている事です。フィルタ回路はリファレンスに対してかなりの量の電流の吐き出し/吸い込みを行う可能性があるので、ベストのフィルタ性能を得るに低ソース・インピーダンスのリファレンスが重要です.このリファレンス回路を使用する時、次の事に留意してください:</p><ul><li>AD8031を使用する。この回路で他のオペンプに置き換えると不安定になります.</li><li> AD8031が駆動するコンデンサは10&mu;F以上にする必要があります。このコンデンサと並列にいくつでもバイパスコンデンサを接続する事ができます.</li><li>AD8031とコンデンサの間に抵抗は接続しないでください.</li></ul><p>ツールはリファレンス電圧を正電源電圧から直接電圧分割器を使って得ている事を示しています.しかしこの電圧を又ADR4520 又は ADR3420のようおな電圧リファレンスICから生成する事もできます.　これらのリファレンスICのフットプリントは便利のよいように評価ボードに含まれています.</p>",
          "title": "中間電源電圧リファレンス",
          "tooltip": "ヘルプはここをクリック"
        },
        "whats-this-trigger": "詳細を見る",
        "why-spares": {
          "message": "<p>デュアル・オペアンプを使用する時、フィルタ・ウイザードは常にパッケージに含まれる2つのオペアンプの１つだけを使用します。未使用のオペアンプはスペア・セクションに表示されます。このオペアンプも配線されているため、消費電力は最少です。 </p><p>デュアル・オペアンプを使用した複数ステージのフィルタの場合、フィルター・ウィザードはオペアンプを冗長に使います；例えばデュアル・オペアンプが内蔵する2個のオペアンプのうち、1個のみをそのステージに使用し、余ったもう1つの内蔵オペアンプを別のステージに使用する事はしません。フィルタウィザードでは評価ボード・システムをシンプルに構成するためにこのようにしています：1ステージあたり1つのICを使うルールにする事によって、1ステージあたり1つのドーターカードにする事ができるので、性能の違いを見るために異なるドーターカードと容易に交換する事ができます。</p><p>お客様の回路を量産用にレイアウトする時には、一つのデバイス・パッケージ内の各々のオペアンプを無駄なく利用する事をお薦めします。</p>",
          "title": "スペアが必要な理由",
          "tooltip": "ヘルプはここをクリック"
        }
      }
    },
    "specifications": {
      "filter-response": {
        "message": "<p>このスライダを使用してフィルタ応答を選択します。応答の選択は部品点数 対 他の希望の特性の間でのトレードオフになります。　このツールは3つの応答のタイプを支援します:</p><p><table class=''fw-table''><tbody><tr><th>スライダー選択</th><th>フィルター応答</th><th>コメント</th></tr><tr><td>最小段数</td><td>チェビシェフ</td><td><p>これはパスバンドからストップバンド間の遷移域において、一番急峻な周波数応答を実現できます。そのため、より少ない段数、より少ない部品点数で実現できます。<p><p>このフィルターの欠点<ul><li>パスバンドのリップル</li><li>弱いステップ応答</li><li>部品のバリエーションに対して高感度</li></ul><p>チェビシェフ応答について詳しくは、<a href=''{siteURL}/MT-206'' target=''_blank''>MT-206</a>をご覧ください。</p></td></tr><tr><td>ミドルポジション</td><td>バタ－ワース</td><td><p>この応答は、部品点数とステップ応答や部品のばらつき感度のような他の特性の両方を考慮した場合良い妥協点になります。</p><p>バターワース応答は、しばしば、 \"最大限平坦型\" 応答と呼ばれています。なぜなら通過帯域と阻止帯域の間で最も急峻な変化を示しますがそれでもピーキングはないからです。</p><p>バターワース応答については詳しくは、<<a href=''{siteURL}/MT-224'' target=''_blank''>MT-224</a>をご覧ください。</p></td></tr><tr><td>右側中部</td><td>バターワースベッセル</td><td><p>バターワース・ベッセルフィルタはベッセルとバターワース応答の中間的なものです。そのため特性は、この2つのフィルタ応答が混在したような形になります。</p><p>スライダーを中央に動かすと、フィルタは、バターワース的な構成になります。さらに右側にスライダーを動かすと、フィルタはベッセルフィルタに近い構成になります。</p></td></tr><tr><td>セトリングが最も速い</td><td>ベッセル</td><td><p>ベッセルフィルタは、通過帯域と阻止帯域の間の変化が最も緩やかなので、最も多くの段数（すなわち最も多くの部品数）を必要とします。</p><p>しかし、さもなければそれは優れた特性を持ちます。</p><ul><li>大きなステップ応答</li><li>部品のばらつきに対して低感度</li></ul><p>もし阻止帯域の周波数と通過帯域の周波数が互いに近すぎるとベッセルフィルタ回路は困難になる可能性があります。</p><p>ベッセル応答について詳しくはMT-204をご覧ください<a href=''{siteURL}/MT-204'' target=''_blank''>MT-204 tutorial</a>.</p></td></tr></tbody></table></p>",
        "title": "フィルター応答",
        "tooltip": "ヘルプはここをクリック"
      },
      "passband": {
        "message": "<p>これは通過させたい周波数の範囲です。通過帯域周波数での回路ゲイン、周波数カットオフ、この周波数カットオフで希望する減衰を入力する事によりこの領域を定義してください。減衰は入力したゲインに関連します。たとえばゲインを20と入力し、減衰を-3dBと入力すると、ツールは通過帯域カットオフ周波数を17dBに設定しようとします.</p><p>フィルタ応答が \"Fewest Stages\"（チェビシェフ）の場合、通過帯域での希望するリップル量を入力できます。リップル仕様を大きくすると通過帯域から阻止帯域への変化が急峻になりますが、ステップ応答は悪くなり、部品のばらつきのフィルタへの影響も大きくなります。ローパス・フィルタとハイパス・フィルタに関して、フィルタの次数が奇数の場合、リップルは規定のゲインよりも下で生じます；フィルタ次数が偶数の時リップルは規定のゲインよりも上で生じます。同じ原則が通過帯域フィルタにも適用します；ただ　最初に次数を2で割ります.</p>",
        "title": "パスバンド",
        "tooltip": "ヘルプはここをクリック"
      },
      "stopband": {
        "message": "<p>これは除去したい周波数の範囲です。減衰は回路ゲインと関連があります。たとえばゲインを20dBにして、減衰を－35dBにすると、ツールは阻止帯域周波数を－15dBに設定しょうとします.</p>",
        "title": "ストップバンド",
        "tooltip": "ヘルプはここをクリック"
      }
    },
    "to-precision-warning": {
      "message": "ご使用ブラウザーが”Edge”のバージョン 15か16の可能性を検出しました。この場合、精度を指定する際に数値が不正確に表示され、誤った値が選択される可能性があります。このため、”Edge”のバージョン17以降か、別のブラウザーで本アプリケーションを使用することを推奨します。",
      "title": "特定ブラウザでの値表示異常の可能性があります。"
    }
  },
  "navbar": {
    "chinese": "简体中文",
    "english": "English",
    "feedback": "ご意見 ・ ご要望",
    "help": "ヘルプ",
    "japanese": "日本語",
    "load": "設計を読み込む",
    "next-tab": "次のタブ",
    "previous-tab": "前のタブ",
    "save": "保存",
    "videos": "ビデオ"
  },
  "opAmpSelection": {
    "innerRequirements": {
      "recommended-gbw-title": "お勧めするGBW： ",
      "required-gbw-title": "要求されるGBW： ",
      "requirement-title-one": "ステージ ",
      "requirement-title-two": " オペアンプの要件",
      "total-supply-voltage-title": "全体の供給電圧: "
    },
    "status": {
      "blank-opamp-name": "オペアンプ名が空欄です。",
      "channel-support": "フィルタ評価ボードはシングル・オペアンプとデュアル・オペアンプのみサポートします、",
      "components-out-of-range": "回路内のR、L、またはCが大き過ぎるか小さ過ぎる、",
      "current-feedback-unsupported": "電流帰還形オペアンプはサポートしていません。",
      "disabled": "使用不能",
      "gbw-low": "GBWの値が低すぎます",
      "gbw-too-low": "GBWの値が低すぎます。,",
      "ibias_high": "高いバイアス電流",
      "last-time-buy": "ラスト・タイム・バイ",
      "marginal": "非推奨",
      "not-allowed": "使用できません",
      "not-available-in-database": "データベースに存在していません。",
      "not-enough-negative-input-range": "不十分な負入力範囲、",
      "not-enough-negative-output-range": "不十分な負出力範囲、",
      "not-enough-positive-input-range": "不十分な正入力範囲、",
      "not-enough-positive-output-range": "十分な正出力範囲、",
      "not-recommended": "非推奨",
      "not-recommended-new-designs": "新規設計にお勧めしません。",
      "obsolete": "生産中止",
      "output-impedence-high": "出力インピーダンスが大きすぎる、",
      "package-incompatible": "評価ボードに対応していないパッケージ",
      "prerelease": "未発表",
      "quad-opamp": "評価ボードはクワッドオペアンプをサポートしていません、",
      "recommended": "推奨",
      "rout-high": "Rout ハイ",
      "row-count": "'{count, plural, =0 {{total}製品中#個のオペアンプを表示しています。フィルタを確認してください。} other {{total}製品中#個のオペアンプを表示しています。}}'",
      "slew-rate-low": "スルーレートの値が低すぎます、",
      "supply-voltage-high": "供給電圧の値が高すぎます。",
      "supply-voltage-low": "電源電圧が低すぎます",
      "under-min-stable-gain": "最小安定ゲイン＝ {value}",
      "under-min-stable-gain-no-cap": "最小安定ゲイン＝ {value} (補正用コンデンサが存在しないと仮定します。),"
    },
    "title": "オペアンプを選ぶ"
  },
  "page": {
    "description": "実際のオペアンプを使ったアクティブ・フィルタの設計が数分で行えます。",
    "title": "フィルタ・ウィザード | アナログ・デバイセズ"
  },
  "panel": {
    "display-context": {
      "center-frequency": "中心周波数",
      "compensate-gbw": "; GBW comp",
      "components": "最適化: {optimization}; +Vs: {vplus}; -Vs: {vminus}",
      "filter-type": {
        "bandPass": "バンドパス",
        "highPass": "ハイパス",
        "lowPass": "ローパス"
      },
      "frequency": "{value}Hz {signal}",
      "optimizations": {
        "noise": "ノイズ",
        "power": "電力",
        "specific-components": "特定部品",
        "voltage-range": "電圧範囲"
      },
      "passband-frequency": "パスバンド",
      "specifications": "{order} {implementation}",
      "stopband-frequency": "ストップバンド",
      "tolerances": "R: {rtolerance}; C: {ctolerance}",
      "tolerances-inductor": "L: {ltolerance}"
    },
    "view": "表示:"
  },
  "parameter-selector": {
    "choose-parameters": "パラメータを選ぶ",
    "ok": "OK"
  },
  "settings": {
    "components": {
      "change-op-amp": "オペアンプの変更",
      "choose-op-amp": "選択",
      "compensate-gbw": "GBWの補正",
      "component-sizing": "「部品のサイジング」",
      "components": "部品",
      "gain-resistors": "ゲイン抵抗",
      "gain-slider": "ゲインスライダ",
      "implementation": "組込み",
      "implementations": {
        "buffered-rc": "RC",
        "first-order": "初回注文",
        "gain": "ゲイン",
        "inductor": "インダクタ許容誤差",
        "multiple-feedback": "複数のフィードバック",
        "sallen-key": "サレンキー"
      },
      "negative-supply-voltage": "負電源電圧",
      "op-amp": "オペアンプ",
      "optimization": "設計回路を最適化する",
      "optimizations": {
        "low-noise": "低ノイズ",
        "low-power": "低電力",
        "specific-components": "特定部品",
        "voltage-range": "電圧範囲"
      },
      "pick-for-me": "推奨値",
      "positive-supply-voltage": "正電源電圧",
      "q-resistors": "Q値設定抵抗",
      "rc-sizing": "RC比率",
      "stage": "ステージ: {letter}",
      "stages": "Stages",
      "user-choice": "自分で選ぶ",
      "volt-unit": "V",
      "voltage-supplies": "オペアンプ電圧供給",
      "vs-minus": "-Vs :",
      "vs-plus": "+Vs :"
    },
    "filter-tab": {
      "bandPass": "バンドパス",
      "highPass": "ハイパス",
      "lowPass": "ローパス",
      "select-filter-type": "フィルタータイプをお選びください。"
    },
    "next-steps": {
      "all-files": "設計用ファイル",
      "all-files-tooltip": "SPICEファイル、BOM、評価ボードデザインファイル、PDFファイルのバージョン情報等が格納されたzipファイルをダウンロードする",
      "evaluation-board": "評価用ボ一ドを注文",
      "evaluation-board-tooltip": "ハードウェアの試作品用に評価ボードキットを注文する",
      "feedback": "ご意見 ・ ご要望",
      "get-files": "ファイル取得",
      "mail-colleague": "同僚にメールする(email)",
      "mail-colleague-tooltip": "同僚に送る",
      "order": "注文",
      "samples": "サンプル注文",
      "samples-tooltip": "構成部品のサンプルを注文",
      "send-design": "Send filter<br/>to {toolname}",
      "send-design-tooltip": "Sends a filter design to the calling application",
      "share": "共有",
      "spice-only": "SPICE ファイル",
      "spice-only-tooltip": "SPICEファイルを含んだzipファイルをダウンロード"
    },
    "specifications": {
      "center": "中心周波数",
      "db": "dB",
      "fastest-settling-0": "最速",
      "fastest-settling-1": "設定",
      "fewest-stages-0": "最少",
      "fewest-stages-1": "段",
      "filter-response": "フィルター応答",
      "gain": "ゲイン",
      "gain-units": {
        "db": "dB",
        "vv": "V/V"
      },
      "hz": "Hz",
      "passband": "パスバンド",
      "passband-attenuation": "パスバンドの減衰量",
      "passband-frequency": "パスバンドの周波数",
      "passband-gain-units": "パスバンドのゲインの単位",
      "stopband": "ストップバンド",
      "stopband-attenuation": "ストップバンドの減衰量",
      "stopband-frequency": "ストップバンドの周波数"
    },
    "tolerances": {
      "E12": "E12",
      "E24": "E24",
      "E48": "E48",
      "E6": "E6",
      "E96": "E96",
      "capacitor": "コンデンサ",
      "capacitor-series": "コンデンサの標準容量系列を使用",
      "capacitor-tolerance": "コンデンサ許容誤差",
      "component-tolerances": "部品の許容誤差",
      "five": "5%",
      "fiveTenths": "0.5%",
      "gbw-tolerance": "オペアンプ GBW許容誤差",
      "ideal": "ideal",
      "inductor": "インダクタ",
      "inductor-series": "インダクタの標準容量系列を使用",
      "inductor-tolerance": "インダクタ許容誤差",
      "one": "1%",
      "oneTenth": "0.1%",
      "op-amp-gbw": "Op Amp GBW",
      "preferred-series": "設定した系列",
      "resistor": "抵抗",
      "resistor-series": "抵抗の標準容量系列を使用",
      "resistor-tolerance": "抵抗許容誤差",
      "ten": "10%",
      "twenty": "20%"
    }
  },
  "units": {
    "ampere": "A",
    "db": "dB",
    "degree": "°",
    "hz": "Hz",
    "ohm": "Ω",
    "radian": "rad",
    "second": "s",
    "snd": "V/√Hz",
    "volt": "V",
    "vperus": "V/us",
    "vpp": "Vpp",
    "vrms": "Vrms",
    "vv": "V/V",
    "watt": "W"
  },
  "wizard": {
    "components": "部品選択",
    "filter-type": "タイプ",
    "next-steps": "次のステップ",
    "specifications": "仕様",
    "tolerances": "部品の公差"
  }
}], ["zh-cn", {
  "annotations": {
    "filterResponse": {
      "orders": {
        "order1": "一阶{responseType}",
        "order10": "十阶{responseType}",
        "order2": "二阶{responseType}",
        "order3": "三阶{responseType}",
        "order4": "四阶{responseType}",
        "order5": "五阶{responseType}",
        "order6": "六阶{responseType}",
        "order7": "七阶{responseType}",
        "order8": "八阶{responseType}",
        "order9": "九阶{responseType}",
        "orderN": "{order}阶{responseType}"
      },
      "responseType": {
        "Bessel": "贝塞尔",
        "Butterworth": "巴特沃兹",
        "Butterworth Bessel": "巴特沃兹-贝塞尔",
        "Chebyshev": "切比雪夫"
      },
      "responseValue": "{value} dB",
      "stages": "{count, plural, =1 {1 级} other {# 级数}}"
    },
    "magnitude": {
      "db-down": "{n} dB衰减",
      "gain": "增益 = {n} dB",
      "passband-region": "通带区间",
      "passband-ripple": "通带纹波 = {n} dB",
      "stopband-region": "阻带区间"
    }
  },
  "dialogs": {
    "algorithm-confirmation": {
      "decreasing-r2-advantages": "降低R2有以下优点",
      "decreasing-r2-advantages-item-1": "降低R2的电阻噪声。",
      "decreasing-r2-advantages-item-2": "通过R2降低电流噪声影响。",
      "decreasing-r2-advantages-item-3": "放大器输入电容影响性能的可能性较小。",
      "expand": "展开",
      "hide": "收起",
      "increasing-r1-advantages": "提高R1有以下优点",
      "increasing-r1-advantages-item-1": "源阻抗影响滤波器响应的可能性较小。",
      "increasing-r1-advantages-item-2": "高频下输入滤波器输入阻抗较高。",
      "increasing-r1-advantages-item-3": "高频下放大器输出负载较小。",
      "introduction": "2023年11月，我们更新了滤波器向导，采用不同的方法计算Sallen Key低通组件。所有其他滤波器级不受影响。这一变化会影响R2/R1比率较高的Sallen Key低通滤波级。高比率会对滤波器性能产生不利影响。我们在设法降低该比率值。改变算法对滤波器级关键规格（fp、Q值和增益）影响不大。对于某些优化考量，我们的算法会更好地利用滤波器级性能，因此可能会看到滤波器级顺序发生变化。",
      "new-algorithm-button": "使用新算法",
      "old-algorithm-button": "使用旧算法",
      "post-script-new-design": "您可能会看到R1、R2、C1和C2发生变化。所有其他组件将不受影响。所有新设计都将使用新方法。",
      "post-script-save-design": "对于已保存的设计，既可以继续使用旧算法，也可选择用新算法。如果更新为新算法，这些组件可能与您上次保存时不同。",
      "potential-drawbacks": "这一变化的潜在弊端",
      "potential-drawbacks-item-1": "使用旧算法时，C1/C2比率通常为10比较合适。",
      "potential-drawbacks-item-2": "噪声增益会略有增加。  我们认为降低R2噪声可以弥补这个缺点，利大于弊。",
      "potential-drawbacks-item-3": "对于增益>1时的单电源配置，减小R2需要中间电源驱动器具有较低的输出阻抗。  我们的AD8031电容驱动解决方案完全符合这一要求。",
      "pros-and-cons": "降低R2/R1比率的利弊-点击",
      "title": "上次保存后Sallen Key低通组件计算结果可能发生变化"
    },
    "common": {
      "cancel": "取消",
      "close": "关闭",
      "ok": "确定",
      "open": "打开",
      "save": "保存",
      "select": "选择"
    },
    "connect-to": {
      "message-error": "Connection to {tool} failed",
      "title-error": "Connection Error"
    },
    "evaluation-boards": {
      "eval-board-column": "需要评估板",
      "eval-board-flagged": "无法订购评估板",
      "eval-board-flagged-after-incompatibles": "如需订购评估板，请返回器件选项卡选择兼容的器件。",
      "eval-board-flagged-before-incompatibles": "在器件选择选项卡中，您选择的下列不推荐运算放大器与滤波器向导评估板系统不兼容:",
      "eval-board-flagged-multi-feedback": "在组件选择选项卡中，为一个或多个电路级选择多反馈级方案。多反馈电路级的评估子板尚未上市。",
      "eval-board-instruction": "在订单按钮打开的页面中，单击“立即购买”打开页面，您可以将商品放入购物车中。",
      "eval-board-multiple": "* 我们运送的每个子板箱中包含4个独立的模块，所以没有必要单独订购。",
      "eval-board-not-available-board": "不可用",
      "eval-board-parts-column": "焊接这些器件（单独订购器件）",
      "eval_board-flagged-inductor": "在组件选择选项卡中，为一个或多个电路级选择电感级方案。 电感电路级的评估子板尚未上市。",
      "evalboard-confirmation": {
        "cancel-button-text": "取消",
        "message": "抱歉。滤波器向导评估板系统不含相关子板，无法用于评估使用电感的级。",
        "proceed-button-text": "继续浏览评估板",
        "title": "对于评估板系统来说，频率过高"
      },
      "stage-column": "阶段",
      "stage-info": {
        "channel-dual": "-- 双通道运算放大器",
        "channel-none": "",
        "channel-single": "-- 单通道运算放大器",
        "implementation-buffered-rc": "缓冲RC",
        "implementation-deliyannis-friend": "Multiple Feedback (Deliyannis Friend)",
        "implementation-first-order": "一阶",
        "implementation-gain": "增益",
        "implementation-inductor": "电感",
        "implementation-multiple-feedback": "Multiple Feedback",
        "implementation-none": "",
        "implementation-sallen-key": "Sallen Key",
        "stage-text": "{stageType} {stageImplementation} 级 {stageChannel}",
        "stage-type-band-pass": "带通",
        "stage-type-band-stop": "带阻",
        "stage-type-gain": "增益",
        "stage-type-high-pass": "高通",
        "stage-type-low-pass": "低通",
        "stage-type-none": "",
        "stage-type-notch": "陷波"
      },
      "stage-info-column": "阶段信息",
      "table-title": "所需的评估板",
      "title": "订购评估板"
    },
    "feedback": {
      "email": "电子邮件：",
      "feedback": "你的反馈：",
      "feedback-dialog-ng-message": "您的反馈发送失败。可能是由于服务器的连接问题，请尝试再次发送。",
      "feedback-dialog-ok-message": "您的反馈已经发送。",
      "give-feedback": "给予反馈",
      "invitation": "请告诉我们你对这款工具的看法，任何好的或坏的。 ",
      "name": "姓名：",
      "optional": "(Optional)",
      "title": "提交您的意见或反馈！"
    },
    "load": {
      "choose-button": "选择文档",
      "invalid-file": "设计文件无效。请验证您尝试加载的设计文件的内容。",
      "invalid-parts": "{numParts,plural,other{如果不能加载设计，接下来的设计文件将不支持这个应用：}}{parts}",
      "message": "从计算机文件中加载设计",
      "no-opamps": "运算放大器数据不可用。无法加载设计。请尝试刷新浏览器。如果问题依然存在，请使用滤波器向导右上方的反馈按钮来报告该问题。",
      "title": "加载设计"
    },
    "opamp": {
      "table": {
        "architecture": "Architecture",
        "canOrderEvalBoard": "Eval Board?",
        "comment": "注释",
        "comments": "注释",
        "commentsDisplay": {
          "showAll": "显示全部",
          "showNotAllowed": "不允许",
          "showNotAllowedMatch": "不允许",
          "showNotRecommended": "不推荐使用",
          "showNotRecommendedMatch": "不推荐使用",
          "showRecommended": "推荐",
          "showRecommendedMatch": "推荐"
        },
        "feedbackMethod": "Feedback Method",
        "gbw": "GBW (Hz)",
        "iBias": "最大偏置电流(A)",
        "iNoise": "iNoise",
        "inHeadroomMinus": "输入负裕量(V)",
        "inHeadroomPlus": "输入正裕量(V)",
        "index": "Index",
        "isLTSpiceDisplay": {
          "showAll": "显示全部",
          "showNo": "否",
          "showYes": "是"
        },
        "isLTSpiceOpAmp": "LTspice？",
        "maxSupplyVoltage": "最大电源电压 (V)",
        "minStableGain": "Min Stable Gain",
        "minSupplyVoltage": "最小电源电压 (V)",
        "numberChannels": "通道数",
        "outHeadroomMinus": "输出负裕量(V)",
        "outHeadroomPlus": "输出正裕量(V)",
        "packageCode": "Package Code",
        "partNumber": "产品型号",
        "price": "价格（美元）",
        "rOut": "rOut",
        "rawGBW": "Raw GBW",
        "selectable": "Selectable?",
        "slewRate": "Slew Rate",
        "specialOpAmp": "Special Op-Amp?",
        "status": "Status Code",
        "statusDisplay": {
          "showAll": "显示全部",
          "showNotRecommended": "不推荐用于新设计",
          "showProduction": "量产",
          "showRecommended": "推荐用于新设计"
        },
        "statusText": "状态",
        "supplyCurrent": "电源电流(A)",
        "tempRange": "温度范围",
        "tempRangeDisplay": {
          "showAll": "显示全部",
          "showBlanks": "(空白)"
        },
        "vNoise": "噪声电压(nV/√Hz)",
        "vintage": "Vintage",
        "vos": "最大失调电压(V)"
      }
    },
    "samples": {
      "add-button": "添加所选样片至购物车",
      "add-to-cart-column": "样片加入购物车",
      "model-column": "元器件模型/封装",
      "part-column": "组成部分",
      "quantities-warning": "ADI公司向符合条件的客户免费限量提供样片。 出于客户对我们产品样片有大量需求，两周内，每款器件您只能申请2片，每份申请最多申请4款器件。 如果您的设计需要额外数量的产品，请在网站上通过在线购买或者联系我们的授权代理商购买。",
      "title": "申请样片",
      "unavailable-message": "无法申请样片"
    },
    "save": {
      "save-desc-error": "请提供描述",
      "save-desc-field": "介绍",
      "save-name-error": "请输入设计名称",
      "save-name-field": "设计名称",
      "title": "保存"
    },
    "send-filter": {
      "message": "You may now close this browser tab.",
      "message-error": "Sending design to {tool} was unsuccessful",
      "title-cancel": "{tool} has broken the connection",
      "title-error": "Send Design Error",
      "title-ok": "Filter Transfer to {tool} Complete"
    },
    "share": {
      "share-button": "Email",
      "share-design-information": "<p>若要共享您的设计副本，请在 <b>发件人名称</b> 字段中输入您的姓名。然后在 <b>共享设计</b> 字段中输入收件人的电子邮件地址。多个收件人的地址需分行填写。</p><p>收件人将收到ADI发出的电子邮件，内含包括共享设计ZIP存档的附件。您只需要从ZIP文件中提取设计并使用应用的“加载设计”功能上传。</p><p>本过程为每个收件人创建一份设计副本。收件人编辑他们的副本并不会影响您保存在您自己的电脑中的设计。</p>",
      "share-dialog-ng-message": "无法共享设计，这可能是因为服务器连接问题。请重试。",
      "share-dialog-ok-message": "已共享设计",
      "share-duplicate-email": "找到重复的电子邮件",
      "share-email-empty-error": "请输入电子邮件地址",
      "share-email-field": "收件人",
      "share-email-format-error": "您输入的电子邮件地址中有一个或多个无效，请更正后重试。",
      "share-email-placeholder": "电子邮件地址",
      "share-name-error": "请输入设计名称",
      "share-name-field": "设计名称",
      "share-sender-error": "请提交收件人姓名",
      "share-sender-field": "收件人姓名",
      "title": "通过邮件发送我的设计"
    },
    "system": {
      "application-busy": "处理中...",
      "connecting-to": "Connecting to {tool}...",
      "download-create-bom": "正在创建BOM文件...",
      "download-create-data": "正在创建数据文件...",
      "download-create-design": "正在创建设计文件...",
      "download-create-eval-board": "正在创建评估板文件...",
      "download-create-graph": "正在创建图形数据...",
      "download-create-pdf": "正在创建PDF文件...",
      "download-create-spice": "正在创建SPICE文件...",
      "download-downloading": "正在下载……",
      "download-requesting": "正在请求……",
      "error-opamp-data": "运算放大器数据不可用。滤波器向导无法继续运行。请保存您的设计，然后尝试刷新浏览器。如果问题依然存在，请使用滤波器向导右上方的反馈按钮来报告该问题。",
      "error-pst-data": "数据映射暂时不可用，因此无法显示运算放大器表。请保存您的设计，然后尝试刷新浏览器。如果问题依然存在，请使用滤波器向导右上方的反馈按钮来报告该问题。",
      "loading-opamp-data": "加载 OpAmp 数据...",
      "sending-filter": "Sending filter to {tool}...",
      "title": "应用消息"
    },
    "video": {
      "active_filter": {
        "title": "Filtering 101: Active Filter Stage Order",
        "url": "{basedir}/en/resources/media-center/videos/3637489700001.html"
      },
      "active_passive": {
        "title": "Filtering 101: Active vs. Passive",
        "url": "{basedir}/en/resources/media-center/videos/3637523715001.html"
      },
      "analog_digital": {
        "title": "Filtering 101: Analog vs. Digital",
        "url": "{basedir}/en/resources/media-center/videos/3637489722001.html"
      },
      "chebyshev_butterworth_bessel": {
        "title": "Filtering 101: Chebyshev vs. Butterworth vs. Bessel",
        "url": "{basedir}/en/resources/media-center/videos/3637489717001.html"
      },
      "gain_attenuation": {
        "title": "Sallen Key 101: Gain and Attenuation",
        "url": "{basedir}/en/resources/media-center/videos/3637489691001.html"
      },
      "heading": "点击下列链接，观看说明视频",
      "opamp_output_impedance": {
        "title": "Sallen Key 101: Effect of Op Amp Output Impedance",
        "url": "{basedir}/en/resources/media-center/videos/3637495042001.html"
      },
      "picking_components": {
        "title": "Sallen Key 101: Picking Components",
        "url": "{basedir}/en/resources/media-center/videos/3637437921001.html"
      },
      "quality_factor": {
        "title": "Filtering 101: Q - The Quality Factor of a Filter",
        "url": "{basedir}/en/resources/media-center/videos/3637489712001.html"
      },
      "sallenkey_feedback": {
        "title": "Filtering 101: Sallen Key vs. Multiple Feedback",
        "url": "{basedir}/en/resources/media-center/videos/3637489704001.html"
      },
      "subtitle": "Tutorial videos on Filter Design",
      "title": "视频"
    }
  },
  "download": {
    "error-message": "<p>无法获取设计文件。出现此错误的原因可能有：</p><p>1)与服务器的连接中断。</p><p>2)服务中断。</p>",
    "error-title": "下载",
    "file-content": {
      "no-schematic": "既然 LTspice 是ADI公司的一部分，我们可将SPICE网络列表转换为 LTspice 模型。设计中的运算放大器当前没有可用的 LTspice 模型。如果您希望ADI优先考虑针对特定器件生成 LTspice 模型，请告诉您的销售代表或通过此工具发送反馈。\r\n\r\n由您设计中的器件支持的SPICE仿真：\r\n",
      "no-schematic-no-netlist": "ADI当前正处于将运算放大器从SPICE网络列表转换为LTspice模型的过程。您的设计包含一系列器件，有些器件具有基于文本的网络列表，而另一些具有LTspice文件。为此，该工具无法生成任何SPICE输出。对于由此带来的不便，我们表示歉意并将努力解决此问题。如果您希望ADI优先考虑针对特定器件生成LTspice模型，请告诉您的销售代表或通过此工具发送反馈。\r\n\r\n由您设计中的器件支持的SPICE仿真：\r\n",
      "part-no-spice-info": "设计中的以下运算放大器没有LTspice模型或文本网络列表模型。如果您希望ADI优先考虑针对特定器件生成LTspice模型，请告诉您的销售代表或通过此工具发送反馈。"
    },
    "pdf-content": {
      "image-headers": {
        "circuit": "电路",
        "group-delay": "群延迟",
        "input-impedance-mag": "输入阻抗幅度",
        "input-impedance-phase": "输入阻抗相位",
        "magnitude-db": "幅度(dB)",
        "magnitude-vv": "幅度（按伏特计算）",
        "noise": "噪声",
        "phase-degrees": "相位（度）",
        "phase-delay": "相位延迟",
        "phase-radians": "相位（弧度）",
        "stages": "级数",
        "step-response": "阶跃响应"
      },
      "pdf-data-ie-image-missing": "很遗憾，若您使用IE 8或更低版本的IE浏览该工具，将无法生成图片。若您想要浏览页面上的图片，请使用Firefox、Chrome、IE 9或更高版本的IE浏览器。",
      "pdf-desc": "{desc}\n\n由{user}在{date}上创建",
      "pdf-desc-no-design-name": "由 {user}　创建于{date}",
      "pdf-desc-no-name-desc": "创建于{date}",
      "pdf-desc-no-user-name": "{desc}\n\n创建于 {date}",
      "pdf-heading": "滤波器设计向导",
      "pdf-orders": {
        "order1": "一阶",
        "order10": "十阶",
        "order11": "十一阶",
        "order12": "十二阶",
        "order2": "二阶",
        "order3": "三阶",
        "order4": "四阶",
        "order5": "五阶",
        "order6": "六阶",
        "order7": "七阶",
        "order8": "八阶",
        "order9": "九阶"
      },
      "pdf-subheading": "{filterType}、{nthOrder}{filterResponse}的滤波器要求",
      "pdf-tool-name": "滤波器设计向导"
    }
  },
  "ember-aditools-page": {
    "card": {
      "checkbox-tooltip": "Toggle",
      "help-tooltip": "Click for help",
      "part-number-tooltip": "Click to select part"
    },
    "common": {
      "cancel": "取消",
      "close": "关闭",
      "load": "加载",
      "ok": "确定",
      "open": "打开",
      "save": "保存",
      "select": "选择"
    },
    "dialogs": {
      "feedback": {
        "email": "电子邮件：",
        "feedback": "你的反馈：",
        "give-feedback": "给予反馈",
        "invitation": "请告诉我们你对这款工具的看法，任何好的或坏的。 ",
        "name": "姓名：",
        "optional": "(Optional)",
        "title": "提交您的意见或反馈！"
      },
      "load": {
        "choose-button": "选择文档",
        "message": "从计算机文件中加载设计",
        "no-file-selected": "No file selected.",
        "title": "加载设计"
      },
      "samples": {
        "add-button": "添加所选样片至购物车",
        "add-link": "Add to Order",
        "add-to-cart-column": "样片加入购物车",
        "model-column": "元器件模型/封装",
        "part-column": "组成部分",
        "quantities-warning": "ADI公司向符合条件的客户免费限量提供样片。 出于客户对我们产品样片有大量需求，两周内，每款器件您只能申请2片，每份申请最多申请4款器件。 如果您的设计需要额外数量的产品，请在网站上通过在线购买或者联系我们的授权代理商购买。",
        "title": "申请样片",
        "unavailable-message": "无法申请样片"
      },
      "save": {
        "save-desc-error": "请提供描述",
        "save-desc-field": "介绍",
        "save-name-error": "请输入设计名称",
        "save-name-field": "设计名称",
        "title": "保存"
      },
      "share": {
        "share-button": "Email",
        "share-design-information": "<p>若要共享您的设计副本，请在 <b>发件人名称</b> 字段中输入您的姓名。然后在 <b>共享设计</b> 字段中输入收件人的电子邮件地址。多个收件人的地址需分行填写。</p><p>收件人将收到ADI发出的电子邮件，内含包括共享设计ZIP存档的附件。您只需要从ZIP文件中提取设计并使用应用的“加载设计”功能上传。</p><p>本过程为每个收件人创建一份设计副本。收件人编辑他们的副本并不会影响您保存在您自己的电脑中的设计。</p>",
        "share-dialog-ng-message": "无法共享设计，这可能是因为服务器连接问题。请重试。",
        "share-dialog-ok-message": "已共享设计",
        "share-duplicate-email": "找到重复的电子邮件",
        "share-email-empty-error": "请输入电子邮件地址",
        "share-email-field": "收件人",
        "share-email-format-error": "您输入的电子邮件地址中有一个或多个无效，请更正后重试。",
        "share-email-placeholder": "电子邮件地址",
        "share-name-error": "请输入设计名称",
        "share-name-field": "设计名称",
        "share-sender-error": "请提交收件人姓名",
        "share-sender-field": "收件人姓名",
        "title": "通过邮件发送我的设计"
      },
      "system": {
        "application-busy": "处理中...",
        "title": "应用消息"
      }
    },
    "footer": {
      "accessibility": "可访问性",
      "cookie-settings": "Cookie设置",
      "copyright-text": "1995 - 2025 Analog Devices, Inc. 保留所有权利",
      "icp-id": "<a href=\"https://beian.miit.gov.cn/\">沪ICP备09046653号-1</a>",
      "legal": "法律与风险",
      "privacy-policy": "隐私政策",
      "privacy-settings": "隐私设置",
      "sitemap": "网站地图"
    },
    "header": {
      "applications": "应用",
      "company": "公司",
      "design-center": "设计中心",
      "education": "教育培训",
      "parametric-search": "参数搜索",
      "products": "产品",
      "spoken": {
        "homepage": "ADI主页",
        "sitelinks": "ADI网站链接"
      },
      "support": "支持"
    },
    "menubar": {
      "chinese": "简体中文",
      "english": "English",
      "help": "帮助",
      "japanese": "日本語",
      "load": "加载设计",
      "save": "保存"
    },
    "studio": {
      "adcdriver": "ADC驱动器",
      "dacebc": "DAC",
      "diamond": "仪表放大器",
      "filterwizard": "模拟滤波器",
      "noise": "噪声",
      "photodiode": "光电二极管",
      "precisionstudio": "ADI<span class=''service-mark''>℠</span> Precision Studio",
      "signalchaindesigner": "Signal Chain",
      "simdds": "DDS",
      "spoken": {
        "studiolinks": "ADI Precision Studio链接"
      },
      "virteval": "Virtual Eval"
    },
    "toolbar": {
      "actions": "Actions"
    }
  },
  "figures": {
    "billOfMaterials": {
      "bom-designator": "标识",
      "bom-material": "材料",
      "bom-package": "封装",
      "bom-quantity": "数量",
      "bom-text": "点击“获取文件”->下载Zip包中包含一张表格形式的物料清单。",
      "bom-text-italic": "若您创建自己的PCB而非采用ADI公司的评估板，则斜体字部分的元件可省略。",
      "bom-tolerance": "容差",
      "bom-value": "值",
      "extra-components": {
        "header": "表头",
        "jumper": "跳线",
        "sma-jack": "SMA插孔、插口式电路板边缘",
        "sma-male": "插入式-插入式SMA",
        "socket": "插座",
        "test-pin": "测试引脚"
      },
      "materials": {
        "tantalum": "钽"
      },
      "title": "物料清单",
      "x-axis": "",
      "y-axis": ""
    },
    "circuit": {
      "filter-type": {
        "band-pass": "带通",
        "high-pass": "高通",
        "low-pass": "低通"
      },
      "implementation": {
        "first-order": "缓冲RC",
        "gain": "增益",
        "inductor": "电感",
        "multiple-feedback": "Multiple Feedback",
        "sallen-key": "Sallen Key"
      },
      "order": {
        "eighth_order": "八阶",
        "fifth_order": "五阶",
        "first_order": "一阶",
        "fourth_order": "四阶",
        "nineth_order": "九阶",
        "second_order": "二阶",
        "seventh_order": "七阶",
        "sixth_order": "六阶",
        "tenth_order": "十阶",
        "third_order": "三阶"
      },
      "stage": "阶段 {letter}",
      "title": "电路",
      "x-axis": "",
      "y-axis": ""
    },
    "errors": {
      "adcBandwidthIsLessThanMinimum": "ADC带宽值（当前为{value}Hz）必须至少为{minimum}Hz",
      "centerFrequencyNotInRange": "中心频率必须介于{minimum}Hz和{maximum}Hz之间",
      "centerFrequencyTooHigh": "中心频率与通带频率之比过高。请降低中心频率或增加通带频率。",
      "centerFrequencyTooLow": "中心频率与通带频率之比过低。请增加中心频率或降低通带频率。",
      "emptyField": "{fieldId}字段不能为空。",
      "frequencyTooHigh": "无法找到实际元件值。 您的Q值可能太高。 在规格屏幕中使用级视图监控Q值。 您可以尝试： (1) 使用巴特沃兹或贝塞尔而非切比雪夫滤波器响应。 (2) 使用速度较低的通带-阻带转换。",
      "frequencyTooLow": "频率过低。无法找到元件值。",
      "gainNotInRange": "增益必须介于{minimum} {unit}和{maximum} {unit}之间",
      "highOrderFiltersUnsupported": "未找到阶数≤ 10的滤波器解决方案。降低通带频率或阻带衰减，增加阻带频率或通带衰减，或调整滤波器响应。",
      "invalidField": "无法解析字段{fieldId}中的值{value}。",
      "noOpAmpFoundForRequirements": "未发现能够满足需要的运算放大器。",
      "noOpAmpFoundForRequirementsWithVoltage": "未发现能够满足需要的运算放大器。将+Vs设置为5V、-Vs设置为0V或-5V，可能效果更佳。",
      "passbandAttenuationHighBandGreaterThan": "As the passband frequency approaches the maximum limit of {frequency}Hz, the passband attenuation becomes more restricted. At the stated passband frequency, the attenuation must be greater than {minimum} dB.",
      "passbandAttenuationLowGreaterThan": "As the passband frequency approaches the minimum limit of {frequency}Hz, the passband attenuation becomes more restricted. At the stated passband frequency, the attenuation must be greater than {minimum} dB.",
      "passbandAttenuationNotInRange": "通带衰减必须介于{minimum} dB和{maximum} dB之间",
      "passbandFrequencyNotInRange": "通带频率必须介于{minimum}Hz和{maximum}Hz之间",
      "passbandIsGreaterThanStopband": "通带频率（当前为{passbandFrequency}Hz）必须小于阻带频率{stopbandFrequency}Hz",
      "referenceVoltageSpanGreaterThanMax": "对于基准级中的AD8031，电源电压范围太宽。建议：(1)减小电源电压，(2)切换到双电源",
      "referenceVoltageSpanLessThanMinimum": "对于基准级中的AD8031，电源电压范围太窄。建议：(1)提高电源电压，(2)切换到双电源",
      "selectedOpAmpIsIdeal": "级{stage}：请选择此级的运算放大器。",
      "selectedOpAmpIsIncompatible": "级{stage}：{opAmp}无法满足滤波器要求。请选择不同的运算放大器或调整您的元件尺寸",
      "selectedOpAmpIsIncompatibleWithVoltage": "级{stage}：{opAmp}无法满足滤波器要求。请选择不同的运算放大器，调整您的元件尺寸或更改电压源。",
      "stageQTooLarge": "您指定的滤波器具有Q值为{qValue}。的级 滤波器设计向导仅支持Q值小于50的滤波器级。建议：(1) 降低中心频率、(2) 增加阻带和通带频率。",
      "stopbandAttenuationNotInRange": "阻带衰减必须介于{minimum} dB和{maximum} dB之间",
      "stopbandFrequencyNotInRange": "阻带频率必须介于{minimum}Hz和{maximum}Hz之间",
      "stopbandIsGreaterThanPassband": "阻带频率（当前为{stopbandFrequency}Hz）必须小于通带频率{passbandFrequency}Hz",
      "stopbandIsGreaterThanPassbandAttenuation": "阻带衰减（当前为{stopbandAttenuation} dB）必须比通带衰减{passbandAttenuation} dB深",
      "voltageSpanGreaterThanMax": "电源电压范围太宽。电源之间的电压差不应当超过36V",
      "voltageSpanLessThanMinimum": "电源电压范围太窄。电源之间的电压差应至少为1.8V",
      "vsMinusShouldBeNegative": "-Vs电压太高。其数值应当为0V或更低",
      "vsMinusZeroVsPlusGreaterThanMax": "当-Vs = 0时，+Vs电压必须低于12.6V。这是由于AD8031单电源基准电压驱动器的限制所致，其最大电源电压为12.6V。",
      "vsPlusShouldBePositive": "+Vs电压太低。其数值应当为0V或更高。"
    },
    "groupDelay": {
      "title": "相位延迟",
      "x-axis": "频率（Hz）",
      "x-hover": "频率:",
      "y-axis": "相位延迟(s)",
      "y-hover": "相位延迟:"
    },
    "inputImpedanceMagnitude": {
      "title": "输入阻抗(Ω)",
      "x-axis": "频率（Hz）",
      "x-hover": "频率:",
      "y-axis": "输入阻抗(Ω)",
      "y-hover": "输入阻抗:"
    },
    "inputImpedancePhase": {
      "title": "输入阻抗(°)",
      "x-axis": "频率（Hz）",
      "x-hover": "频率:",
      "y-axis": "输入阻抗(°)",
      "y-hover": "输入阻抗:"
    },
    "magnitudeDb": {
      "title": "幅度(dB)",
      "x-axis": "频率（Hz）",
      "x-hover": "频率:",
      "y-axis": "幅度(dB)",
      "y-hover": "幅度:"
    },
    "magnitudeVV": {
      "title": "幅度(V/V)",
      "x-axis": "频率（Hz）",
      "x-hover": "频率:",
      "y-axis": "幅度(V/V)",
      "y-hover": "幅度:"
    },
    "noise": {
      "adc-bandwidth": "ADC带宽",
      "adc-input-range": "ADC输入范围",
      "adc-range": "ADC范围",
      "adc-table-title": "ADC表",
      "enob-comp-sel": "等效位数",
      "enob-comp-tol": "等效位数",
      "enob-nominal": "标称",
      "enob-worst": "最差情况下的",
      "graph-title": "频谱噪声密度",
      "noise-referred-filter-output-1": "所有噪声均指滤波器输出。",
      "noise-referred-filter-output-2": "1/f噪声未建模。",
      "nominal-label": "标称值",
      "peak-to-peak-title": "峰峰值",
      "rms-peak-to-peak": "均方根和峰峰值",
      "rms-title": "有效值",
      "title": "噪声",
      "worst-case-label": "最差情况",
      "x-axis": "频率（Hz）",
      "x-hover": "频率:",
      "y-axis": "频谱噪声密度 (V/√Hz)",
      "y-hover": "噪声:"
    },
    "phaseDegrees": {
      "title": "相位(°)",
      "x-axis": "频率（Hz）",
      "x-hover": "频率:",
      "y-axis": "相位(°)",
      "y-hover": "相位:"
    },
    "phaseDelay": {
      "title": "相位延迟",
      "x-axis": "频率（Hz）",
      "x-hover": "频率:",
      "y-axis": "相位延迟(s)",
      "y-hover": "相位延迟:"
    },
    "phaseRadians": {
      "title": "相位(弧度)",
      "x-axis": "频率（Hz）",
      "x-hover": "频率:",
      "y-axis": "相位(弧度)",
      "y-hover": "相位:"
    },
    "power": {
      "header-text": "注意：本页显示滤波器的静态功耗输入信号可能会对功耗产生极大影响，这里未建模。",
      "order-with": {
        "order1": "一阶滤波",
        "order2": "二阶滤波"
      },
      "reference-stage-part-with": "AD8031采用",
      "reference-stage-text": "基准级",
      "reference-whats-this": "这是什么？",
      "title": "功率",
      "total-power": "总静态功耗",
      "x-axis": "",
      "y-axis": ""
    },
    "stages": {
      "filter-types": {
        "type-name-band-pass": "带通",
        "type-name-high-pass": "高通",
        "type-name-low-pass": "低通"
      },
      "header-text": "您的滤波器需要{n}具有如下特性的运算放大器级",
      "implementations": {
        "buffered-rc": "缓冲RC",
        "gain": "增益",
        "inductor": "电感",
        "multiple-feedback": "Multiple<br/>Feedback",
        "sallen-key": "Sallen Key"
      },
      "orders": {
        "first-order": "一阶",
        "second-order": "二阶"
      },
      "simulated": "仿真",
      "simulated-to": " 至 {value}",
      "target": "目标",
      "title": "级数",
      "tooltip": {
        "fp": "该级的极点频率。亦称为截止频率、自然频率或基频。",
        "gain": "增益(V/V)：+该级的增益",
        "q": "Q表示该级的峰值大小。数字越大表示极点频率附近的峰值越高。"
      },
      "x-axis": "",
      "y-axis": ""
    },
    "stepResponse": {
      "title": "阶跃响应",
      "x-axis": "时间(s)",
      "x-hover": "时间:",
      "y-axis": "幅度(V/V)",
      "y-hover": "幅度:"
    },
    "voltageRange": {
      "amp-input-range": "输入范围",
      "amp-output-range": "输出范围",
      "amplifier": "放大器",
      "amplifier_specs": "放大器规格",
      "input-range": "输入范围",
      "max-signals": "最大信号",
      "max-signals-nominal": "标称值",
      "max-signals-worst-case": "最差情况",
      "maximum-input": "最大输入",
      "output-range": "输出范围",
      "signal-possible": "可实现信号",
      "slew-rate": "压摆率",
      "title": "电压范围",
      "warning-input-range-voltage-range": "本级输入范围限制信号范围。",
      "warning-output-range-voltage-range": "本级输出范围限制信号范围。",
      "warning-slew-rate_voltage-range": "本级压摆率限制信号范围。",
      "x-axis": "",
      "y-axis": ""
    }
  },
  "footer": {
    "copyright": "© 1995 - 2018 Analog Devices, Inc. All Rights Reserved ",
    "privacy-security": "隐私和保密政策",
    "privacy-security-url": "/cn/about-adi/landing-pages/001/privacy_security_statement.html",
    "privacy-settings": "Privacy Settings",
    "privacy-settings-url": "/cn/landing-pages/001/privacy-settings.html",
    "sitemap": "网站地图",
    "sitemap-url": "/cn/sitemap.html",
    "terms-of-use": "使用条款",
    "terms-of-use-url": "/cn/about-adi/landing-pages/001/terms_of_use.html"
  },
  "fragments": {
    "at": "@",
    "eq": "=",
    "f": "f",
    "in": "IN",
    "left": "◄----",
    "n-a": "N/A",
    "out": "OUT",
    "p": "p",
    "plus": "+",
    "q": "Q",
    "r": "R",
    "ref": "REF",
    "right": "---►",
    "times": "×",
    "to": "to"
  },
  "header": {
    "applications": "应用",
    "community": "社区",
    "design-center": "设计中心",
    "education": "教育培训",
    "parametric-search": "参数搜索",
    "products": "产品",
    "support": "支持",
    "title": "滤波器设计向导"
  },
  "help": {
    "common": {
      "noise": {
        "adc-bandwidth": {
          "message": "<p>在此输入您ADC的带宽。该数值将与频谱密度曲线的噪声值一同纳入计算，得到均方根噪声和峰峰值噪声。</p><p>我们对整个ADC带宽范围的频谱密度曲线内的噪声进行积分，以计算均方根噪声以及峰峰值噪声。ADC用作滤波器，可降低您刚创建的运算放大器滤波器的输出噪声。   若您仔细查看频谱密度曲线，则最高频率处的频谱密度为非零值，并且实际使用中，该现象继续在高于本图所示的频率范围内存在。ADC可过滤此噪声。</p><p>我们假定ADC为一阶滚降。我们为ADC滚降建立了一阶幅度曲线，将其与频谱密度曲线相乘，然后对结果进行积分运算。若您的ADC具有更陡峭的滚降曲线（例如sinc^3 Σ-Δ型ADC）则该工具可能会略为高估总系统噪声。</p><p>某些ADC需要在放大器驱动器和ADC之间使用RC滤波器。若此RC滤波器带宽低于该ADC本身（或者您不知道该ADC的带宽），则应当使用此RC滤波器的截止频率。 RC滤波器的截止频率为：1/(2πRC)。</p>",
          "title": "ADC带宽",
          "tooltip": "点击查看帮助"
        }
      },
      "power": {
        "message": "<p>只要-Vs =0，滤波器工具就会增加一个基准级。此基准级产生一个中间电源电压轨，用作滤波器电路的基准电压.</p><p>基准级包括一个AD8031运算放大器，它驱动10 &mu;F电容。利用运算放大器直接驱动电容一般是一个非常糟糕的主意，但只要所驱动电容足够大，AD8031的架构就能确保这种配置保持稳定。该电路的优势在于，它在整个频谱内提供了一个低频源阻抗。由于滤波器电路可能流出和吸入可观的电流到基准电压源，因此低源阻抗基准源对于实现最佳滤波器性能至关重要。使用此基准电路时，请注意以下几点:</p><ul><li>使用AD8031。换上其它运算放大器会导致电路不稳定.</li><li>AD8031驱动的电容至少应为10 &mu;F。可以放置任意数量的旁路电容与此电容并联.</li><li>AD8031与电容之间不应放置电阻</li></ul><p>工具中显示基准电压通过一个直接与正电源轨相连的分压器获得。然而，此电压也可以从ADR4520或ADR3420等基准电压源IC产生。评估板考虑了这些基准源IC的尺寸，方便您使用.</p>",
        "title": "基准级",
        "tooltip": "点击查看帮助"
      },
      "voltage-range": {
        "message": "有源滤波器的输入电压范围以及相应的输出电压范围受限于运算放大器的非理想特性。 \"电压范围\"视图显示最大输入范围的计算结果，并以高亮显示哪个运算放大器规格造成了这种限制。 <ul><li>\"可能的最大输入信号\"是允许的最大输入电压——使用更大的输入信号将产生削波或失真。 </li><li>\"放大器规格\"部分显示每一级选定运算放大器的规格。  </li><li>\"最大信号\"部分显示确定最大允许输入电压的计算结果。 限制输入信号电压的运算放大器级和规格用一个警告标志来表示。 计算\"最大信号\"部分的其他数值，确保不超过参数限值——换言之，确保整个滤波器路径上没有削波或失真。 </li><li>\"元件容差\"选项卡给出了标称值和最差情况值。 标称值指的是原理图中元件的标称值。 最差情况计算的是容差范围内边界处的无源值，可能导致较大的增益传递函数，需进一步降低输入信号。 参见\"元件容差\"选项卡上的\"幅度\"曲线图，了解元件容差导致的增益传递函数不确定性。 </li></ul><p><b>压摆率限制 </b>如果一个运算放大器的压摆率限制了滤波器输入电压范围规格，则输入信号电压下降至这样一种水平，在该水平下的压摆速度不会超过运算放大器所能达到的速度。 更多信息，请参见小型指南<a href=''{siteURL}/MT-045'' target=\"_blank\">MT-045：运算放大器带宽和带宽平坦度</a>中的\"压摆率和全功率带宽\"部分。 </p><p><b>输出电压范围限制 </b>如果运算放大器的输出电压范围限制了滤波器输入电压范围规格，则输入信号电压下降至不会过驱运算放大器输出的水平。</p><p><b>输入电压范围限制 </b>如果运算放大器的输入电压范围限制了滤波器输入电压范围规格，则输入信号电压下降至不会过驱运算放大器输入的水平。 </p>",
        "title": "电压范围",
        "tooltip": "点击查看帮助"
      }
    },
    "comp-select": {
      "choosing-components": {
        "message": "<p>您已经在规格屏幕中选择了滤波器的理论性能，现在可以选择实际元件。当更改元件时，您可在电路视图中看到这些更改。如果您更改为其他视图，则可以查看元件选择是否影响滤波器性能。软件支持两种元件选择方式 </p><p>软件支持两种元件选择方式</p><p><b>方法1：让软件为您选择元件 </b> </p><p>在这种模式下，软件会为您选择运算放大器、电阻和电容。在此模式下，可以支持三种优化：</p><ul><li>电压范围：工具选择具有较宽的输入和输出范围的运算放大器。电阻和电容值一般介于“噪声”优化与“功耗”优化之间。</li><li>噪声：工具选择具有低频谱噪声密度的运算放大器，电压和电流噪声均要考虑。工具使用较小的电阻和较大的电容以降低电阻的噪声贡献。</li><li>功耗：工具选择具有低功耗的运算放大器。在此模式下，工具降低对滤波器的精度要求，允许使用具有较低增益带宽积的运算放大器，它们通常具有较低的功耗。工具使用较大的电阻和较小的电容以使功耗最低。</li></ul> <p><b>方法 2：自行选择元件  在此模式下</b> </p><p>软件在启动时使用在“为我选择”(Pick for me) 模式下使用的最新值。然后，您可以通过三种方式调整元件值：</p><ul><li>调整电阻-电容权衡关系：例如，您可以移动滑块，以获得更大的电阻和更小的电容。当您调整滑块时，RC 时间常数保持不变，因此滤波器的截止频率将与规格屏幕中选择的截止频率相匹配。</li><li>调整增益电阻：. 如果某个级具有增益电阻，则您可以调整增益电阻的绝对值。电阻之间的比率保持固定，以保持在规格屏幕中选择的增益。</li><li>选择不同的运算放大器：程序根据您在规格屏幕中输入的值，计算最低要求。您可以在我们的产品组合中选择满足这些最低要求的运算放大器。</li></ul> <p>您还可以通过抓取某一个级条，并将其移动至其他级的上方/下方，从而调整级顺序。级顺序通常不会影响幅度和相位性能，但可能对噪声和电压范围产生很大影响。  </p>",
        "title": "优化设计",
        "tooltip": "点击查看帮助"
      },
      "compensate-gbw": {
        "message": "<p>如果不勾选此控件，软件程序将假设运算放大器为理想器件，速度无限快，并据此计算电阻和电容值，就像滤波器教科书中所做的一样。实际的运算放大器并不是无限快，这一局限会影响滤波器响应。如果勾选此控件，程序将调整电阻和电容值以补偿运放有限增益带宽的影响，使得最终结果更接近预想的情况.</p><p>例如：假设滤波器级的截止频率应当为100 kHz，Q应当为1。然而，由于运放的增益带宽积有限，使用理论元件值得到的实际结果可能是95 KHz和1.1的Q。如果勾选该复选框，工具将选择反向偏移的电阻和电容值来进行补偿，例如所选值使得理想运放的截止频率为105 kHz，Q为0.9。这样，误差将抵消，所得结果将接近于理想响应.</p><p>一般而言，最好选择具有足够增益带宽的运算放大器，而不要依赖补偿方法。如果您使用“为我选择”模式以及“电压范围”或“低噪声”优化，则工具会尝试选择具有足够高的增益带宽、接近理想值的运算放大器，但又不会由于带宽过高而浪费大量功耗。因此，是否勾选“补偿 GBW”复选框并无多大区别。但是，在使用“功耗”优化时，勾选此复选框可以提高性能，因为此优化会降低运算放大器 GBW 要求以节省功耗。如果您使用“我要选择”模式，并且选择等于或低于建议 GBW 的运算放大器，则勾选此复选框也会有所帮助 </p><p>这种技术的局限性:</p><ul><li>该技术只补偿运算放大器的增益带宽积，而不补偿其输出电阻。如果您设计的是低通或带通滤波器，并且看到响应曲线在高频时上翘，那么这很有可能是输出电阻不理想的结果。输出电阻问题应通过如下方法来解决：选择增益带宽较高的运算放大器，选择具有标准（而非轨到轨）输出级的运算放大器，或者提高电路的电阻值.</li><li> 该技术不能消除运放增益带宽积中的所有误差. </li><li> 该技术不能解决高通滤波器在高频时的滚降问题.</li><li>程序使用一个相当简单的模型来获得运放的开环增益曲线。如果运放的实际性能与此模型有很大出入，那么这种增益带宽补偿可能不正确。结果应在SPICE和实验室中进行检查.</li><li>尤其是使用高Q电路时，补偿可能取决于电阻和电容元件的极小变化。利用\"元件容差\"屏幕可查看实际元件容差如何影响结果.</li></ul>",
        "title": "补偿GBW",
        "tooltip": "点击查看帮助"
      },
      "component-sizing": {
        "message": "<p>滤波器向导允许改变电阻与电容之比。较大的电阻会产生较高的噪声和偏置电流误差，但会降低运放输出电阻误差和功耗。如果可能，应使电容值低于0.1&mu;F，这样就可以使用C0G电容，而无需使用X7R电容。之所以优先选用C0G材料，是因为在一定的温度和电压下，其容值远比X7R型稳定. </p><p>某些滤波器架构同时具有正和负反馈路径。这种情况下，其中一个反馈路径将是电阻之比。利用本部分的第二个控件，可以调整此反馈路径中的绝对值（比例保持不变）</p>",
        "title": "元件大小",
        "tooltip": "点击查看帮助"
      },
      "implementation": {
        "message": "<p>滤波器向导目前支持实现下列电路：Sallen Key、Multiple Feedback和一阶。如果某种电路方案适合该滤波器级的阶数和类型，它就会列于此处.</p><p>有关 Sallen Key 应用的更多信息，请参见<a href=''{siteURL}/MT-222'' target=''_blank''>指南：MT-222。</a>相关 Sallen Key 应用与多重反馈实现的比较，请参见<a href=''{siteURL}/en/resources/media-center/videos/3637489704001.html'' target=''_blank''>滤波101：Sallen Key 与多重反馈</a>视频。</p>",
        "title": "实施",
        "tooltip": "点击查看帮助"
      },
      "noise": {
        "adc-table": {
          "message": "<p>此表显示ADC的有效位数。等效位数(ENOB)计算如下：</p><p>最大输入信号(rms) = ADC输入范围（峰峰值）/ 2√2</p><p>SNR = 20 * log （最大输入信号(rms) / 噪声(rms)）</p><p>ENOB = (SNR – 1.76) / 6.02</p>",
          "title": "ADC表",
          "tooltip": "点击查看帮助"
        }
      },
      "op-amp-selection": {
        "message": "<p>如果您不想使用工具选择的运算放大器，而要使用其它运算放大器，您可以在此处进行更改.</p> <p>工具将ADI运算放大器库分为三类:</p><ul><li>不允许：出于各种原因，工具不允许您选择某些运算放大器：运放不够快，无法实现滤波器；运放不适合评估板；运放不能在您指定的电源电压下工作；运放数据手册缺少工具需要的规格，等等</li><li>勉强能用：某些运算放大器速度够快，可以实现所选的滤波器，但存在一些误差。虽然不是最佳，您可能仍希望使用此类器件。例如，因为您的库存中有货，或者确实需要降低设计功耗。工具会提出警告，但允许您在设计中使用此类器件。对于这些运放，为了降低其所产生的误差，使用\"补偿GBW\"选项常常有效.</li><li>推荐使用：这些器件足够快，非常适合您的设计. </li></ul>",
        "title": "运算放大器",
        "tooltip": "点击查看帮助"
      },
      "op-amp-selection-help": {
        "message": "<p><b>这些运算放大器的要求意味着：</b></p><ul><li>总电源电压：采用元件中的“电压电源”部分。</li><li>推荐的GBW：具有此增益带宽或以上的运算放大器应具有滤波器级的良好性能。运算放大器必须满足运算放大器列表中成为“推荐”部分的最低GBW要求。</li><li>所需的GBW：增益带宽低于此阈值的运算放大器不可选。这是因为滤波器性能会很差，导致我们无法精确地模拟该性能。如果运算放大器的GBW介于推荐值和所需值之间，则fp和Q会受影响，但有些应用的性能可能仍足够好。</li></ul><p><b>如何计算GBW限制</b></p><p>滤波器设计的标准经验法则为最小GBW > 增益* Q * fp * 100。该经验法则非常简单且容易记住。然而，它通常给出的答案比必要情况更保守。换言之，通常可以使用比该公式推荐更慢的运算放大器，并获得完美的滤波结果。</p><p>遗憾的是，为得到更精确的答案，数学变得相当复杂。由于计算机可以很好地进行计算，因此我们在滤波器向导中使用该复杂数学来计算我们展示的数字。遗憾的是，这些公式较为混乱且不易理解。</p><p>如果想要了解运算放大器如何影响滤波器响应，Mac Van Valkenburg出色的“模拟滤波器设计”，很好地讨论了运算放大器有限放大器增益对总体滤波器响应的影响。他的公式旨在尽可能告知您发生的情况。本文会严重影响我们在滤波器向导中使用的公式。</p><p>在哪里划界也很主观。这实际上取决于您愿意承受多少误差。这就是为什么我们给出推荐的GBW（我们认为这是一个很好的下限）和所需的GBW（我们感到舒服的最低数值，我们的模拟会相当准确）的原因。最重要的是，我们实时模拟响应，这样便可立即看到运算放大器对滤波器性能的影响。我们推荐的GBW大致为初步数值，最终您须自行决定滤波器性能是否满足您的特定需求。我们尝试简单、快速地进行模拟以便快速尝试各种选项，并根据对您很重要的指标来评估结果。</p>",
        "title": "运算放大器的要求",
        "tooltip": "点击查看帮助"
      },
      "voltage-supplies": {
        "message": "<p>选择运算放大器的电压源。当选择“为我选择” 模式时，程序将使用这些电压来选择相应的运算放大器，当选择“我要选择”模式时，程序将缩小运算放大器选择范围。<p><p>如果您选择单电源电压(–Vs = 0)，工具会将一个值为中间电源的基准电压插入电路中。</p>",
        "title": "运算放大器电源",
        "tooltip": "点击查看帮助"
      }
    },
    "comp-tolerance": {
      "GBW": {
        "message": "<p>对于大多数运算放大器，器件之间的增益带宽差异通常为+/-20%。此控件让您能够查看此增益带宽差异的影响。除非运算放大器的速度刚好勉强满足设计需求，否则增益带宽积的差异对整体容差包络的影响很小。</p>",
        "title": "运放增益带宽积",
        "tooltip": "点击查看帮助"
      },
      "capacitor": {
        "message": "<p><b>电容 – 容差</b></p><p>该控制功能告诉程序使用何种范围的电容值来计算图上显示的容差包络。 </p><p>例如，假设上一页的滤波器计算得出理想电容值为1.12 μF。 让我们再假设将E6当作首选系列，这意味着该电容将向下取整为1 uF。 如果选择20%作为容差，则程序将使用1 μF +/-20%计算包络。 </p><p>由于1%电容值通常较难获取，该程序将1%电容限制在不超过4.7 nF。 较高的数值会将容差上推至5%。 </p><table class=\"fw-table\"><tr><th>电容容差</th><th> 容许范围</th></tr><tr><td>理想</td><td>10pF 至 10µF</td></tr><tr><td>1%</td><td>10pF 至 4.7nF</td></tr><tr><td>5%</td><td>10pF 至 10µF</td></tr><tr><td>10%</td><td>10pF 至 10µF</td></tr><tr><td>20%</td><td>10pF 至 10µF</td></tr></table><p>注意，电容通常是滤波器设计中精度最差的元件，一般建议购买容差较高的电容。 我们推荐选用C0G（亦称为NP0）陶瓷材质的5%或更好的电容。 </p>",
        "title": "电容",
        "tooltip": "点击查看帮助"
      },
      "inductor": {
        "message": "<p><b>电感 – 容差</b></p><p>该控制功能告诉程序使用何种范围的电感值来计算图上显示的容差包络。 </p><p>例如，假设上一页的滤波器计算得出理想电感值为1.12 nH。 让我们再假设将E6作为首选系列，这意味着该电感将取整为1 nH。 如果选择20%作为容差，则程序将使用1 nH +/-20%计算包络。 </p><table class=\"fw-table\"><tr><th>电容容差</th><th> 容许范围</th></tr><tr><td>理想</td><td>10nH 至 33µH</td></tr><tr><td>5%</td><td>10nH 至 33µH</td></tr><tr><td>10%</td><td>10nH 至 33µH</td></tr><tr><td>20%</td><td>10nH 至 33µH</td></tr></table><p>当您订购电路器件时，我们建议选择谐振频率至少是您低通滤波器通带频率或带通滤波器中心频率10倍的电感。 该限制条件可能会影响到您订购的电感容差。 </p>",
        "title": "容差",
        "tooltip": "点击查看帮助"
      },
      "noise": {
        "adc-table": {
          "message": "<p>此表显示ADC的有效位数。等效位数(ENOB)计算如下：</p><p>最大输入信号(rms) = ADC输入范围（峰峰值）/ 2√2</p><p>SNR = 20 * log （最大输入信号(rms) / 噪声(rms)）</p><p>ENOB = (SNR – 1.76) / 6.02</p><p>我们结合器件标称值和最差情况值计算该有效位数。器件容差越小，则这些数字彼此越接近。</p>",
          "title": "ADC表",
          "tooltip": "点击查看帮助"
        }
      },
      "pref-series-capacitor": {
        "message": "<p><b>电容 – 首选系列</b></p><p>滤波器向导程序可让您设置无源元件的首选系列： 元件的取整值。 </p><p>例如，假设上一页的滤波器计算得出理想电容值为1.12 uF。 下表显示根据首选系列，该值将在何处取整。 </p><table class=\"fw-table\"><tr><th>首选系列</th><th> 取整值</th></tr><tr><td>理想</td><td>1.12 uF</td></tr><tr><td>E24</td><td>1.1 uF</td></tr><tr><td>E12</td><td>1.2 uF</td></tr><tr><td>E6</td><td>1 uF</td></tr></table>",
        "title": "电容",
        "tooltip": "点击查看帮助"
      },
      "pref-series-inductor": {
        "message": "<p><b>电感 – 首选系列</b></p><p>滤波器向导程序可让您设置无源元件的首选系列： 元件的取整值。</p><p>例如，假设上一页的滤波器计算得出理想电感值为1.12 uH。 下表显示根据首选系列，该值将在何处取整。 </p><table class=\"fw-table\"><tr><th>首选系列</th><th> 取整值</th></tr><tr><td>理想</td><td>1.12 uH</td></tr><tr><td>E12</td><td>1.2 uH</td></tr><tr><td>E6</td><td>1 uH</td></tr></table><p>当您订购电路器件时，我们建议选择谐振频率至少是您低通滤波器通带频率或带通滤波器中心频率10倍的电感。 该限制条件可能会影响到您订购的电感容差。</p>",
        "title": "容差",
        "tooltip": "点击查看帮助"
      },
      "pref-series-resistor": {
        "message": "<p><b>电阻 – 首选系列</b></p><p>滤波器向导程序可让您设置无源元件的首选系列： 元件的取整值。</p><p>例如，假设上一页的滤波器计算得出理想电阻值为1.12 kΩ。 下表显示根据首选系列，该值将在何处取整。 </p><table class=\"fw-table\"><tr><th>首选系列</th><th> 取整值</th></tr><tr><td>理想</td><td>1.12 kΩ</td></tr><tr><td>E96</td><td>1.13 kΩ</td></tr><tr><td>E48</td><td>1.1 kΩ</td></tr><tr><td>E24</td><td>1.1 kΩ</td></tr><tr><td>E12</td><td>1.2 kΩ</td></tr><tr><td>E6</td><td>1 kΩ</td></tr></table>",
        "title": "电阻",
        "tooltip": "点击查看帮助"
      },
      "resistor": {
        "message": "<p><b>电阻 – 容差</b></p><p>该控制功能告诉程序使用何种范围的电阻值来计算图上显示的容差包络。</p><p>例如，假设上一页的滤波器计算得出理想电阻值为1.12 kΩ。 让我们再假设将E96作为首选系列，这意味着该电阻将向上取整为1.13 kΩ。 如果选择1%作为容差，则程序将使用1.13 kΩ +/-1%计算包络。 </p><p>由于0.1%和0.5%电阻值通常较难获取，该程序将这些电阻限制在10 Ω至1 MΩ内。 超出该范围的数值会将容差上推至1%。 </p><table class=\"fw-table\"><tr><th>电容容差 </th><th> 容许范围</th></tr><tr><td>理想</td><td>1Ω 至 10 MΩ</td></tr><tr><td>0.1%</td><td>10Ω 至 1 MΩ</td></tr><tr><td>0.5%</td><td>10Ω 至 1 MΩ</td></tr><tr><td>1%</td><td>1Ω 至 10 MΩ</td></tr><tr><td>5%</td><td>1Ω 至 10 MΩ</td></tr></table><p>设计滤波器时，建议使用25 ppm/°C薄膜电阻。 这通常能够获得精度和成本之间的良好折衷。 </p>",
        "title": "电阻",
        "tooltip": "点击查看帮助"
      },
      "step-response": {
        "why-no-envelope": {
          "message": "<p>本工具不计算阶跃响应视图的容差包络。精确计算阶跃响应包络需要多次迭代，每次计算都将花费较长时间。为了保留本工具的交互式本质，我们决定不集成这一功能。若阶跃响应的波动很大，则建议在SPICE中运行蒙特卡洛仿真</p><p>虽然不计算包络，但会根据滤波器的标称元件值计算标称阶跃响应。改变容差值时，标称值随之改变，你会发现阶跃响应图有一些移动。</p>",
          "title": "为什么没有包络？",
          "tooltip": "点击查看帮助"
        }
      }
    },
    "main": {
      "message": "<p class=''sub-help-header''>工具概览</p><p>使用模拟滤波器向导和实际运算放大器在几分钟内设计低通、高通或带通滤波器。 设计过程中，可以观察滤波器设计的理想规格与实际电路行为特性。 快速评估权衡运算放大器规格 – 包括增益带宽、噪声和电源电流 – 以确定满足您需求的最佳滤波器设计。 具有以下特性：</p><ul><li>滤波器响应滑块 – 在最少级数（切比雪夫）和最快速建立（贝塞尔）之间进行选择，并在（切比雪夫、巴特沃兹和巴特沃兹-贝塞尔）之间进行多次响应</li><li>通过滤波器向导选择运算放大器（针对低功耗、低噪声或电压范围进行优化），或使用“我想选择”功能手动选择运算放大器</li><li>“我想选择”部分提供Sallen Key和多路反馈拓扑结构</li><li>计算结果和曲线图包括非理想运算放大器特性和无源元件容差的影响。</li><li>使用<a href=''{siteURL}/cn/design-center/evaluation-hardware-and-software/evaluation-boards-kits/eval-fw.html'' target=''_blank''>滤波器向导评估系统完成原型设计</a></li><li>保存和分享设计，并下载设计文件包，具体包括设计报告、SPICE仿真文件、物料清单和评估PCB设计文件。</li></ul><p class =''sub-help-header''>具体项目帮助</p><p>有关具体项目帮助，请单击相关项目旁边的蓝色问号。</p>",
      "title": "滤波器向导帮助"
    },
    "next-steps": {
      "circuit": {
        "bypass-capacitor-title": "旁路电容",
        "eval-board-help": {
          "message": "<p>滤波器向导评估板系统由一个母版和数个子板组成。每个母版都提供4个子板插槽，每级使用一个子板。若设计需要的级多于4个，则多个母版可组合使用。母版还包括旁通电路和参考级（若必要）。</p><p>母版/子板系统可带来如下优势：</p><ul><li><b>快速改变级顺序。</b> 例如，使用多个不同类型的级权衡噪声性能与输入范围。</li><li><b>范围。</b> 滤波器向导评估板系统含有数个子板模型，支持不同类型的级。这些子板可在同一个设计中混合搭配。例如：某级可使用单运算放大器，而另一级则使用双封装运算放大器。或者，低通级与高通级搭配组成带通滤波器。</li><li><b>轻松测量单个级的性能。</b> 该设计可清楚表明级的开始与结束位置，单级可隔离调试。</li></ul><p>您可向ADI公司订购评估板裸片和运算放大器样片，其余器件应向经销商订购。</p><p>滤波器向导通过索引标识符的最后一个字母，标识每块板上的对应元件。   例如， A级元件将称为R1A、U1A等，B级元件将称为R1B、U1B等。母版元件将称为R1M、U1M等。   若您的设计含有多个同类子板，则建议标记您的子板，以便跟踪哪一块板用作A级、哪一块用作B级等。<p><div class=''opampNotValid-header-txt''>母版和子板照片</div><div class=''orderEvalBoardExplanationImage'' style=\"background: url(''images/mother-daughter-eval-board.jpg'') no-repeat scroll 0 0 transparent;height: 307px;margin-right: 200px;width: 416px;\"></div>",
          "title": "评估板系统说明",
          "tooltip": "点击查看帮助"
        },
        "opamp-spares-title": "备件",
        "whats-this": {
          "message": "<p>只要-Vs =0，滤波器工具就会增加一个基准级。此基准级产生一个中间电源电压轨，用作滤波器电路的基准电压.</p><p>基准级包括一个AD8031运算放大器，它驱动10 &mu;F电容。利用运算放大器直接驱动电容一般是一个非常糟糕的主意，但只要所驱动电容足够大，AD8031的架构就能确保这种配置保持稳定。该电路的优势在于，它在整个频谱内提供了一个低频源阻抗。由于滤波器电路可能流出和吸入可观的电流到基准电压源，因此低源阻抗基准源对于实现最佳滤波器性能至关重要。使用此基准电路时，请注意以下几点:</p><ul><li>使用AD8031。换上其它运算放大器会导致电路不稳定.</li><li>AD8031驱动的电容至少应为10 &mu;F。可以放置任意数量的旁路电容与此电容并联.</li><li>AD8031与电容之间不应放置电阻</li></ul><p>工具中显示基准电压通过一个直接与正电源轨相连的分压器获得。然而，此电压也可以从ADR4520或ADR3420等基准电压源IC产生。评估板考虑了这些基准源IC的尺寸，方便您使用.</p>",
          "title": "中间电源基准电压源",
          "tooltip": "点击查看帮助"
        },
        "whats-this-trigger": "这是什么？",
        "why-spares": {
          "message": "<p>使用双运算放大器时，滤波器向导将始终仅使用封装内两个运算放大器中的一个。未使用的运算放大器显示在备件部分。备件相连，以便尽可能降低功耗。</p><p>对于使用双运算放大器的多级滤波器，滤波器向导会“浪费”运算放大器；它不会试图将其中一个运算放大器用于某一级，而另一个用于另一级。我们采用下述方法使评估板系统易于使用：通过每一级保留一个IC，我们便可每一级都使用一个子卡，便于交换不同的子卡，观察性能差异。</p><p>当您进行量产电路布局时，我们建议利用封装内的每一个运算放大器。</p>",
          "title": "为何要有备件？",
          "tooltip": "点击查看帮助"
        }
      }
    },
    "specifications": {
      "filter-response": {
        "message": "<p>使用此滑块选择滤波器响应。选择一个折中考虑元件数与其它所需特性的响应。此工具支持三种响应类型：</p><p><table class=''fw-table''><tbody><tr><th>滚动条选择</th><th>滤波器响应</th><th>注释</th></tr><tr><td>最少级数</td><td>切比雪夫</td><td><p>此响应提供通带和阻带之间的最陡峭转换，因而需要最少级数（即最少元件）。<p><p>此滤波器的缺点是：<ul><li>通带中的纹波</li><li>阶跃响应较差</li><li>对元件变化的高敏感度</li></ul><p>有关切比雪夫响应的更多信息，请参阅指南<a href=''{siteURL}/MT-206'' target=''_blank''>MT-206</a>。</p></td></tr><tr><td>中间位置</td><td>巴特沃兹</td><td><p>此种响应达到了器件数量与其他特性（例如阶跃响应和器件容差灵敏度）之间的良好平衡</p><p>巴特沃兹响应通常称为“最平坦”响应，因为它提供通带和阻带之间的最陡峭转换，同时仍然避免峰化。</p><p>有关巴特沃兹响应的更多信息，请参阅指南<a href=''{siteURL}/MT-224'' target=''_blank''>MT-224</a></p></td></tr><tr><td>右中部</td><td>巴特沃兹-贝塞尔</td><td><p>巴特沃兹-贝塞尔滤波器是介于贝塞尔响应和巴特沃兹响应之间的过渡滤波器。它的性能兼具这两类响应的特点。</p><p>将滑块移动到中间，使其更像一个巴特沃兹滤波器。  将滑块向右移动，使其更像一个贝塞尔滤波器。</p></td></tr><tr><td>最快设置</td><td>贝塞尔</td><td><p>贝塞尔滤波器提供通带和阻带之间的最平缓转换，因而需要最多级数（即最多元件）。</p><p>但是，它还具有其他优良特性</p><ul><li>阶跃响应良好</li><li>对元件变化的低敏感度</li></ul><p>请注意，如果阻带和通带频率过于接近，则贝塞尔解决方案可能无法实现。</p><p>有关贝塞尔响应的更多信息，请参阅指南<a href=''{siteURL}/MT-204'' target=''_blank''>MT-204</a></p></td></tr></tbody></table></p>",
        "title": "滤波器响应",
        "tooltip": "点击查看帮助"
      },
      "passband": {
        "message": "<p>这是您希望让其通过的频率范围。要定义此区间，请在电路增益部分输入通带频率、截止频率，以及在该截止频率您需要多少衰减。衰减与输入的增益相关。例如，如果您输入20 dB的增益和-3 dB的衰减，工具就会尝试把通带截止频率设置在17 dB.</p><p>如果滤波器响应是 \"最少级数\"（切比雪夫），您就可以输入您希望通带中有多少纹波。纹波量越大，则从通带到阻带的转换越陡峭，但同时也会降低阶跃响应性能，并提高滤波器对元件变化的敏感度。对于低通和高通滤波器，如果滤波器阶数为奇数，纹波将出现在额定增益以下；如果阶数为偶数，纹波将出现在额定增益以上。带通滤波器同样如此，不过首先应将阶数除以2.</p>",
        "title": "通带",
        "tooltip": "点击查看帮助"
      },
      "stopband": {
        "message": "<p>这是您希望抑制的频率范围。衰减与电路增益相关。例如，如果您输入20 dB的增益和-35 dB的衰减，工具就会尝试把阻带频率设置在-15 dB.</p>",
        "title": "阻带",
        "tooltip": "点击查看帮助"
      }
    },
    "to-precision-warning": {
      "message": "我们检测到您使用的浏览器可能是边缘15或16，在指定精度时某些数字显示不准确。（第一个问题在边缘15中出现，并在边缘17中修复。）在某些情况下，差异可能高达50%。使用此应用和其他浏览器，将会获得更可靠的结果。",
      "title": "浏览器数字显示问题"
    }
  },
  "navbar": {
    "chinese": "简体中文",
    "english": "English",
    "feedback": "提交意见反馈",
    "help": "帮助",
    "japanese": "日本語",
    "load": "下载",
    "next-tab": "下一个选项卡",
    "previous-tab": "上一个选项卡",
    "save": "保存",
    "videos": "视频"
  },
  "opAmpSelection": {
    "innerRequirements": {
      "recommended-gbw-title": "推荐的GBW：",
      "required-gbw-title": "所需的GBW：",
      "requirement-title-one": "阶段 ",
      "requirement-title-two": " 运算放大器的要求",
      "total-supply-voltage-title": "总电源电压： "
    },
    "status": {
      "blank-opamp-name": "运算放大器名称为空",
      "channel-support": "滤波器评估板只支持单通道和双通道",
      "components-out-of-range": "电路中的R、L或C太大或太小。",
      "current-feedback-unsupported": "不支持电流反馈运算放大器，",
      "disabled": "禁用",
      "gbw-low": "gbw低,",
      "gbw-too-low": "GBW过低",
      "ibias_high": "高输偏置电流",
      "last-time-buy": "最后一次采购",
      "marginal": "勉强能用",
      "not-allowed": "不允许",
      "not-available-in-database": "在数据库中不可用：",
      "not-enough-negative-input-range": "负输入范围不足",
      "not-enough-negative-output-range": "负输出范围不足",
      "not-enough-positive-input-range": "正输入范围不足",
      "not-enough-positive-output-range": "正输出范围不足",
      "not-recommended": "不推荐使用",
      "not-recommended-new-designs": "新设计不推荐使用本产品",
      "obsolete": "停产",
      "output-impedence-high": "输出阻抗过高",
      "package-incompatible": "封装与评估板不兼容",
      "prerelease": "预发布",
      "quad-opamp": "评估板不支持四通道运算放大器",
      "recommended": "推荐",
      "rout-high": "高速信号路由",
      "row-count": "'{count, plural, =0 {显示#/{total}个运算放大器。请检查提供的滤波器。} other {显示#/{total}个运算放大器。}}'",
      "slew-rate-low": "压摆率过低",
      "supply-voltage-high": "电源电压过高",
      "supply-voltage-low": "电源电压过低",
      "under-min-stable-gain": "最小稳定增益 = {value}",
      "under-min-stable-gain-no-cap": "最小稳定增益 = {value} (假设不存在COMP电容)"
    },
    "title": "选择运算放大器"
  },
  "page": {
    "description": "在几分钟内设计集成实际运算放大器的有源滤波器",
    "title": "滤波器设计向导 | 亚德诺半导体"
  },
  "panel": {
    "display-context": {
      "center-frequency": "中心频率",
      "compensate-gbw": "; GBW补偿",
      "components": "优化目标: {optimization}; +Vs: {vplus}; -Vs: {vminus}",
      "filter-type": {
        "bandPass": "带通",
        "highPass": "高通",
        "lowPass": "低通"
      },
      "frequency": "{value}Hz {signal}",
      "optimizations": {
        "noise": "噪声",
        "power": "电源",
        "specific-components": "特定元件",
        "voltage-range": "电压范围"
      },
      "passband-frequency": "通带",
      "specifications": "{order} {implementation}",
      "stopband-frequency": "阻带",
      "tolerances": "R: {rtolerance}; C: {ctolerance}",
      "tolerances-inductor": "L: {ltolerance}"
    },
    "view": "查看:"
  },
  "parameter-selector": {
    "choose-parameters": "选择参数",
    "ok": "OK"
  },
  "settings": {
    "components": {
      "change-op-amp": "更改运算放大器",
      "choose-op-amp": "选择",
      "compensate-gbw": "补偿GBW",
      "component-sizing": "元件大小",
      "components": "元件",
      "gain-resistors": "增益电阻",
      "gain-slider": "增益滑块",
      "implementation": "实施",
      "implementations": {
        "buffered-rc": "缓冲RC",
        "first-order": "一阶r",
        "gain": "增益",
        "inductor": "电感",
        "multiple-feedback": "Multiple Feedback",
        "sallen-key": "Sallen Key"
      },
      "negative-supply-voltage": "负电源电压",
      "op-amp": "运算放大器",
      "optimization": "优化",
      "optimizations": {
        "low-noise": "低噪声",
        "low-power": "低功耗",
        "specific-components": "特定元件",
        "voltage-range": "电压范围"
      },
      "pick-for-me": "为我选择",
      "positive-supply-voltage": "正电源电压",
      "q-resistors": "Q 电阻",
      "rc-sizing": "RC尺寸调整",
      "stage": "阶段: {letter}",
      "stages": "Stages",
      "user-choice": "我想选择",
      "volt-unit": "V",
      "voltage-supplies": "运算放大器电源",
      "vs-minus": "-Vs",
      "vs-plus": "+Vs"
    },
    "filter-tab": {
      "bandPass": "带通",
      "highPass": "高通",
      "lowPass": "低通",
      "select-filter-type": "选择滤波器类型"
    },
    "next-steps": {
      "all-files": "获取设计",
      "all-files-tooltip": "下载包含SPICE文件、BOM、评估板文件、和pdf版视图的zip文件",
      "evaluation-board": "订购评估板",
      "evaluation-board-tooltip": "订购评估板套件以构建硬件原型",
      "feedback": "提交意见反馈",
      "get-files": "获取文件",
      "mail-colleague": "邮件分享给同事",
      "mail-colleague-tooltip": "将此设计的副本发送给同事",
      "order": "订购",
      "samples": "申请样片",
      "samples-tooltip": "申请器件样片",
      "send-design": "Send filter<br/>to {toolname}",
      "send-design-tooltip": "Sends a filter design to the calling application",
      "share": "共享",
      "spice-only": "仅SPICE",
      "spice-only-tooltip": "下载包含SPICE文件的zip文件"
    },
    "specifications": {
      "center": "中心频率",
      "db": "dB",
      "fastest-settling-0": "最快",
      "fastest-settling-1": "建立",
      "fewest-stages-0": "最少",
      "fewest-stages-1": "级数",
      "filter-response": "滤波器响应",
      "gain": "增益",
      "gain-units": {
        "db": "dB",
        "vv": "V/V"
      },
      "hz": "Hz",
      "passband": "通带",
      "passband-attenuation": "通带衰减",
      "passband-frequency": "通带频率",
      "passband-gain-units": "通带增益单元",
      "stopband": "阻带",
      "stopband-attenuation": "阻带衰减",
      "stopband-frequency": "阻带频率"
    },
    "tolerances": {
      "E12": "E12",
      "E24": "E24",
      "E48": "E48",
      "E6": "E6",
      "E96": "E96",
      "capacitor": "电容",
      "capacitor-series": "电容首选系列",
      "capacitor-tolerance": "电容容差",
      "component-tolerances": "元件容差",
      "five": "5%",
      "fiveTenths": "0.5%",
      "gbw-tolerance": "运算放大器GBW容差",
      "ideal": "理想",
      "inductor": "容差",
      "inductor-series": "电感首选系列",
      "inductor-tolerance": "电感容差",
      "one": "1%",
      "oneTenth": "0.1%",
      "op-amp-gbw": "运放增益带宽积",
      "preferred-series": "首选系列",
      "resistor": "电阻",
      "resistor-series": "电阻首选系列",
      "resistor-tolerance": "电阻容差",
      "ten": "10%",
      "twenty": "20%"
    }
  },
  "units": {
    "ampere": "A",
    "db": "dB",
    "degree": "°",
    "hz": "Hz",
    "ohm": "Ω",
    "radian": "弧度",
    "second": "s",
    "snd": "V/√Hz",
    "volt": "V",
    "vperus": "V/us",
    "vpp": "Vpp",
    "vrms": "Vrms",
    "vv": "V/V",
    "watt": "W"
  },
  "wizard": {
    "components": "元件选择",
    "filter-type": "类型",
    "next-steps": "后续步骤",
    "specifications": "详细规格",
    "tolerances": "元件容差"
  }
}]];